window.products = [
  {
    "sku": "PB12FS-GM",
    "title": "AGS Arlec Gaming Series 12 Outlet Power Board Foot Switched RGB Light Premium Surge Protected",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_AGS_Gaming_12_Outlet_Premium_Surge_Powerboard_with_Master_Foot_Switch_PB12FS-GM_1.jpg?v=1762757269"
  },
  {
    "sku": "PB2PD30-GM",
    "title": "AGS Arlec Gaming Series 2 Outlet Power Board 30W PD Fast Charge Premium Surge Protected",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_AGS_Gaming_2_Outlet_Portable_PD30W_Fast_Charging_Powerboard_PB2PD30-GM.jpg?v=1762757261"
  },
  {
    "sku": "PB44LS-GM",
    "title": "AGS Arlec Gaming Series 4 Outlet Power Board Individually Switched RGB Light Premium Surge Protected",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_AGS_Gaming_4_Outlet_Individually_Switched_Premium_Surge_Powerboard_PB44LS-GM_1.jpg?v=1762757276"
  },
  {
    "sku": "BA-9V",
    "title": "Alkaline Battery - 2 X 9V",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALKALINE_BATTERY_-_9V_BA-9V.jpg?v=1762755260"
  },
  {
    "sku": "BA-9V2",
    "title": "Alkaline Battery - 2 X 9V2",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALKALINE_BATTERY_-_2_X_9V_BA-9V2.jpg?v=1762755270"
  },
  {
    "sku": "BBA-4AAA",
    "title": "Alkaline Battery - 4 X AAA",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_AAA_Alkaline_Batteries_-_4_Pack_BBA-4AAA.jpg?v=1762755321"
  },
  {
    "sku": "BA-12AA",
    "title": "Alkaline Battery - BA-12AA",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALKALINE_BATTERY_-_12_X_AA_BA-12AA.jpg?v=1762755280"
  },
  {
    "sku": "BA-16AAA",
    "title": "Alkaline Battery - BA-16AAA",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_AAA_Alkaline_Battery_-_16Pk_BA-16AAA.jpg?v=1762755299"
  },
  {
    "sku": "BA-24AA",
    "title": "Alkaline Battery - BA-24AA",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_AA_Alkaline_Battery_-_24Pk_BA-24AA.jpg?v=1762831126"
  },
  {
    "sku": "BBA-4AA",
    "title": "Alkaline Battery - BBA-4AA",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/BBA-4AA.jpg?v=1762757293"
  },
  {
    "sku": "BEDL5-RW",
    "title": "Arlec  Rain Wished 5m Ordinary Duty Braided Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/BEDL5-RW_3.png?v=1784799000"
  },
  {
    "sku": "LVX793",
    "title": "Arlec 1.2m 175 Multicolour LED Candy Cane Statue",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX793_CPIN007283OL.pdf?v=1754379033",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1.2m_175_Multicolour_LED_Candy_Cane_Statue_LVX793.jpg?v=1762830398"
  },
  {
    "sku": "LVX558",
    "title": "Arlec 1.2m 180 LEDs Large Wreath",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX558_CPIN006642_OL.pdf?v=1754379033",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1.2m_180_LEDs_Large_Wreath_LVX558.jpg?v=1762753197"
  },
  {
    "sku": "LVX1801",
    "title": "Arlec 1.2m Inflatable PVC Bauble Multicolour Lines",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1801_CPIN006783_OL.pdf?v=1754379022",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1.2m_Inflatable_PVC_Bauble_Multicolour_Lines_LVX1801.jpg?v=1762753072"
  },
  {
    "sku": "LVX1800",
    "title": "Arlec 1.2m Inflatable PVC Champagne Bauble",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1800_CPIN006783_OL.pdf?v=1754379022",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1.2m_Inflatable_PVC_Champagne_Bauble_LVX1800.jpg?v=1762753042"
  },
  {
    "sku": "LVX970",
    "title": "Arlec 1.2m Low Voltage LED Corgi Inflatable",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX970_LVX971_CPIN006606_OL.pdf?v=1754379028",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1.2m_Low_Voltage_LED_Inflatable_Corgi_LVX970.jpg?v=1762829983"
  },
  {
    "sku": "LVE611",
    "title": "Arlec 1.2m Pumpkin Halloween Inflatable",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE611_HalloweenInflatables_CPIN006686_OL.pdf?v=1754378975",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1.2m_Pumpkin_Halloween_Inflatable_LVE611.jpg?v=1762753174"
  },
  {
    "sku": "LVE610",
    "title": "Arlec 1.2m White Ghost Halloween Inflatable",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE610_HalloweenInflatables_CPIN006686_OL.pdf?v=1754378978",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1.2m_White_Ghost_Halloween_Inflatable_LVE610.jpg?v=1762753132"
  },
  {
    "sku": "LVE613",
    "title": "Arlec 1.2m x 0.8m Pumpkin Halloween Inflatable",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE613_HalloweenInflatables_CPIN006686_OL.pdf?v=1754378977",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1.2m_Pumpkin_Halloween_Inflatable_LVE613.jpg?v=1762753691"
  },
  {
    "sku": "LVX310",
    "title": "Arlec 1.4m Red & White Wooden Beads LED String Lights",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX310_CPIN007271OL.pdf?v=1754379037",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1.4M_Red___White_Wooden_Beads_LED_String_Lights_LVX310_1.jpg?v=1762830351"
  },
  {
    "sku": "LVX1772",
    "title": "Arlec 1.5m Battery Powered Ribbon Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1772_CPIN007824_OL.pdf?v=1754379029",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1.5m_Battery_Powered_Ribbon_Light_LVX1772_1.jpg?v=1762829652"
  },
  {
    "sku": "LVX1869",
    "title": "Arlec 1.5m Inflatable Santa on Motorcycle",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1869.jpg?v=1765439933"
  },
  {
    "sku": "LVX1834",
    "title": "Arlec 1.5m Low Voltage LED Schnauzer Inflatable",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1834_CPIN007263OL.pdf?v=1754379040",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Low_Voltage_1.5m_LED_Inflatable_Schnauzer_LVX1834.png?v=1762829944"
  },
  {
    "sku": "LVX1868",
    "title": "Arlec 1.67m Inflatable Rotating Santa in Helicopter",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1868.jpg?v=1765270990"
  },
  {
    "sku": "LVX311",
    "title": "Arlec 1.7m Green & White Wooden Beads Led String Lights",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX311_CPIN007272OL.pdf?v=1754379037",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1.7m_Green___White_Wooden_Beads_Led_String_Lights_LVX311.jpg?v=1762830341"
  },
  {
    "sku": "LVX1838",
    "title": "Arlec 1.7m Low Voltage LED Santa\'s Safari Inflatable",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1838_CPIN007842_OL.pdf?v=1754379028",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1.7m_Low_Voltage_LED_Inflatable_Santa_s_Safari_LVX1838.jpg?v=1762829954"
  },
  {
    "sku": "LVE616",
    "title": "Arlec 1.8m 3 Ghosts Halloween Inflatable",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE616_HalloweenInflatables_CPIN006686_OL.pdf?v=1754378978",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1.8m_3_Ghosts_Halloween_Inflatable_LVE616_1_2.jpg?v=1762753230"
  },
  {
    "sku": "LVE612",
    "title": "Arlec 1.8m 4 Pumpkin Halloween Inflatable",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE612_HalloweenInflatables_CPIN006686_OL.pdf?v=1754378976",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1.8m_4_Pumpkin_Halloween_Inflatable_LVE612.jpg?v=1762753182"
  },
  {
    "sku": "LVX839",
    "title": "Arlec 1.8m Inflatable Colourful Christmas Baubles Low Voltage",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX839_CPIN006123-2OL.pdf?v=1754379026",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1.8m_Inflatable_Colourful_Christmas_Baubles_Low_Voltage_LVX839.jpg?v=1762753081"
  },
  {
    "sku": "LVX31",
    "title": "Arlec 1.8m Inflatable Low Voltage Christmas Tree",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX31_CPIN006784_OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Green___White_Wooden_Beads_Led_String_Lights_LVX311.jpg?v=1762753022"
  },
  {
    "sku": "LVX1867",
    "title": "Arlec 1.8m Inflatable Rotating Gingerbread House",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1867.jpg?v=1765269554"
  },
  {
    "sku": "LVX1836",
    "title": "Arlec 1.8m Low Voltage Inflatable Santa",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1836_CPIN007265_OL.pdf?v=1754379039",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1.8m_Low_Voltage_Inflatable_Santa_LVX1836_7.jpg?v=1762829969"
  },
  {
    "sku": "LVX1835",
    "title": "Arlec 1.8m Low Voltage Inflatable White Bear",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1835CPIN007264OL.pdf?v=1754379039",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Low_Voltage_1.8m_Inflatable_White_Bear_LVX1835.jpg?v=1762829908"
  },
  {
    "sku": "LVE615",
    "title": "Arlec 1.8m Pumpkin and 3 Ghosts Halloween Inflatable",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE615_HalloweenInflatables_CPIN006686_OL.pdf?v=1754378977",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1.8m_Pumpkin_and_3_Ghosts_Halloween_Inflatable_LVE615.jpg?v=1762753122"
  },
  {
    "sku": "LVE617",
    "title": "Arlec 1.8m Pumpkin and Ghost Halloween Inflatable",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/HalloweenInflatables_CPIN006686_93766b2a-74e0-4528-a7c9-2ad54c088140.pdf?v=1754454261",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1.8m_Pumpkin_and_Ghost_Halloween_Inflatable_LVE617.jpg?v=1762753113"
  },
  {
    "sku": "LVX1851",
    "title": "Arlec 1.9m 180 LED Low Voltage Pop-Up Christmas Tree",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1851.jpg?v=1765336534"
  },
  {
    "sku": "ALMR005",
    "title": "Arlec 10 Bulb LED CCT Dimmable Mirror Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALMR005.png?v=1779883930"
  },
  {
    "sku": "LVG106HA",
    "title": "Arlec 10 Pack Smart LED Path Lights",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVG106HACPIN006912OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "LVA010",
    "title": "Arlec 100 Entertainment Light Multi Purpose Clips",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_100_Entertainment_Light_Multi_Purpose_Clips_LVA010.jpg?v=1762753223"
  },
  {
    "sku": "OCH205",
    "title": "Arlec 1000W 5 Fin Oil Column Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/OCH205CPIN005076_4OL.pdf?v=1754379041",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1000W_5_Fin_Oil_Column_Heater_OCH205.jpg?v=1762756786"
  },
  {
    "sku": "PEH140",
    "title": "Arlec 1000W Convection Panel Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PEH140_CPIN004386.pdf?v=1754379038",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1000W_Convection_Panel_Heater_PEH140.jpg?v=1762831854"
  },
  {
    "sku": "PEH131",
    "title": "Arlec 1000W Convection Panel Heater with Digital Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PEH131_CPIN005083_2.pdf?v=1754379037",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1000W_Convection_Panel_Heater_PEH131.jpg?v=1762832140"
  },
  {
    "sku": "REH101",
    "title": "Arlec 1000W Radiant Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/REH101CPIN005761.pdf?v=1754379096",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1000W_Radiant_Heater_REH101.jpg?v=1762831968"
  },
  {
    "sku": "TH0039",
    "title": "Arlec 100W Stainless Steel 9 Bar Heated Towel Rail",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/TH0039_CPIN003142-5.pdf?v=1754379098",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_100W_Stainless_Steel_9_Bar_Heated_Towel_Rail_TH0039.jpg?v=1762757000"
  },
  {
    "sku": "LV1602",
    "title": "Arlec 10m Blue Thin LED Rope Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV1600_LV1601_LV1602_CPIN004417-3_OL.pdf?v=1754378978",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_50m_Coloured_LED_Rope_Light_LV1602.jpg?v=1762829801"
  },
  {
    "sku": "LVE189",
    "title": "Arlec 10m Coloured Solar Powered Thin LED Rope Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE189.pdf?v=1784007751",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE189.jpg?v=1765275996"
  },
  {
    "sku": "LV1570",
    "title": "Arlec 10m Cool White LED Festive Solar Rope Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV1570_CPIN003350-7_OL.pdf?v=1754378978",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_10m_Cool_White_LED_Festive_Solar_Rope_Light_LV1570.jpg?v=1762829607"
  },
  {
    "sku": "LVE190",
    "title": "Arlec 10m Cool White Solar Powered Thin LED Rope Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE188_LVE189_LVE190_CPIN004583_7_OL.pdf?v=1783936822",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE190.jpg?v=1783936065"
  },
  {
    "sku": "ALD990",
    "title": "Arlec 10m Dotless CCT COB Strip Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD990.png?v=1781244753"
  },
  {
    "sku": "LV1411",
    "title": "Arlec 10m Festive LED Light Rope",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV1410LV1411CPIN003349-5_OL.pdf?v=1754454197",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_10m_Festive_LED_Light_Rope_LV1411.jpg?v=1762829054"
  },
  {
    "sku": "YEL10-HWOB",
    "title": "Arlec 10m Halloween Orange+Black Heavy Duty Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/YEL10-HWOB.png?v=1785128311"
  },
  {
    "sku": "YEL10-HWPB",
    "title": "Arlec 10m Halloween Purple+Black Heavy Duty Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/YEL10-HWPB.png?v=1785128206"
  },
  {
    "sku": "YEL10-HWPG",
    "title": "Arlec 10m Halloween Purple+Lime Green Heavy Duty Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/YEL10-HWPG.png?v=1785123025"
  },
  {
    "sku": "LV1601",
    "title": "Arlec 10m Multi Coloured Thin LED Rope Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV1601_CPIN004417-5OL.pdf?v=1754378981",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_10m_Multi_Coloured_Thin_LED_Rope_Light_LV1601.jpg?v=1762830360"
  },
  {
    "sku": "LV1410",
    "title": "Arlec 10m Multi-colour Festive LED Light Rope",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV1410_1411_CPIN003349-4.pdf?v=1754378978",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_10m_Festive_LED_Light_Rope_-_Mult_LV1410_27bec79b-d97a-4909-b08e-29ad3dda8967.jpg?v=1762751330"
  },
  {
    "sku": "LV1581",
    "title": "Arlec 10m Multicolour Low Voltage Plug-in LED Rope Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV158_Series_CPIN008617_OL.pdf?v=1783938371",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV1581.jpg?v=1783937956"
  },
  {
    "sku": "LV1571",
    "title": "Arlec 10m Multicolour Or Warm White Switch Festive Solar Rope Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV1571CPIN003390-5OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_10m_Multicolour_Or_Warm_White_Switch_Festive_Solar_Rope_Light_LV1571.jpg?v=1762753568"
  },
  {
    "sku": "LVS1581",
    "title": "Arlec 10m Solar Colour Switch LED Rope Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS1581.png?v=1779883255"
  },
  {
    "sku": "LV1600",
    "title": "Arlec 10m Warm White Thin LED Rope Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV1600_CPIN004417-4_OL.pdf?v=1754378981",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_10m_Warm_White_Thin_LED_Rope_Light_LV1600.jpg?v=1762829782"
  },
  {
    "sku": "AWL2315",
    "title": "Arlec 10W 800lm Rechargeable LED Worklight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWL2315.pdf?v=1791525570",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWL2315.png?v=1791525634"
  },
  {
    "sku": "CHR361MTRHA",
    "title": "Arlec 12-PC Modular Line Lights - Matter Compatible",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CHR361MTRHA_IM.pdf?v=1793003127",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/3.jpg?v=1793002967"
  },
  {
    "sku": "LVX786",
    "title": "Arlec 12.5cm 5 Pack White LED Acrylic Penguins Statues Battery Operated",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX786_CPIN007279_OL.pdf?v=1754379036",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_12.5cm_5_Pack_White_LED_Acrylic_Penguins_Statues_Battery_Operated_LVX786.jpg?v=1762830372"
  },
  {
    "sku": "REH218",
    "title": "Arlec 1200W White 2 Bar Radiant Strip Heater With Pull Cord",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/REH218CPIN004035.pdf?v=1754379096",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1200W_White_2_Bar_Radiant_Strip_Heater_With_Pull_Cord_REH218.jpg?v=1762831987"
  },
  {
    "sku": "LVS989",
    "title": "Arlec 120lm Premium Solar LED Wall Light With Motion Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS989_CPIN007024OL.pdf?v=1754378981",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_120L_Premium_Solar_LED_Wall_Light_With_Motion_Sensor_LVS989.jpg?v=1762753353"
  },
  {
    "sku": "UC662",
    "title": "Arlec 12cm CCT Streaming Ring Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC662.pdf?v=1754477173",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC662Insitue2_2.png?v=1765257588"
  },
  {
    "sku": "LVE898",
    "title": "Arlec 12m Low Voltage 100 RGB Copper USB Powered LED String Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE898_CPIN006600_OL.pdf?v=1754378972",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_12m_100_RGB_Copper_USB_Powered_LED_String_Light_LVE898.jpg?v=1762830109"
  },
  {
    "sku": "UC452CCT",
    "title": "Arlec 12W 87cm CCT Linking Bar Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC452CCT.png?v=1787805316"
  },
  {
    "sku": "CSF60LCCT",
    "title": "Arlec 12W Clipper Ceiling Fan Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CSF60LCCT_CPIN004394_OL.pdf?v=1754378963",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_12W_Clipper_Ceiling_Fan_Light_CSF60LCCT.jpg?v=1762752052"
  },
  {
    "sku": "DCF52426HWL",
    "title": "Arlec 132cm Miami 4-Blade DC Hugger Fan with CCT Light And Remote",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DCF52426HWL.pdf?v=1763620254",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DCF52426HWL.jpg?v=1763373431"
  },
  {
    "sku": "LVX1854",
    "title": "Arlec 138cm Low Voltage Christmas Tree Ladder With Santa",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1854.jpg?v=1765440167"
  },
  {
    "sku": "LVS830",
    "title": "Arlec 13cm Fairy Light Decorative Solar Lantern",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_13cm_Fairy_Light_Decorative_Solar_Lantern_LVS830.jpg?v=1762753628"
  },
  {
    "sku": "LVS271",
    "title": "Arlec 14cm Assorted LED Solar Bee Stake Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_14cm_Assorted_LED_Solar_Bee_Stake_Light_LVS271.jpg?v=1762830213"
  },
  {
    "sku": "LVS272",
    "title": "Arlec 14cm Assorted LED Solar Snail Stake Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_14cm_Assorted_LED_Solar_Snail_Stake_Light_LVS272.jpg?v=1762830252"
  },
  {
    "sku": "LVS274",
    "title": "Arlec 14cm Assorted LED Solar Turtle Stake Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_14cm_Assorted_LED_Solar_Turtle_Stake_Light_LVS274.jpg?v=1762830190"
  },
  {
    "sku": "LVS273",
    "title": "Arlec 14cm Solar Ladybug Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_14cm_Solar_Ladybug_Light_LVS273_1.jpg?v=1762830263"
  },
  {
    "sku": "OCH207T",
    "title": "Arlec 1500W 7 Fin Oil Heater With Adjustable Thermostat",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/OCH207T_211_CPIN005077.pdf_new.pdf?v=1756117941",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1500W_7_Fin_Oil_Heater_With_Adjustable_Thermostat_OCH207T_53577b55-90bd-459e-be91-ebb641c2201a.jpg?v=1762831815"
  },
  {
    "sku": "OCH207",
    "title": "Arlec 1500W 7-Fin Column Oil Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/OCH207_CPIN003616_2.pdf?v=1754379033",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1500W_7-Fin_Column_Oil_Heater_OCH207.jpg?v=1762831807"
  },
  {
    "sku": "ROH433",
    "title": "Arlec 1500W Alfresco Tabletop Instant Infrared Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ROH433CPIN008077_OL.pdf?v=1754379105",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1500W_Alfresco_Tabletop_Instant_Infrared_Heater_ROH433.jpg?v=1762756922"
  },
  {
    "sku": "ROH431",
    "title": "Arlec 1500W Black Hanging 360 Instant Infrared Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ROH431_CPIN007298_OL.pdf?v=1754379105",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1500W_Black_Hanging_360__Instant_Infrared_Heater_ROH431.png?v=1762756914"
  },
  {
    "sku": "CEH165",
    "title": "Arlec 1500W Ceramic Fan Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CEH165CPIN004033_2.pdf?v=1754378919",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1500W_Ceramic_Fan_Heater_CEH165.jpg?v=1762831474"
  },
  {
    "sku": "CEH163",
    "title": "Arlec 1500W Ceramic Fan Heater with Adjustable Thermostat",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CEH163CPIN004041-2.pdf?v=1754378919",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1500W_Ceramic_Fan_Heater_with_Adjustable_Thermostat_CEH163.jpg?v=1762831465"
  },
  {
    "sku": "CEH239",
    "title": "Arlec 1500W Ceramic Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CEH239CPIN005763.pdf?v=1754378920",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1500W_Ceramic_Heater_CEH239.jpg?v=1762831515"
  },
  {
    "sku": "PEH141",
    "title": "Arlec 1500W Convection Panel Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PEH141_CPIN004386.pdf?v=1754379037",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1500W_Convection_Panel_Heater_PEH141_1.jpg?v=1762831873"
  },
  {
    "sku": "MTH15",
    "title": "Arlec 1500W Micathermic Heater With Adjustable Thermostat",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1500W_Micathermic_Heater_With_Adjustable_Thermostat_MTH15.jpg?v=1762831766"
  },
  {
    "sku": "REH115",
    "title": "Arlec 1500W Radiant Heater With Fan Boost",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/REH115CPIN004377.pdf?v=1754379096",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1500W_Radiant_Heater_With_Fan_Boost_REH115.jpg?v=1762831979"
  },
  {
    "sku": "LVS988",
    "title": "Arlec 150lm Premium Solar LED Wall Light With Motion Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS988_CPIN007023OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_150L_Premium_Solar_LED_Wall_Light_With_Motion_Sensor_LVS988.jpg?v=1762753365"
  },
  {
    "sku": "DCA01BK",
    "title": "Arlec 150m Battery Operated Wireless Door Chime - Black",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DCA01BK_CPIN007702-2OL.pdf?v=1754378971",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_150m_Battery_Operated_Wireless_Door_Chime_-_Black_DCA01BK.jpg?v=1762753736"
  },
  {
    "sku": "DCA01",
    "title": "Arlec 150m Battery Operated Wireless Door Chime - White",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DCA01_CPIN007702-2OL.pdf?v=1754378972",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_150m_Battery_Operated_Wireless_Door_Chime_-_White_DCA01.jpg?v=1762753758"
  },
  {
    "sku": "KDC02-2",
    "title": "Arlec 150m White Wireless Dual Plug-in Door Chime with Kinetic Push Button",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/KDC02-2_CPIN007706_3_OL.pdf?v=1754378974",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_150m_White_Wireless_Dual_Plug-in_Door_Chime_with_Kinetic_Push_Button_KDC02-2.jpg?v=1762753730"
  },
  {
    "sku": "DKP03",
    "title": "Arlec 150m White Wireless Plug-in Door Chime with Kinetic Push Button",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DKP03CPIN007708_OL.pdf?v=1754378971",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_150m_White_Wireless_Plug-in_Door_Chime_with_Kinetic_Push_Button_DKP03.jpg?v=1762753700"
  },
  {
    "sku": "LVS310",
    "title": "Arlec 15cm Dragonfly Pattern Decorative Solar Lantern",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_15cm_Dragonfly_Pattern_Decorative_Solar_Lantern_LVS310.jpg?v=1762753453"
  },
  {
    "sku": "LVS311",
    "title": "Arlec 15cm LED Diagonal Flame Effect Solar Lantern",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_15cm_LED_Diagonal_Flame_Effect_Solar_Lantern_LVS311.jpg?v=1762753521"
  },
  {
    "sku": "LVX1846",
    "title": "Arlec 15cm Warm White Battery Powered 25 LED Hanging Star",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1846.jpg?v=1765338035"
  },
  {
    "sku": "YEL15-CL",
    "title": "Arlec 15m Heavy Duty Extension Lead With Bonus IP44 Cord Safety Box",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/YEL15-CL.jpg?v=1763366056"
  },
  {
    "sku": "LVE1015HA",
    "title": "Arlec 15m Multi Coloured Smart Grid Connect Connectable LED Rope Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE1015HA_CPIN005420.pdf?v=1754378975",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_15m_Multi_Coloured_Smart_Grid_Connect_Connectable_LED_Rope_Light_LVE1015HA.jpg?v=1762751339"
  },
  {
    "sku": "TH0021-BB",
    "title": "Arlec 15W Brush Brass Single Bar Heated Towel Rail",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/TH0021-BB_CPIN007351.pdf?v=1754379096",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_15W_Brush_Brass_Single_Bar_Heated_Towel_Rail_TH0021-BB.jpg?v=1762756956"
  },
  {
    "sku": "TH0021-GG",
    "title": "Arlec 15W Gunmetal Grey Single Bar Heated Towel Rail",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/TH0021-GG_CPIN007351.pdf?v=1754379096",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_15W_Gunmetal_Grey_Single_Bar_Heated_Towel_Rail_TH0021-GG.jpg?v=1762756965"
  },
  {
    "sku": "LVA207BK",
    "title": "Arlec 16mm Black Magnetic Gutter Hooks - 10 pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_16mm_Black_Magnetic_Gutter_Hooks_-_10_pack_LVA207BK.jpg?v=1762753190"
  },
  {
    "sku": "LVA018",
    "title": "Arlec 18 Multi Purpose Magnetic Gutter Hooks",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_18_Multi_Purpose_Magnetic_Gutter_Hooks_LVA018.jpg?v=1762751350"
  },
  {
    "sku": "EFH442",
    "title": "Arlec 1800W Fireplace Heater With Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/EFH442_CPIN004387.pdf?v=1754378967",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1800W_Fireplace_Heater_With_Remote_Control_EFH442.jpg?v=1762831701"
  },
  {
    "sku": "ROH407HA",
    "title": "Arlec 1850W Black Smart Grid Connect Alfresco Strip Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ROH407CPIN005767-3OL.pdf?v=1754379106",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ROH407HA.jpg?v=1778049090"
  },
  {
    "sku": "PEH142",
    "title": "Arlec 1850W Convection Panel Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PEH142_CPIN004386.pdf?v=1754379038",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1850W_Convection_Panel_Heater_PEH142.jpg?v=1762831884"
  },
  {
    "sku": "TH0021-MB",
    "title": "Arlec 18W Black Matte Single Bar Heated Towel Rail - Matte Black",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/TH0021-MB_CPIN007351.pdf?v=1754379096",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_18W_Black_Matte_Single_Bar_Heated_Towel_Rail_-_Matte_Black_TH0021-MB.jpg?v=1762756973"
  },
  {
    "sku": "TH0021-SS",
    "title": "Arlec 18W Stainless Steel Single Bar Heated Towel Rail",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/TH0021-SS_CPIN007351.pdf?v=1754379096",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_18W_Stainless_Steel_Single_Bar_Heated_Towel_Rail_TH0021-SS.jpg?v=1762832064"
  },
  {
    "sku": "LVE880",
    "title": "Arlec 19.5cm Rotating RGB LED Projector Torch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE880CPIN006633_OL.pdf?v=1754378975",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_19.5cm_Rotating_RGB_LED_Projector_Torch_LVE880.jpg?v=1762829756"
  },
  {
    "sku": "LVS994",
    "title": "Arlec 190lm Premium Solar LED Wall Light With Motion Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS994_CPIN007029OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_190L_Premium_Solar_LED_Wall_Light_With_Motion_Sensor_LVS994.jpg?v=1762753418"
  },
  {
    "sku": "LVS178",
    "title": "Arlec 19cm Decorative Owl Solar Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_19cm_Decorative_Owl_Solar_Light_LVS178.jpg?v=1762830304"
  },
  {
    "sku": "ALD053",
    "title": "Arlec 1m CW Battery Strip Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD053.pdf?v=1754477173",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec1mCWBatteryStripLight1.jpg?v=1765260575"
  },
  {
    "sku": "ALD052",
    "title": "Arlec 1m RGB Battery Strip Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD052.pdf?v=1754477173",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec1mRGBBatteryStripLight1.jpg?v=1765260680"
  },
  {
    "sku": "ALD055",
    "title": "Arlec 1m WW LED Battery Sensor Strip Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD055.pdf?v=1754477173",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec1mWWLEDBatterySensorStripLight1.png?v=1765260080"
  },
  {
    "sku": "LVX1791HA",
    "title": "Arlec 2 x 2m Dual LED Festive Net Lights",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1791HA_CPIN007854_OL.pdf?v=1754379034",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1791HA.jpg?v=1762829065"
  },
  {
    "sku": "LVS612",
    "title": "Arlec 2-in-1 3CCT Solar Wall and Fence Light - 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS612.png?v=1788430517"
  },
  {
    "sku": "BL-2CR123A",
    "title": "Arlec 2-Pack Professional Lithium Batteries - BL-2CR123A",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "LVX1833",
    "title": "Arlec 2.1m Low Voltage Inflatable Santa Reindeer",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1833CPIN007262OL.pdf?v=1754379040",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2.1m_Low_Voltage_Inflatable_Santa_Reindeer_LVX1833.jpg?v=1762829897"
  },
  {
    "sku": "LVS09LINK",
    "title": "Arlec 2.4GHz LumaLink Linkable Solar Path Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "LVX1865",
    "title": "Arlec 2.4m Inflatable Gingerbread Man",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1865.jpg?v=1765270778"
  },
  {
    "sku": "LVX1832",
    "title": "Arlec 2.4m Low Voltage Inflatable Signs",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1832CPIN007261OL.pdf?v=1754379039",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Inflatable_Signs_2.4M_Low_Voltage_LVX1832.jpg?v=1762829932"
  },
  {
    "sku": "LVX975",
    "title": "Arlec 2.4m Low Voltage LED Gingerbread Family Inflatable",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX975_CPIN006598_OL.pdf?v=1754379028",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2.4m_Low_Voltage_LED_Inflatable_Gingerbread_Family_LVX975.jpg?v=1762829998"
  },
  {
    "sku": "LVE618",
    "title": "Arlec 2.5m Tombstones Halloween Inflatable",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE618_HalloweenInflatables_CPIN006686_OL.pdf?v=1754378976",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2.5m_Tombstones_Halloween_Inflatable_LVE618.jpg?v=1762753238"
  },
  {
    "sku": "LVE856",
    "title": "Arlec 20 Battery Operated Bat Lantern Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE856.png?v=1780031349"
  },
  {
    "sku": "LVE848",
    "title": "Arlec 20 Battery Operated Spiderweb Lantern Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE848.png?v=1780033405"
  },
  {
    "sku": "LVS019",
    "title": "Arlec 20 Lumens LED Garden Spot Solar Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_20_Lumens_LED_Garden_Spot_Solar_Light_LVS019.jpg?v=1762753579"
  },
  {
    "sku": "LVE1120HA",
    "title": "Arlec 20 Warm White Smart LED Low Voltage Connectable Festoon Lights",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE1120HA_CPIN006120-2_OL.pdf?v=1754378978",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_20_Warm_White_Smart_LED_Low_Voltage_Connectable_Festoon_Lights_LVE1120HA.jpg?v=1762753141"
  },
  {
    "sku": "LVE1121HA",
    "title": "Arlec 20 Warm White Smart LED Low Voltage Connectable Star Lights",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "LVE158",
    "title": "Arlec 200 Dual Colour LED Candy Bubble String Lights Low Voltageur",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE158_CPIN006127_OL.pdf?v=1754378978",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_200_Dual_Colour_LED_Candy_Bubble_String_Lights_Low_Voltageur_LVE158.jpg?v=1762829886"
  },
  {
    "sku": "LVS533CM",
    "title": "Arlec 200 Lumen LED Solar Sensor Floodlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS533CM_IM.pdf?v=1790832936",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS533CM.png?v=1790582242"
  },
  {
    "sku": "WLED25",
    "title": "Arlec 2000lm Cool White LED Portable Worklight",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "OCH209TBK",
    "title": "Arlec 2000W 9 Fin Oil Heater With 24Hr Timer",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/OCH209TBK_CPIN005033.pdf?v=1754379033",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2000W_9_Fin_Oil_Heater_With_24Hr_Timer_OCH209TBK.jpg?v=1762756795"
  },
  {
    "sku": "FHB210",
    "title": "Arlec 2000W Bathroom Fan Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/FHB210_CPIN007007_OL.pdf?v=1754378974",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2000W_Bathroom_Fan_Heater_FHB210.jpg?v=1762831722"
  },
  {
    "sku": "CH253",
    "title": "Arlec 2000W Black Convection Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CH253_CPIN005762_3_OL.pdf?v=1754378927",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2400W_White_Convection_Heater_With_Remote_Control_CH253_05d74b13-db0d-4124-9294-3ba6b66289d4.jpg?v=1762831673"
  },
  {
    "sku": "ROH312",
    "title": "Arlec 2000W Black Freestanding Instant Infrared Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ROH312_CPIN007713_2_OL.pdf?v=1754379105",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2000W_Black_Freestanding_Instant_Infrared_Heater_ROH312.png?v=1762756837"
  },
  {
    "sku": "ROH302",
    "title": "Arlec 2000W Black Wall-Mount Instant Infrared Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ROH302_CPIN007712_OL.pdf?v=1754379106",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2000W_Black_Wall-Mount_Instant_Infrared_Heater_ROH302.png?v=1762832028"
  },
  {
    "sku": "ROH408",
    "title": "Arlec 2000W Cantilever Instant Infrared Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ROH408CPIN005770_2OL.pdf?v=1754379105",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2000W_Cantilever_Instant_Infrared_Heater_ROH408.jpg?v=1762832050"
  },
  {
    "sku": "CEH202",
    "title": "Arlec 2000W Ceramic Fan Heater with Adjustable Thermostat and Oscillating Function",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CEH202_CPIN004061-2.pdf?v=1754378919",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2000W_Ceramic_Fan_Heater_with_Adjustable_Thermostat_and_Oscillating_Function_CEH202.jpg?v=1762831485"
  },
  {
    "sku": "CEH228",
    "title": "Arlec 2000W Ceramic Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CEH228CPIN005760.pdf?v=1754378921",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2000W_Ceramic_Heater_CEH228.jpg?v=1762831494"
  },
  {
    "sku": "CEH252",
    "title": "Arlec 2000W Ceramic Oscillating Tower Heater with Electronic Thermostat and Timer",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CEH252CPIN004027-2.pdf?v=1754378921",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2000W_Ceramic_Oscillating_Tower_Heater_with_Electronic_Thermostat_and_Timer_CEH252.jpg?v=1762831566"
  },
  {
    "sku": "CEH251",
    "title": "Arlec 2000W Ceramic Tower Heater with Oscillating Function",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CEH251CPIN004026_2.pdf?v=1754378919",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2000W_Ceramic_Tower_Heater_with_Oscillating_Function_CEH251.jpg?v=1762831557"
  },
  {
    "sku": "CEH256",
    "title": "Arlec 2000W Ceramic Tower Heater With Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CEH256CPIN007003_2OL.pdf?v=1754378927",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2000W_Ceramic_Tower_Heater_With_Remote_Control_CEH256.jpg?v=1762831585"
  },
  {
    "sku": "CEH80",
    "title": "Arlec 2000W Ceramic Wall Mount Heater With Digital Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CEH80CPIN006422_2_OL.pdf?v=1754378926",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2000W_Ceramic_Wall_Mount_Heater_With_Digital_Control_CEH80_1.jpg?v=1762831456"
  },
  {
    "sku": "CH227",
    "title": "Arlec 2000W Convection Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CH227_CPIN005065.pdf?v=1754378919",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2000W_Convection_Heater_CH227.jpg?v=1762831628"
  },
  {
    "sku": "CH260",
    "title": "Arlec 2000W Convection Heater with Adjustable Thermostat",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CH260_CPIN007009_OL.pdf?v=1754378926",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2000W_Convection_Heater_CH260.jpg?v=1762832114"
  },
  {
    "sku": "CH226",
    "title": "Arlec 2000W Convection Heater with Adjustable Thermostat, Timer and Turbo Fan LED Display",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CH226_CPIN005043.pdf?v=1754378921",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2000W_Convection_Heater_with_Adjustable_Thermostat__Timer_and_Turbo_Fan_LED_Display_CH226.jpg?v=1762831617"
  },
  {
    "sku": "CH262",
    "title": "Arlec 2000W Convection Heater With Fan Boost And Remote",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CH262_CPIN007011_2_OL.pdf?v=1754378926",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2000W_Convection_Heater_With_Fan_Boost_And_Remote_CH262.jpg?v=1762831683"
  },
  {
    "sku": "CH206",
    "title": "Arlec 2000W Convection Heater With Timer And Fan Boost",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CH206_CPIN004037.pdf?v=1754378920",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2000W_Convection_Heater_With_Timer_And_Fan_Boost_CH206.jpg?v=1762831595"
  },
  {
    "sku": "PEH132",
    "title": "Arlec 2000W Convection Panel Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PEH132_CPIN005083_2.pdf?v=1754379037",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2000W_Convection_Panel_Heater_PEH132.jpg?v=1762831864"
  },
  {
    "sku": "CEH236",
    "title": "Arlec 2000W Digital Ceramic Tower Heater With 360 Oscillation",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2000W_Digital_Ceramic_Tower_Heater_With_360__Oscillation_CEH236.jpg?v=1762831504"
  },
  {
    "sku": "FEH110",
    "title": "Arlec 2000W Fan Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/FEH110CPIN004341.pdf?v=1754378964",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2000W_Fan_Heater_FEH110.jpg?v=1762831712"
  },
  {
    "sku": "FEH290",
    "title": "Arlec 2000W Fan Heater With Digital Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/FEH290_CPIN007008_4OL.pdf?v=1754378974",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2000W_Fan_Heater_With_Digital_Control_FEH290.jpg?v=1762756766"
  },
  {
    "sku": "PEH210HA",
    "title": "Arlec 2000W Grid Connect Ceramic Wall Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PEH210HA_CPIN007039_OL.pdf?v=1754379042",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2000W_Grid_Connect_Ceramic_Wall_Heater_PEH210HA.jpg?v=1762831893"
  },
  {
    "sku": "ROH406",
    "title": "Arlec 2000W Instant Infrared Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ROH406CPIN005766_4_OL.pdf?v=1754379104",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2000W_Instant_Infrared_Heater_ROH406.jpg?v=1762756889"
  },
  {
    "sku": "MTH16",
    "title": "Arlec 2000W Micathermic Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MTH16_CPIN005758_supplier_minor_change_20201124.pdf?v=1754379035",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2000W_Micathermic_Heater_MTH16.jpg?v=1762831779"
  },
  {
    "sku": "CEH125",
    "title": "Arlec 2000W Wall Mount Ceramic Heater with 2 Power Settings 1000W/2000W with Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CEH125CPIN004050-2.pdf?v=1754378922",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2000W_Wall_Mount_Ceramic_Heater_with_Remote_Control_CEH125.jpg?v=1762832105"
  },
  {
    "sku": "CEH126",
    "title": "Arlec 2000W Wall Mount Ceramic Heater with 2 Power Settings with Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CEH126CPIN004051_3.pdf?v=1754378918",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2000W_Wall_Mount_Ceramic_Heater_With_Remote_Control_CEH126.jpg?v=1762832096"
  },
  {
    "sku": "LVS533",
    "title": "Arlec 200lm LED Solar Sensor Floodlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS533CPIN005262_2OL.pdf?v=1754378981",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_200_Lumen_LED_Solar_Sensor_Floodlight_LVS533.jpg?v=1762753556"
  },
  {
    "sku": "LVS10LINK",
    "title": "Arlec 200lm LumaLink Linkable Solar Bollard Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "DCA02",
    "title": "Arlec 200m Rechargeable Wireless Door Chime With Speaker and RGB LED Indicator - Black",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DCA02_CPIN007704OL.pdf?v=1754378973",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_200m_Rechargeable_Wireless_Door_Chime_With_Speaker_and_RGB_LED_Indicator_-_Black_DCA02.jpg?v=1762753724"
  },
  {
    "sku": "DCAP02-2",
    "title": "Arlec 200m White Wireless Dual Plug-in RGB Door Chime with Push Button",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DCAP02-2_CPIN007707OL.pdf?v=1754378971",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec200mWhiteWirelessDualPlug-inRGBDoorChimewithPushButton_DCAP02-2.jpg?v=1762753716"
  },
  {
    "sku": "DCAP01",
    "title": "Arlec 200m White Wireless Plug-in RGB Door Chime with Push Button",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DCAP01_CPIN007707OL.pdf?v=1754378971",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_200m_White_Wireless_Plug-in_RGB_Door_Chime_with_Push_Button_DCAP01.jpg?v=1762753772"
  },
  {
    "sku": "CH239",
    "title": "Arlec 200W Oil Free Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CH239_CPIN005754-2OL.pdf?v=1754378926",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_200W_Oil_Free_Heater_CH239_33a24903-04e7-4103-8222-b67beefddb43.jpg?v=1762831646"
  },
  {
    "sku": "AWL2605",
    "title": "Arlec 20W 2000lm Rechargeable LED Bat Worklight",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWL2605.png?v=1793158416"
  },
  {
    "sku": "AWL2316",
    "title": "Arlec 20W 2000lm Rechargeable LED Worklight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWL2316.pdf?v=1791526116",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWL2316.png?v=1791527039"
  },
  {
    "sku": "AWL2311T",
    "title": "Arlec 20W 2000lm Rechargeable Work Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWL2311T.pdf?v=1791524535",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWL2311T.png?v=1791524843"
  },
  {
    "sku": "ROH352",
    "title": "Arlec 2100W Freestanding Instant Infrared Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ROH352CPIN008078_OL.pdf?v=1754379105",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2100W_Freestanding_Instant_Infrared_Heater_ROH352.jpg?v=1762756846"
  },
  {
    "sku": "LVX519",
    "title": "Arlec 210cm Low Voltage Plugin Koala & Gift Boxes Inflatable",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX519_CPIN008625_OL.pdf?v=1783677793",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX519.png?v=1783677617"
  },
  {
    "sku": "PEH220",
    "title": "Arlec 2200W Black Convection Panel Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PEH220PEH221CPIN004353_3_OL.pdf?v=1754379042",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2200W_Black_Convection_Panel_Heater_PEH220.jpg?v=1762831904"
  },
  {
    "sku": "PEH224HA",
    "title": "Arlec 2200W Black Grid Connect Smart Convection Panel Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PEH224HA_CPIN007040_3_OL.pdf?v=1754379040",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2200W_Black_Grid_Connect_Smart_Convection_Panel_Heater_REH308.jpg?v=1762756814"
  },
  {
    "sku": "PEH222HA",
    "title": "Arlec 2200W Black Smart Convection Panel Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PEH222HA_CPIN004357.pdf?v=1754379037",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2200W_Black_Smart_Convection_Panel_Heater_PEH222HA_1.jpg?v=1762831922"
  },
  {
    "sku": "CEH230BK",
    "title": "Arlec 2200W Ceramic Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CEH230BKCPIN005074.pdf?v=1754378920",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2200W_Ceramic_Heater_CEH230BK.jpg?v=1762756719"
  },
  {
    "sku": "CEH253",
    "title": "Arlec 2200W Ceramic Tower Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CEH253CPIN004037_2.pdf?v=1754378919",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2200W_Ceramic_Tower_Heater_CEH253.jpg?v=1762831576"
  },
  {
    "sku": "CEH241",
    "title": "Arlec 2200W Ceramic Tower Heater With Oscillation And Digital Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CEH241CPIN006427_3OL.pdf?v=1754378927",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2200W_Ceramic_Tower_Heater_With_Oscillation_And_Digital_Control__CEH241_1.jpg?v=1762831523"
  },
  {
    "sku": "CEH81",
    "title": "Arlec 2200W Ceramic Wall Mount Heater With Digital Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CEH81CPIN006423OL.pdf?v=1754378926",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2000W_Ceramic_Wall_Mount_Heater_With_Digital_Control_CEH81.jpg?v=1762831447"
  },
  {
    "sku": "PEH221",
    "title": "Arlec 2200W White Convection Panel Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PEH221CPIN004353_6OL.pdf?v=1754379043",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2200W_White_Convection_Panel_Heater_PEH221.jpg?v=1762831913"
  },
  {
    "sku": "PEH225HA",
    "title": "Arlec 2200W White Grid Connect Smart Convection Panel Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PEH225HA_CPIN007040_3_OL.pdf?v=1754379040",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2200W_White_Grid_Connect_Smart_Convection_Panel_Heater_PEH225HA.jpg?v=1762756827"
  },
  {
    "sku": "PEH225HA-TS",
    "title": "Arlec 2200W White Grid Connect Smart Glass Panel Heater",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PEH225HA-TS.jpg?v=1779361508"
  },
  {
    "sku": "PEH223HA",
    "title": "Arlec 2200W White Smart Convection Panel Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CPIN004357_PEH223HA.pdf?v=1754378922",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2200W_White_Smart_Convection_Panel_Heater_PEH223HA.jpg?v=1762831935"
  },
  {
    "sku": "REH307",
    "title": "Arlec 2250W 3 Bar Quartz Radiant Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/REH307CPIN004036_2.pdf?v=1754379096",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2250W_3_Bar_Quartz_Radiant_Heater_REH307.jpg?v=1762831998"
  },
  {
    "sku": "CEH536",
    "title": "Arlec 2300W Ceramic Tower Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CEH536CPIN004376.pdf?v=1754378921",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2300W_Ceramic_Tower_Heater_CEH536.jpg?v=1762831605"
  },
  {
    "sku": "LV1996",
    "title": "Arlec 23cm Low Voltage LED Projector",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV1996_CPIN008629_OL.pdf?v=1783674264",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV1996.png?v=1783673656"
  },
  {
    "sku": "CL24",
    "title": "Arlec 24 LED Rechargable Camping Lantern With Compass",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/73220187-c3a3-416b-801d-d69d17f74d04_1ceb904b-ed20-40c9-a178-8ea73522d766.jpg?v=1763375268"
  },
  {
    "sku": "OCH110",
    "title": "Arlec 2400W 11 Fin Oil Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/OCH110_CPIN005756_2_OL.pdf?v=1754379040",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2400W_11_Fin_Oil_Heater_OCH110.png?v=1762831789"
  },
  {
    "sku": "OCH211TBK",
    "title": "Arlec 2400W 11 Fin Oil Heater With 24 Hour Timer",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/OCH211TBK_CPIN005033.pdf?v=1754379031",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2400W_11_Fin_Oil_Heater_With_24_Hour_Timer_OCH211TBK.jpg?v=1762756805"
  },
  {
    "sku": "OCH711BK",
    "title": "Arlec 2400W 11 Fin Oil Heater With Adjustable Thermostat",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2400W_11_Fin_Oil_Heater_With_Adjustable_Thermostat_OCH711BK.jpg?v=1762831835"
  },
  {
    "sku": "OCH114",
    "title": "Arlec 2400W 11 Fin Oil Heater With Fan Boost",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/OCH114_CPIN005757_3_OL.pdf?v=1754379043",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2400W_11_Fin_Oil_Heater_With_Fan_Boost_OCH114.jpg?v=1762831800"
  },
  {
    "sku": "PEH258HA",
    "title": "Arlec 2400W Black Grid Connect Glass Panel Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PEH258HA_CPIN007055_3_OL.pdf?v=1754379102",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2400W_Black_Grid_Connect_Glass_Panel_Heater_PEH258HA.jpg?v=1762831944"
  },
  {
    "sku": "ROH403B",
    "title": "Arlec 2400W Black Instant Infrared Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ROH403B_CPIN005768_7_OL.pdf?v=1754379106",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ROH403B.jpg?v=1782446650"
  },
  {
    "sku": "OCH210BK",
    "title": "Arlec 2400W Black Matte 10 Fin Oil Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/OCH210BK_CPIN005049.pdf?v=1754379030",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2400W_Black_Matte_10_Fin_Oil_Heater_OCH210BK.jpg?v=1762831826"
  },
  {
    "sku": "ROH424HA",
    "title": "Arlec 2400W Black Smart Grid Connect Alfresco Strip Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ROH424HA_CPIN005767-4_OL.pdf?v=1754379106",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2400W_Black_Smart_Grid_Connect_Alfresco_Strip_Heater_ROH424HA.png?v=1762756905"
  },
  {
    "sku": "ROH410BKHA",
    "title": "Arlec 2400W Black Smart Grid Connect Alfresco Strip Heater",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ROH410BKHA.png?v=1782445199"
  },
  {
    "sku": "ROH403BHA",
    "title": "Arlec 2400W Black Smart Grid Connect Instant Infrared Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ROH403BHA_CPIN005768_6_OL.pdf?v=1754379106",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2400W_Black_Smart_Grid_Connect_Infrared_Strip_Heater_ROH403BHA.jpg?v=1762756867"
  },
  {
    "sku": "CEH244",
    "title": "Arlec 2400W Ceramic Tower Heater and Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CEH244_CPIN006950_OL.pdf?v=1754378926",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2400W_Ceramic_Tower_Heater_and_Fan_CEH244.jpg?v=1762831547"
  },
  {
    "sku": "CEH243",
    "title": "Arlec 2400W Ceramic Tower Heater With Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CEH243_CPIN007042_2_OL.pdf?v=1754378926",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2400W_Ceramic_Tower_Heater_With_Remote_Control_CEH243.jpg?v=1762831538"
  },
  {
    "sku": "CH250BK",
    "title": "Arlec 2400W Convection Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CH250BKCPIN005063_3.pdf?v=1754378920",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2400W_Convection_Heater_CH250BK.jpg?v=1762831655"
  },
  {
    "sku": "FH910",
    "title": "Arlec 2400W Fan Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/FH910CPIN006399OL.pdf?v=1754378974",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2400W_Fan_Heater_FH910.jpg?v=1762832132"
  },
  {
    "sku": "FEH250",
    "title": "Arlec 2400W Fan Heater with Adjustable Thermostat",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/FEH250_CPIN007038-2OL_1.pdf?v=1754378971",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2400W_Fan_Heater_With_Adjustable_Thermostat_FEH250.jpg?v=1762756742"
  },
  {
    "sku": "FEH251",
    "title": "Arlec 2400W Fan Heater With Adjustable Thermostat And Oscillation",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/FEH251_CPIN007038-2OL.pdf?v=1754378974",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2400W_Fan_Heater_With_Adjustable_Thermostat_And_Oscillation_FEH251.jpg?v=1762756755"
  },
  {
    "sku": "CH2800HA",
    "title": "Arlec 2400W Grid Connect Convection Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CH2800HA_CPIN007012_4_OL.pdf?v=1754378928",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2400W_Grid_Connect_Convection_Heater_CH2800HA.jpg?v=1762831691"
  },
  {
    "sku": "MTH11BK",
    "title": "Arlec 2400W Micathermic Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MTH11BKCPIN004384_2.pdf?v=1754379025",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2400W_Micathermic_Heater_MTH11BK.jpg?v=1762756775"
  },
  {
    "sku": "MTH11",
    "title": "Arlec 2400W Micathermic Heater With Adjustable Thermostat",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2400W_Micathermic_Heater_With_Adjustable_Thermostat_MTH11.jpg?v=1762831732"
  },
  {
    "sku": "MTH12BKHA",
    "title": "Arlec 2400W Micathermic Heater With Electronic Thermostat And Timer",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MTH12BK_CPIN005071_3_OL.pdf?v=1754379037",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MTH12BKHA.jpg?v=1779882169"
  },
  {
    "sku": "MTH12",
    "title": "Arlec 2400W Micathermic Heater With Remote Control",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2400W_Micathermic_Heater_With_Remote_Control_MTH12.jpg?v=1762831744"
  },
  {
    "sku": "CH233",
    "title": "Arlec 2400W Oil Free Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CH233_CPIN007006_OL.pdf?v=1754378927",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2400W_Oil_Free_Heater_CH233.jpg?v=1762831637"
  },
  {
    "sku": "REH309",
    "title": "Arlec 2400W Radiant Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/REH309CPIN005759.pdf?v=1754379098",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2400W_Radiant_Heater_REH309_1.jpg?v=1762832018"
  },
  {
    "sku": "REH308",
    "title": "Arlec 2400W Radiant Heater With Adjustable Thermostat And Fan Boost",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/REH308CPIN004042-2.pdf?v=1754379096",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2400W_Radiant_Heater_With_Adjustable_Thermostat_And_Fan_Boost_REH308.jpg?v=1762832008"
  },
  {
    "sku": "PEH262HA",
    "title": "Arlec 2400W Smart Grid Connect Glass Panel Heater With Flame Effect",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PEH262HA_CPIN008568_OL.pdf?v=1781487922",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PEH262HA.png?v=1776150087"
  },
  {
    "sku": "CH250WH",
    "title": "Arlec 2400W White Convection Heater With Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CH250WH_Series_CPIN005063_5_OL.pdf?v=1754378927",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2400W_White_Convection_Heater_With_Remote_Control_CH250WH_83c7608a-c6ba-4916-bb52-c827268b1b89.jpg?v=1762831664"
  },
  {
    "sku": "PEH333HA",
    "title": "Arlec 2400W White Grid Connect Glass Panel Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PEH333HA_CPIN007055_2_OL.pdf?v=1754379103",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2400W_White_Grid_Connect_Glass_Panel_Heater_PEH333HA.jpg?v=1762831956"
  },
  {
    "sku": "NL0033",
    "title": "Arlec 240V Aluminium Touch Dimmer LED Night Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_240V_Aluminium_Touch_Dimmer_LED_Night_Light_NL0033.jpg?v=1762754017"
  },
  {
    "sku": "NL0063",
    "title": "Arlec 240V Diffused Plug-In LED Night Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_240V_Diffused_Plug-In_LED_Night_Light_NL0063.jpg?v=1762830590"
  },
  {
    "sku": "NL0065",
    "title": "Arlec 240V Motion Sensor LED Plug-In Night Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_240V_Motion_Sensor_LED_Plug-In_Night_Light_NL0065.jpg?v=1762754123"
  },
  {
    "sku": "NL0060",
    "title": "Arlec 240V Pill Plug-In LED Night Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_240V_Pill_Plug-In_LED_Night_Light_NL0060.jpg?v=1762753952"
  },
  {
    "sku": "NL0061",
    "title": "Arlec 240V Pill Plug-In LED Night Light - 3 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_240V_Pill_Plug-In_LED_Night_Light_-_3_Pack_NL0061.jpg?v=1762753911"
  },
  {
    "sku": "NL0034",
    "title": "Arlec 240V Rotating Auto LED Night Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL0034_CPIN003136_3_OL.pdf?v=1754379036",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_240V_Rotating_Auto_LED_Night_Light_NL0034.jpg?v=1762753873"
  },
  {
    "sku": "NL0040",
    "title": "Arlec 240V White Auto Sensor LED Night Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_240VNSHAPEDAUTONIGHTLIGHT_NL0040.jpg?v=1762753889"
  },
  {
    "sku": "LVE859",
    "title": "Arlec 25cm Ghost Solar Stake Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE859.png?v=1780036882"
  },
  {
    "sku": "LVE860",
    "title": "Arlec 25cm Scarecrow Solar Stake Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE860.png?v=1780038012"
  },
  {
    "sku": "LVA211BK",
    "title": "Arlec 25mm Black Magnetic Gutter Hooks - 5 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_25mm_Black_Magnetic_Gutter_Hooks_-_5_Pack_LVA211BK.jpg?v=1762753152"
  },
  {
    "sku": "LVS19U",
    "title": "Arlec 26cm 400lm Solar LED Wall Light With Sensor - Black",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS19UCPIN007673_2_OL.pdf?v=1754378978",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_400lm_26cm_Solar_LED_Wall_Light_With_Sensor_-_Black_LVS19U.jpg?v=1762753343"
  },
  {
    "sku": "LVX1870",
    "title": "Arlec 26cm Solar Poly Resin Penguin Stake Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1870.jpg?v=1765272508"
  },
  {
    "sku": "LVS986",
    "title": "Arlec 28cm 400lm Premium Solar LED Post Light with Motion Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS986_CPIN007021OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_28cm_400L_Premium_Solar_LED_Post_Light_with_Motion_Sensor_LVS986.jpg?v=1762753500"
  },
  {
    "sku": "LV140",
    "title": "Arlec 2M 20 Warm White LED Green Rope Light Battery Operated",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV140CPIN006132-2OL.pdf?v=1754378971",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2M_20_Warm_White_LED_Green_Rope_Light_Battery_Operated_LV140.jpg?v=1762829812"
  },
  {
    "sku": "LVX524",
    "title": "Arlec 2m Batteryoperated Red LED Fabric Ribbon Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX524_LVX525_CPIN008627_OL.pdf?v=1783664140",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX524_1_59fe21e7-d6b5-453a-b5dc-657dec90e111.png?v=1783664399"
  },
  {
    "sku": "LVX525",
    "title": "Arlec 2m Batteryoperated Striped LED Fabric Ribbon Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX524_LVX525_CPIN008627_OL.pdf?v=1783664140",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX525_1.png?v=1783666456"
  },
  {
    "sku": "ALD290",
    "title": "Arlec 2m Dotless CCT COB Strip Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD290.png?v=1781245843"
  },
  {
    "sku": "LVX163",
    "title": "Arlec 3 LED Battery Operated Poinsette Flower Pot Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_3_LED_Battery_Operated_Poinsette_Flower_Pot_Light_LVX163.jpg?v=1762830073"
  },
  {
    "sku": "NL150",
    "title": "Arlec 3-In-1 Wireless Charger With Speaker & Night Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL150.png?v=1781690148"
  },
  {
    "sku": "PA1226WH",
    "title": "Arlec 3.5kW Portable Air Conditioner With Remote",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PA1226WH_im.pdf?v=1783934578",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PA1226WH_eadf19c6-286c-42de-8cb6-038a18147ff0.png?v=1783935274"
  },
  {
    "sku": "LVS020",
    "title": "Arlec 30 Lumens LED Garden Spot Solar Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_30_Lumens_LED_Garden_Spot_Solar_Light_LVS020.jpg?v=1762753591"
  },
  {
    "sku": "UC549",
    "title": "Arlec 300 x 100mm CCT and Dimmable Frameless Cabinet Light With IR Sensor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC549_b901acdb-7ccb-4903-9df2-94c83edd8028.png?v=1781694874"
  },
  {
    "sku": "UC550",
    "title": "Arlec 300 x 200mm CCT and Dimmable Frameless Cabinet Light With IR Sensor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC550.png?v=1781257587"
  },
  {
    "sku": "ROH413HA",
    "title": "Arlec 3000W Grid Connect Smart Radiant Strip Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ROH413HA_CPIN006462_OL_1.pdf?v=1754379103",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ROH413HA.png?v=1782446434"
  },
  {
    "sku": "LVS603",
    "title": "Arlec 300lm Dual Purpose Solar Wall Light and Spotlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CPIN008785_OL.pdf?v=1788417032",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS603.png?v=1788416096"
  },
  {
    "sku": "LVS180",
    "title": "Arlec 30cm Tulip Solar Stake Light - Assorted Colour",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_800lm_LED_Solar_Floodlight_With_PIR_Motion_Sensor_LVS1800_9054b50b-d786-4504-bc03-3f7ad5279ee5.jpg?v=1762829589"
  },
  {
    "sku": "LVX1856",
    "title": "Arlec 30cm Warm White / Multi-Colour Low Voltage Star Cluster Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1856_1.jpg?v=1764653149"
  },
  {
    "sku": "LV1583",
    "title": "Arlec 30m Cool White Low Voltage Plugin LED Rope Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV1583_Series_CPIN008617_OL_2.pdf?v=1783940101",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV1583_1.png?v=1783940175"
  },
  {
    "sku": "LV1415",
    "title": "Arlec 30m Multi-colour Festive LED Light Rope",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV1415_CPIN003365-2.pdf?v=1754378971",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_30m_Festive_LED_Light_Rope_-_Multi-colour_LED_LV1415.jpg?v=1762751360"
  },
  {
    "sku": "LV1582",
    "title": "Arlec 30m Multicolour Low Voltage Plug-in LED Rope light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV158_Series_CPIN008617_OL_1.pdf?v=1783939857",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV1582_1.png?v=1783939461"
  },
  {
    "sku": "LV1416",
    "title": "Arlec 30m White Festive LED Light Rope",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV1416_CPIN003365-6O_L.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_30m_Festive_LED_Light_Rope_-_White_LV1416.jpg?v=1762751367"
  },
  {
    "sku": "WL2330",
    "title": "Arlec 30W LED Worklight With Tripod",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/WL2330CPIN007323_OL.pdf?v=1754379100",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_30W_LED_Worklight_With_Tripod_WL2330.jpg?v=1762756698"
  },
  {
    "sku": "LVS535",
    "title": "Arlec 330lm LED Movement Activated Sensor Security Solar Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS535CPIN005354_2OL.pdf?v=1754378981",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_330_Lumens_LED_Movement__Activated_Sensor_Security_Solar_Light_LVS535.jpg?v=1762753375"
  },
  {
    "sku": "LVX1859",
    "title": "Arlec 33cm Battery Operated Santa Hat Tree Topper",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1859.jpg?v=1765273277"
  },
  {
    "sku": "LVX518",
    "title": "Arlec 34cm Batteryoperated LED Fabric House Ornament",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX518_CPIN008624_OL.pdf?v=1783665623",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX518_1.png?v=1783665545"
  },
  {
    "sku": "LVX992",
    "title": "Arlec 35cm Battery Operated LEDs Table Top Christmas Calendar",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX991_LVX992__CPIN006592_OL.pdf?v=1754379023",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_35cm_Battery_Operated_LEDs_Table_Top_Christmas_Calendar_LVX992.jpg?v=1762830025"
  },
  {
    "sku": "TH0035",
    "title": "Arlec 35W Stainless Steel 5 Bar Heated Towel Rail - 5 Bar",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/TH0035_CPIN003142-5.pdf?v=1754379098",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_35W_Stainless_Steel_5_Bar_Heated_Towel_Rail_-_5_Bar_TH0035.jpg?v=1762756983"
  },
  {
    "sku": "LVX1774",
    "title": "Arlec 3m Battery Powered Ribbon Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1774_CPIN007845_2_OL.pdf?v=1783654028",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1774.jpg?v=1783663389"
  },
  {
    "sku": "LVX33",
    "title": "Arlec 3m Low Voltage Inflatable Santa",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX33_CPIN006785_OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_3m_Low_Voltage_Inflatable_Santa_LVX33.jpg?v=1762753032"
  },
  {
    "sku": "ALD303",
    "title": "Arlec 3m RGB LED Strip Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD303.pdf?v=1754477173",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec3mRGBLEDStripLight1.jpg?v=1765260196"
  },
  {
    "sku": "LVX967",
    "title": "Arlec 3m x 4.5m Low Voltage Inflatable Dinosaur",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX967_LVX968_CPIN004227-3_OL_1.pdf?v=1754379028",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec-3m-x-4.5m-Low-Voltage-Inflatable-Dinosaur_LVX967_4e5099e4-cccf-4224-962b-0382753738d4.jpg?v=1762753010"
  },
  {
    "sku": "PB442PK-P",
    "title": "Arlec 4 Outlet Individually Switched Powerboard White - Twin Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB442PK-P_Hero.jpg?v=1763458219"
  },
  {
    "sku": "PB34B-G",
    "title": "Arlec 4 Outlet Outdoor Powerboard With Removable Garden Stake",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB34B-G.png?v=1780384085"
  },
  {
    "sku": "PB94-L",
    "title": "Arlec 4 Outlet Portable Power Block with Safety Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB94-L_CPIN007971_OL.pdf?v=1763524570",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB94-L_1.jpg?v=1763523944"
  },
  {
    "sku": "PB4UC",
    "title": "Arlec 4 Outlet Powerboard With USB Chargers",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4_Outlet_Powerboard_With_USB_Chargers_PB4UC.jpg?v=1762752505"
  },
  {
    "sku": "ARMF214",
    "title": "Arlec 4-in-1 Rechargeable Modular Utility Kit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ARFM214.jpg?v=1778829949"
  },
  {
    "sku": "PBCB4APD20-P",
    "title": "Arlec 4-Outlet Power Cube With PD20W USB-2A+2C",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PBCB4APD20-P.jpg?v=1763372460"
  },
  {
    "sku": "LVE289",
    "title": "Arlec 4-Paw Print LED Solar Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE289CPIN006229_OL.pdf?v=1754378978",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Paw_Print_LED_Solar_Light_-_Pack_of_4_LVE289_1.jpg?v=1762830315"
  },
  {
    "sku": "LVX968",
    "title": "Arlec 4.5m Inflatable Dinosaur Low Voltage",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX967_LVX968_CPIN004227-3_OL.pdf?v=1754379028",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4.5m_Inflatable_Dinosaur_Low_Voltage_LVX968.jpg?v=1762753061"
  },
  {
    "sku": "LVX995",
    "title": "Arlec 40 - 64cm Extendable Christmas Wreath Hook",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX995_CPIN00_01.pdf?v=1754379021",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_40_-_64cm_Extendable_Christmas_Wreath_Hook_LVX995.jpg?v=1762830039"
  },
  {
    "sku": "LVS19W",
    "title": "Arlec 400lm 18.2cm Solar LED Wall Light With Sensor - Black",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS19WCPIN007672_2_OL.pdf?v=1754378978",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_18.2cm_Black_400lm_Solar_LED_Wall_Light_With_Sensor_LVS19W.jpg?v=1762753429"
  },
  {
    "sku": "LVS983",
    "title": "Arlec 400lm Premium Solar LED Wall Light With Motion Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS983_CPIN007018OL.pdf?v=1754378981",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_400L_Premium_Solar_LED_Wall_Light_With_Motion_Sensor_LVS983.jpg?v=1762753408"
  },
  {
    "sku": "WL0123",
    "title": "Arlec 400lm Rechargeable LED Crank Worklight",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "LVX517",
    "title": "Arlec 40cm Batteryoperated LED Fabric Candy Ornament",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX517_CPIN008623_OL.pdf?v=1783667408",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX524_1_8641b47d-a663-4c7b-a212-05a8efac2da2.png?v=1783667022"
  },
  {
    "sku": "LVE902",
    "title": "Arlec 40cm Low Voltage Warm White LED Christmas Wreath",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE902_CPIN005430_2_OL.pdf?v=1754378981",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_40cm_Warm_White_LED_Christmas_Wreath_LVE902.jpg?v=1762830095"
  },
  {
    "sku": "APF4057WTS",
    "title": "Arlec 40cm White 5 Blade Pedestal Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/APF4057WTS_IM.pdf?v=1783935492",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/APF4057WTS.jpg?v=1783935348"
  },
  {
    "sku": "AWL2601",
    "title": "Arlec 40W 3000lm Rechargeable LED Worklight",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWL2601.png?v=1793154901"
  },
  {
    "sku": "AWL2622",
    "title": "Arlec 40W 4000lm Dual Head LED Tripod Worklight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWL2622_CPIN009338_OL.pdf?v=1791536236",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWL2622.png?v=1791536468"
  },
  {
    "sku": "AWL2316T",
    "title": "Arlec 40W 4000lm Rechargeable Dual Head LED Tripod Worklight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWL2316T.pdf?v=1791526647",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWL2316T.png?v=1791526880"
  },
  {
    "sku": "LVX1845",
    "title": "Arlec 42.5 x 84.5cm 86 LED\'s Iron WR Frame Acrylic Parachute",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1845.jpg?v=1764654516"
  },
  {
    "sku": "LVS993",
    "title": "Arlec 43lm Premium Solar LED Wall Light With Motion Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS993_CPIN007028OL.pdf?v=1754378981",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_43L_Premium_Solar_LED_Wall_Light_With_Motion_Sensor__LVS993.jpg?v=1762753440"
  },
  {
    "sku": "PEH120",
    "title": "Arlec 450W Eco Wall Heater with Tempered Glass Panel",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PEH120_CPIN004049.pdf?v=1754379037",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_450W_Eco_Wall_Heater_with_Tempered_Glass_Panel_PEH120.jpg?v=1762831847"
  },
  {
    "sku": "LVS981",
    "title": "Arlec 45cm 400lm Premium Solar LED Post Light With Motion Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS981_CPIN007016OL.pdf?v=1754378981",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_45cm_400L_Premium_Solar_LED_Post_Light_With_Motion_Sensor_LVS981.jpg?v=1762753332"
  },
  {
    "sku": "LVX526",
    "title": "Arlec 45cm Solar Acrylic Candy Cane Stake Light - Pack of 4",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX526.pdf?v=1784005521",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX526.png?v=1784005380"
  },
  {
    "sku": "CSF60O",
    "title": "Arlec 45W Oyster Fan Ceiling Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CSF60O_CPIN002252_OL.pdf?v=1754378963",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_Oyster_Fan_Ceiling_Light_CSF60O.jpg?v=1762751943"
  },
  {
    "sku": "LVX516",
    "title": "Arlec 46cm Battery Operated Candy Swirl Stake Light - Pack of 3",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX516.pdf?v=1783942712",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX516.png?v=1783942851"
  },
  {
    "sku": "LVS987",
    "title": "Arlec 48cm 400lm Premium Solar LED Post Light With Motion Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS987_CPIN007022OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_48cm_400L_Premium_Solar_LED_Post_Light_With_Motion_Sensor_LVS987.jpg?v=1762753545"
  },
  {
    "sku": "LVX954",
    "title": "Arlec 4m Low Voltage LED Greeting Santa Inflatable",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX954_CPIN004221-4OL.pdf?v=1754379027",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4m_Inflatable_Greeting_Santa_Low_Voltage_LVX954.jpg?v=1762753602"
  },
  {
    "sku": "LVX976",
    "title": "Arlec 4m Low Voltage LED Harbour Bridge Inflatable",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX976_CPIN006610.pdf?v=1754379023",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4m_Low_Voltage_LED_Inflatable_Harbour_Bridge_LVX976.jpg?v=1762830012"
  },
  {
    "sku": "TH0011",
    "title": "Arlec 5 Bar 40W Stainless Steel Heated Towel Rail",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/TH0011_CPIN003142-5.pdf?v=1754379097",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_5_Bar_40W_Stainless_Steel_Heated_Towel_Rail_TH0011.jpg?v=1762756931"
  },
  {
    "sku": "LVX1861",
    "title": "Arlec 5 Solar Powered Santa and Deer Stake Lights",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1861.jpg?v=1765340437"
  },
  {
    "sku": "LVX1862",
    "title": "Arlec 5 Solar Powered Santa and Friends Stake Lights",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1862.pdf?v=1784000853",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1862_90caf5e0-8c6d-4a23-9b5b-21a4f0b76083.jpg?v=1784000666"
  },
  {
    "sku": "LVX1863",
    "title": "Arlec 5 Solar Powered Star Stake Lights",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1863.jpg?v=1765271704"
  },
  {
    "sku": "LV1995",
    "title": "Arlec 5 Theme LED Party Projector",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV1995CPIN006184_OL.pdf?v=1754378975",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_5_Theme_LED_Party_Projector_LV1995.jpg?v=1762753211"
  },
  {
    "sku": "LVA008",
    "title": "Arlec 50 Pack Festive Ropelight Hooks",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Festive_Ropelight_Hooks_50pk_LVA008.jpg?v=1762830411"
  },
  {
    "sku": "WL0122",
    "title": "Arlec 500lm LED Tripod Worklight",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "LVS646",
    "title": "Arlec 500lm Solar Spotlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CPIN008780_OL.pdf?v=1788326811",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS646.png?v=1788326162"
  },
  {
    "sku": "LVE390",
    "title": "Arlec 50cm 12 Interactive Low Voltage Stake Lights",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE390_CPIN007251OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_12_Interactive_Stake_50cm_LV_Stake_Lights_LVE390.jpg?v=1762829641"
  },
  {
    "sku": "LVS984",
    "title": "Arlec 50cm 400lm Premium Solar LED Post Light With Motion Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS984_CPIN007019OL.pdf?v=1754378981",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_50cm_400L_Premium_Solar_LED_Post_Light_With_Motion_Sensor_LVS984_1.jpg?v=1762753306"
  },
  {
    "sku": "LVE806",
    "title": "Arlec 50cm Halloween Skeleton Stake Lights Battery Operated - Pack of 2",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE806_CPIN006615_OL.pdf?v=1754378975",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_50cm_Halloween_Skeleton_Stake_Lights_Battery_Operated_-_Pack_of_2_LVE806.jpg?v=1762753257"
  },
  {
    "sku": "LV1575",
    "title": "Arlec 50m Coloured LED Rope Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV1575_CPIN003365-6_OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_50m_Coloured_LED_Rope_Light_LV1575.jpg?v=1762751382"
  },
  {
    "sku": "LV1584",
    "title": "Arlec 50m Multicolour Low Voltage Plugin LED Rope Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV1583_Series_CPIN008617_OL_2.pdf?v=1783940101",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV1584_1.png?v=1783941162"
  },
  {
    "sku": "LV1585",
    "title": "Arlec 50m Warm White Low Voltage Plug-in LED Rope Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV1583_Series_CPIN008617_OL_2.pdf?v=1783940101",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV1585_1.png?v=1783941631"
  },
  {
    "sku": "UC551MTRHA",
    "title": "Arlec 57cm Smart Linkable RGBW Bar Light - Matter Compatible",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC551MTRHA.webp?v=1784696079"
  },
  {
    "sku": "LVX539",
    "title": "Arlec 58cm Low Voltage LED Tinsel Dog",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX539_CPIN008630_OL.pdf?v=1783681155",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX539_1_e66e5a2d-15c7-4c68-bd72-f122df9b1212.png?v=1783678170"
  },
  {
    "sku": "LVS636",
    "title": "Arlec 59cm Ember Solar LED Path Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS636_1.png?v=1793069710"
  },
  {
    "sku": "LVX982",
    "title": "Arlec 5m Battery Operated Candy Cane LED Rope Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX982_CPIN006609_OL.pdf?v=1754379024",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_5m_Battery_Operated_Candy_Cane_LED_Rope_Light_LVX982.jpg?v=1762829764"
  },
  {
    "sku": "ALD590",
    "title": "Arlec 5m Dotless CCT COB Strip Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD590.png?v=1781261158"
  },
  {
    "sku": "LVS155",
    "title": "Arlec 5m IP44 120lm Solar LED Strip Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS155.png?v=1793255642"
  },
  {
    "sku": "ALD503",
    "title": "Arlec 5m RGB LED Strip Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD503.pdf?v=1754477173",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec5mRGBLEDStripLight1.jpg?v=1765260293"
  },
  {
    "sku": "LVS935BK",
    "title": "Arlec 5W Integrated Solar Powered Sensor LED Floodlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS935BK_CPIN004237_3_OL.pdf?v=1754378981",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_5W_Integrated_Solar_Powered_Sensor_LED_Floodlight_LVS935BK_1.jpg?v=1762829573"
  },
  {
    "sku": "LVE985",
    "title": "Arlec 6 Jelly Bunny Battery String Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE985CPIN006893_OL.pdf?v=1754378981",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec6JellyBunnyBatteryStringLight_LVE985.jpg?v=1762829846"
  },
  {
    "sku": "LVE980",
    "title": "Arlec 6 Jelly Car And Bus Battery String Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE980_LVE981_LVE982_LVE983_LVE984_CPIN006888__OL.pdf?v=1754378981",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_6_Jelly_Car_And_Bus_Battery_String_Light_LVE980.jpg?v=1762829853"
  },
  {
    "sku": "LVE982",
    "title": "Arlec 6 Jelly Corgi Battery String Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE980_LVE981_LVE982_LVE983_LVE984_CPIN006888__OL.pdf?v=1754378981",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_6_Jelly_Corgi_Battery_String_Light_LVE982.jpg?v=1762829879"
  },
  {
    "sku": "LVE983",
    "title": "Arlec 6 Jelly Frenchie Battery String Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE980_LVE981_LVE982_LVE983_LVE984_CPIN006888__OL.pdf?v=1754378981",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_6_Jelly_Frenchie_Battery_String_Light_LVE983.jpg?v=1762829863"
  },
  {
    "sku": "LVE986",
    "title": "Arlec 6 Jelly Tulip Battery String Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE986_CPIN006893_OL.pdf?v=1754378981",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_6_Jelly_Tulip_Battery_String_Light_LVE986.jpg?v=1762829831"
  },
  {
    "sku": "LVE981",
    "title": "Arlec 6 Jelly Unicorn Battery String Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE980_LVE981_LVE982_LVE983_LVE984_CPIN006888__OL.pdf?v=1754378981",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_6_Jelly_Unicorn_Battery_String_Light_LVE981.jpg?v=1762829839"
  },
  {
    "sku": "LVE984",
    "title": "Arlec 6 Jungle Animal Battery String Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE980_LVE981_LVE982_LVE983_LVE984_CPIN006888__OL.pdf?v=1754378981",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_6_Jungle_Animal_Battery_String_Light_LVE984.jpg?v=1762829871"
  },
  {
    "sku": "SWP-LSBK-P2",
    "title": "Arlec 6 Outlet Black Wide Spaced Surge Protected Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/SWP-LSBK-P2.jpg?v=1791345148"
  },
  {
    "sku": "LVS305",
    "title": "Arlec 60 Micro Warm White LED Starburst Solar Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS305CPIN005355_2_OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_60_Micro_Warm_White_LED_Starburst_Solar_Light_LVS305.jpg?v=1762753294"
  },
  {
    "sku": "LVS0260",
    "title": "Arlec 60lm Solar Garden Spotlight",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS0260.png?v=1788325105"
  },
  {
    "sku": "AWL2602",
    "title": "Arlec 60W 4500lm Rechargeable LED Worklight",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWL2602.png?v=1793156125"
  },
  {
    "sku": "CSF60C",
    "title": "Arlec 60W White Clipper Ceiling Fan Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CSF60C_CPIN002252_OL.pdf?v=1754378963",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_60W_White_Clipper_Ceiling_Fan_Light_CSF60C.jpg?v=1762751886"
  },
  {
    "sku": "NL4254",
    "title": "Arlec 62 x 48.5mm White Plug In Square Motion Night Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_62_x_48.5mm_White_Plug_In_Square_Motion_Night_Light_NL4254_2.jpg?v=1762754024"
  },
  {
    "sku": "NL4067",
    "title": "Arlec 65 x 23mm White Square Motion Sensor Night Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_65_x_23mm_White_Square_Motion_Sensor_Night_Light_NL4067.jpg?v=1762754100"
  },
  {
    "sku": "WL2301",
    "title": "Arlec 650lm USB Powered Utility Light With Tripod",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/WL2301CPIN007342OL.pdf?v=1754379099",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_650lm_USB_Powered_Utility_Light_With_Tripod_WL2301.jpg?v=1762756690"
  },
  {
    "sku": "LVX1860",
    "title": "Arlec 65cm Battery Powered Christmas Tree",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1860.jpg?v=1764652273"
  },
  {
    "sku": "LVE858",
    "title": "Arlec 66 RGB LED String Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE858_1_CPCN012987_OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_RGB_LED_Star_String_Light_LVE858.jpg?v=1762829084"
  },
  {
    "sku": "NL4298",
    "title": "Arlec 67 x 22mm White Rechargeable Motion Square Night Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL4298_CPIN006620OL.pdf?v=1754379031",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_67_x_22mm_White_Rechargeable_Motion_Square_Night_Light_NL4298.jpg?v=1762753978"
  },
  {
    "sku": "NL4299",
    "title": "Arlec 67 x 22mm White Rechargeable Motion Square Night Light - Pack of 2",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL4299_CPIN006620_3OL.pdf?v=1754379039",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_67_x_22mm_White_Rechargeable_Motion_Square_Night_Light_-_Pack_of_2_NL4299.jpg?v=1762753922"
  },
  {
    "sku": "TH0037",
    "title": "Arlec 68W Stainless Steel  7 Bar Heated Towel Rail",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/TH0037_CPIN003142-5.pdf?v=1754379097",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_68W_Stainless_Steel__7_Bar_Heated_Towel_Rail_TH0037.jpg?v=1762756990"
  },
  {
    "sku": "LVX956",
    "title": "Arlec 6m Low Voltage Inflatable Greeting Santa",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX956_CPIN004227-5OL.pdf?v=1754379028",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_6m_Inflatable_Low_Voltage__Greeting_Santa_LVX956.jpg?v=1762752999"
  },
  {
    "sku": "TH0013",
    "title": "Arlec 7 Bar 65W Stainless Steel  Curved Heated Towel Rail",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/TH0013_CPIN003142copy.pdf?v=1754379098",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_7_Bar_65W_Stainless_Steel__Curved_Heated_Towel_Rail_TH0013.jpg?v=1762756948"
  },
  {
    "sku": "TH0012",
    "title": "Arlec 7 Bar 70W Stainless Steel  Curved Heated Towel Rail",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/TH0012_CPIN003142copy.pdf?v=1754379098",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_7_Bar_70W_Stainless_Steel__Curved_Heated_Towel_Rail_TH0012.jpg?v=1762756939"
  },
  {
    "sku": "LVX1857",
    "title": "Arlec 70cm Solar Powered Foldable Tinsel Sphere",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1857.jpg?v=1765274920"
  },
  {
    "sku": "LVX785",
    "title": "Arlec 71cm Low Voltage Festive Stakes - Pack of 4",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX785_CPIN007326OL.pdf?v=1754379036",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Festive_Stakes_4_Pk_71cm_Low_Voltage_LVX785.jpg?v=1762829621"
  },
  {
    "sku": "LVX788",
    "title": "Arlec 75cm Dwarf LED Festive Solar Stake",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_75cm_Festive_Solar_Stake_Led_Dwarf__LVX788_1_ac06f7a1-eef6-49e7-b496-f8c031a5b82c.jpg?v=1762830058"
  },
  {
    "sku": "NL7000",
    "title": "Arlec 7cm White Nightlight Plug in LED Motion & Day/Night Sensor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_7cm_White_Nightlight_Plug_in_LED_Motion___DayNight_Sensor_NL7000.jpg?v=1762753940"
  },
  {
    "sku": "LVS937BK",
    "title": "Arlec 7W Integrated Solar Powered Sensor LED Floodlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS937BKCPIN008010_OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_7W_Integrated_Solar_Powered_Sensor_LED_Floodlight_LVS937BK.jpg?v=1762753614"
  },
  {
    "sku": "LVS1800",
    "title": "Arlec 800lm LED Solar FLoodlight With PIR Motion Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS1800_CPIN007857_OL.pdf?v=1754378981",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_800lm_LED_Solar_Floodlight_With_PIR_Motion_Sensor_LVS1800.jpg?v=1762753318"
  },
  {
    "sku": "LVX1802",
    "title": "Arlec 80cm Black & White Inflatable PVC Bauble",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1802_CPIN006783_OL.pdf?v=1754379022",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_80cm_Black___White_Inflatable_PVC_Bauble_LVX1802.jpg?v=1762753050"
  },
  {
    "sku": "LVX1850",
    "title": "Arlec 80cm Low Voltage Christmas Star With Remote Control",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1850.jpg?v=1764651928"
  },
  {
    "sku": "LVS992",
    "title": "Arlec 80lm Premium Solar LED Wall Light With Motion Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS992_CPIN007027OL.pdf?v=1754378981",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_80L_Premium_Solar_LED_Wall_Light_With_Motion_Sensor_LVS992.jpg?v=1762753509"
  },
  {
    "sku": "DC681-1",
    "title": "Arlec 80m Plug In Wireless Door Chime",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DC681_CPIN002793-5_1.pdf?v=1754378963",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_80m_Plug_In_Wireless_Door_Chime_DC681-1.jpg?v=1762753785"
  },
  {
    "sku": "DC681-2",
    "title": "Arlec 80m Wireless Door Chime Plug In - 2 Pack",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DC681_CPIN002793-5_2.pdf?v=1754378963",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_80m_Wireless_Door_Chime_Plug_In_-_2_Pack_DC681-2.jpg?v=1762753795"
  },
  {
    "sku": "LVS997",
    "title": "Arlec 850lm Premium Solar LED Wall Light With Motion Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS997_CPIN007032OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_850L_Premium_Solar_LED_Wall_Light_With_Motion_Sensor__LVS997_defcf6f9-933e-4977-8c2c-91718a1b143b.jpg?v=1762753467"
  },
  {
    "sku": "LVX778",
    "title": "Arlec 85cm Low Voltage Acrylic Snowman Statue",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX778_CPIN007273OL.pdf?v=1754379037",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_85cm_Low_Voltage_Acrylic_Snowman_Statue_LVX778.jpg?v=1762830383"
  },
  {
    "sku": "UC552MTRHA",
    "title": "Arlec 87cm Smart Linkable RGBW Bar Light - Matter Compatible",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC552MTRHA.png?v=1781859143"
  },
  {
    "sku": "LVS177",
    "title": "Arlec 89cm Corten Bumble Bee Solar Stake Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_89cm_Corten_Bumble_Bee_Solar_Stake_Light_LVS177_2.jpg?v=1762830278"
  },
  {
    "sku": "UC451CCT",
    "title": "Arlec 8W 57cm CCT Linking Bar Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC451CCT.png?v=1787744146"
  },
  {
    "sku": "UC0122",
    "title": "Arlec 9 LED Battery Operated Under Cabinet Sensor Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC0122_CPIN002522_4_OL.pdf?v=1754379100",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_9_LED_Battery_Operated_Under_Cabinet_Sensor_Light_UC0122_de249189-d686-41f4-a7ff-f71211d627df.jpg?v=1762756356"
  },
  {
    "sku": "LVS280",
    "title": "Arlec 9.8cm Colour Changing Solar Table Jars - Assorted",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS280CPIN007370Ol.pdf?v=1754378981",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_9.8cm_Colour_Changing_Solar_Table_Jars_-_Assorted_LVS280.jpg?v=1762829735"
  },
  {
    "sku": "WL0121",
    "title": "Arlec 900lm LED Handheld Worklight",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/WL0121.png?v=1793069152"
  },
  {
    "sku": "LVS982",
    "title": "Arlec 90cm 400lm 1.8W Premium Solar LED Post Light With Motion Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS982_CPIN007017OL.pdf?v=1754378981",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_90cm_400lm_Premium_Solar_LED_Post_Light_With_Motion_Sensor_LVS982.jpg?v=1762753680"
  },
  {
    "sku": "LVS985",
    "title": "Arlec 90cm 400lm 2.8W Premium Solar LED Post Light With Motion Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS985_CPIN007020OL.pdf?v=1754378981",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_90cm_400lm_Premium_Solar_LED_Post_Light_With_Motion_Sensor__LVS985.jpg?v=1762753669"
  },
  {
    "sku": "LVX1841",
    "title": "Arlec 90cm Low Voltage LED Wreath with Kiwi",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1841_CPIN007884_OL.pdf?v=1754379028",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_90cm_Low_Voltage_LED_Wreath_with_Kiwi_LVX1841.jpg?v=1762829922"
  },
  {
    "sku": "AWL2625",
    "title": "Arlec 90W 10,000lm LED Tripod Worklight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWL2625.pdf?v=1791536582",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWL2625.png?v=1791537017"
  },
  {
    "sku": "ATF9126BR",
    "title": "Arlec 91cm Tower Fan With Remote",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ATF9126BR.png?v=1783934305"
  },
  {
    "sku": "ATF9125R",
    "title": "Arlec 91cm Tower Fan With Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ATF9125R.pdf?v=1763620253",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ATF9125R.jpg?v=1763374190"
  },
  {
    "sku": "LVS176",
    "title": "Arlec 92cm Corten Butterfly Solar Stake Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_92cm_Corten_Butterfly_Solar_Stake_Light_LVS176.jpg?v=1762830291"
  },
  {
    "sku": "LVS175",
    "title": "Arlec 92cm Ladybug Solar Stake Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_92cm_Ladybug_Solar_Stake_Light_LVS175.jpg?v=1762830203"
  },
  {
    "sku": "DCF1242BKL",
    "title": "Arlec AER Matte Black 4- Blade120cm DC Ceiling Fan with Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DCF1242BKL_CPIN006326_2_OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_AER_Matte_Black_4-_Blade120cm_DC_Ceiling_Fan_DCF1242BKL.jpg?v=1762751969"
  },
  {
    "sku": "DCF1242WL",
    "title": "Arlec Aer White Matte 4-Blade 120cm DC Ceiling Fan with LED Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DCF1242WL_CPIN006326_2_OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Are_White_Matte_4-Blade_120cm_DC_Ceiling_Fan_with_LED_Light_DCF1242WL.jpg?v=1762752019"
  },
  {
    "sku": "BA-2C",
    "title": "Arlec Alkaline Battery - 2 X C",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Alkaline_Battery_-_2_X_C_BA-2C.jpg?v=1762755228"
  },
  {
    "sku": "BA-2D",
    "title": "Arlec Alkaline Battery - 2 X D",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Alkaline_Battery_-_2_X_D_BA-2D.jpg?v=1762755240"
  },
  {
    "sku": "BA-4AA",
    "title": "Arlec Alkaline Battery - 4 X AA",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Alkaline_Battery_-_4_X_AA_BA-4AA.jpg?v=1762755250"
  },
  {
    "sku": "BA-12AAA",
    "title": "Arlec Alkaline Battery - BA-12AAA",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ArlecAlkalineBattery_BA-12AAA.jpg?v=1762755289"
  },
  {
    "sku": "BE-2C",
    "title": "Arlec Alkaline Extra Heavy Duty Battery - BE-2C",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Alkaline_Extra_Heavy_Duty_Battery_-_BE-2C_BE-2C.jpg?v=1762755332"
  },
  {
    "sku": "BE-2D",
    "title": "Arlec Alkaline Extra Heavy Duty Battery - BE-2D",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Alkaline_Extra_Heavy_Duty_Battery_BE-2D.jpg?v=1762755342"
  },
  {
    "sku": "BE-4AA",
    "title": "Arlec Alkaline Extra Heavy Duty Battery - BE-4AA",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Alkaline_Extra_Heavy_Duty_Battery_BE-4AA.jpg?v=1762755350"
  },
  {
    "sku": "BE-4AAA",
    "title": "Arlec Alkaline Extra Heavy Duty Battery - BE-4AAA",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Alkaline_Extra_Heavy_Duty_Battery_BE-4AAA.jpg?v=1762755359"
  },
  {
    "sku": "LVE857",
    "title": "Arlec Animated Zombie Hand",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE857_CPIN007885_OL.pdf?v=1754378974",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Animated_Zombie_Hand_LVE857.jpg?v=1762829744"
  },
  {
    "sku": "ABL377BK",
    "title": "Arlec Ashton Black Wall Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CPIN003775_3_OL.pdf?v=1792389535",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL377BK.jpg?v=1792390831"
  },
  {
    "sku": "SH143DS",
    "title": "Arlec Automatic Dust Collector Accessory for SH142HA Robotic Vacuum",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/SH143DSCPIN007133_OL.pdf?v=1754379107",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Automatic_Dust_Collector_Accessory_for_SH142HA_Robotic_Vacuum_SH143DS.jpg?v=1762756338"
  },
  {
    "sku": "NL4246",
    "title": "Arlec Bar Motion Sensor Nightlight",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Bar_Motion_Sensor_Nightlight__NL4246.jpg?v=1762754035"
  },
  {
    "sku": "LVX1848",
    "title": "Arlec Battery Operated LED Acrylic Deer",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1848.jpg?v=1765274124"
  },
  {
    "sku": "NL0022",
    "title": "Arlec Battery Operated PIR LED Night Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL0022_GBIN003598.pdf?v=1754379023",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Battery_Operated_PIR_LED_Night_Light_NL0022.jpg?v=1762830581"
  },
  {
    "sku": "LVX540",
    "title": "Arlec Battery Operated Star Icicle Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX540_CPIN00008627_OL.pdf?v=1783653650",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX540_1.png?v=1783663089"
  },
  {
    "sku": "LVX529",
    "title": "Arlec Battery Operated Star Stake Light - Pack of 3",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX529.pdf?v=1783942504",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX529_1.png?v=1783942132"
  },
  {
    "sku": "UC524",
    "title": "Arlec Battery Operated Under Cabinet Bar Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "LVX1773",
    "title": "Arlec Battery Powered LED Glitter Fabric Bow",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Battery_Powered_LED_Glitter_Fabric_Bow_LVX1773.jpg?v=1762753161"
  },
  {
    "sku": "UC525",
    "title": "Arlec Battery-Operated Magnet Mount Motion Sensor Bar Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC525.png?v=1781243806"
  },
  {
    "sku": "AT0057",
    "title": "Arlec Black & Yellow 450lm Rechargeable Work Light Torch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_450lm_Rechargeable_Work_Light_Torch_AT0057.jpg?v=1762755114"
  },
  {
    "sku": "LVS649",
    "title": "Arlec Black 100lm Solar Pathlight with CCT",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS649_IM.pdf?v=1793256125",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS649.png?v=1793256139"
  },
  {
    "sku": "ASLR100M",
    "title": "Arlec Black 100W Solar Portable Blanket Kit with MPPT Controller",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ASLR100M_CPIN007501OL.pdf?v=1754378926",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_100W_Solar_Portable_Blanket_with_MPPT_Controller_ASLR100M.jpg?v=1762755056"
  },
  {
    "sku": "ATF1006HA",
    "title": "Arlec Black 102cm Grid Connect Smart DC Tower Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ATF1006HACPIN004673.pdf?v=1754378920",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_102cm_Black_Smart_Tower_Fan_With_Grid_Connect_ATF1006HA.jpg?v=1762830985"
  },
  {
    "sku": "ATDF4023BK",
    "title": "Arlec Black 102cm Tower Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ATDF4023BKCPIN007421-2OL.pdf?v=1754378926",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Black_102cm_Tower_Fan_ATDF4023BK.jpg?v=1762830964"
  },
  {
    "sku": "WL0007",
    "title": "Arlec Black 10W 700lm LED Rechargeable Work Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/WL0007_CPIN004057_2_OL.pdf?v=1754379101",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_10W_700lm_LED_Rechargeable_Work_Light_WL0007.jpg?v=1762756513"
  },
  {
    "sku": "FL111RV",
    "title": "Arlec Black 10W DIY LED Fixed Flood Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/FL111RV_IM.pdf?v=1754378963",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_10W_LED_Fixed_Floodlight_FL111RV.jpg?v=1762755538"
  },
  {
    "sku": "FL351",
    "title": "Arlec Black 10W DIY Plug-In LED Security Portable Flood Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/FL351CPCN9813_2_OL.pdf?v=1754378966",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec-10W-LED-DIY-Security-Floodlight_FL351.jpg?v=1762755572"
  },
  {
    "sku": "ABL015HA",
    "title": "Arlec Black 10W Grid Connect Smart LED Bunker Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL015HACPIN004641_2_OL.pdf?v=1754378915",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_10W_Grid_Connect_Smart_LED_Bunker_Light_ABL015HA.jpg?v=1762754251"
  },
  {
    "sku": "AWL2313",
    "title": "Arlec Black 10W LED Rechargeable Work Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWL2313_CPIN007391_OL.pdf?v=1754378927",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_10W_LED_Rechargeable_Work_Light_AWL2313.jpg?v=1762755198"
  },
  {
    "sku": "ASLR2310",
    "title": "Arlec Black 10W Solar Charger with USB Outlet",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ASLR2310CPIN007503_3_OL.pdf?v=1754378924",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_10W_Solar_Charger_with_USB_Outlet_ASLR2310.jpg?v=1762755081"
  },
  {
    "sku": "ATF1106RWH",
    "title": "Arlec Black 110cm 40W Tower Fan with Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ATF1106RWH_CPIN000000.pdf?v=1754378919",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_110CM_Tower_Fan_With_Remote_ATF1106RWH.jpg?v=1762832159"
  },
  {
    "sku": "ATF4601HA",
    "title": "Arlec Black 117cm Grid Connect Smart Digital  Tower Fan with Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ATF4601HA_CPIN006227_OL.pdf?v=1754378926",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_117cm_Grid_Connect_Smart_Aurora_Digital_Tower_Fan_ATF4601HA.jpg?v=1762831013"
  },
  {
    "sku": "ATF4602BHA",
    "title": "Arlec Black 118cm Grid Connect Smart Digital Tower Fan with Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ATF4602BHA_CPIN006807_OL.pdf?v=1754378926",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Black_118cm_Grid_Connect_Smart_Digital__Tower_Fan_with_Remote_Control_ATF4602BHA.jpg?v=1762755145"
  },
  {
    "sku": "ATF4603B",
    "title": "Arlec Black 118cm Tower Fan with Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ATF4603B-CPIN006166_2OL.pdf?v=1754378927",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Black_118cm_Tower_Fan_with_Remote_Control_ATF4603B.jpg?v=1762831026"
  },
  {
    "sku": "SCF120",
    "title": "Arlec Black 120cm 4 Blade AC Solar Ceiling Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/SCF120_CPIN006365OL.pdf?v=1754379102",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_120cm_4_Blade_AC_Solar_Ceiling_Fan_SCF120.jpg?v=1762756280"
  },
  {
    "sku": "MAL612",
    "title": "Arlec Black 12W LED Slimline Security Sensor Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL612CPIN007697_OL.pdf?v=1754379034",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_12W_LED_Slimline_Security_Sensor_Light_MAL612.jpg?v=1762755908"
  },
  {
    "sku": "MAL800",
    "title": "Arlec Black 13W Solar DIY LED Security Sensor Flood Light with Movement Activation",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL800CPIN005385_OL.pdf?v=1754379031",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Solar_Movement_Activated_Floodlight_MAL800_1.jpg?v=1762755959"
  },
  {
    "sku": "OCH207TBK",
    "title": "Arlec Black 1500W 7 Fin Oil Heater With 24 Hour Timer",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/OCH207TBK_CPIN005033.pdf?v=1754379033",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Black_1500W_7_Fin_Oil_Heater_With_24_Hour_Timer_OCH207TBK.jpg?v=1762756030"
  },
  {
    "sku": "FL011",
    "title": "Arlec Black 150W Compact Twin Security Flood Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/FL011_CPIN002317_5_OL.pdf?v=1754378969",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Black_150W_Compact_Twin_Security_Flood_Light_FL011_2_6c79e6e8-166f-4ae6-b6b2-7ea6e0dd4b09.jpg?v=1762755506"
  },
  {
    "sku": "FL200",
    "title": "Arlec Black 150W DIY Portable Security Flood Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/FL200_CPIN003841_2_OL.pdf?v=1754378966",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_150W_Portable_Security_Flood_Light_FL200.jpg?v=1762755547"
  },
  {
    "sku": "BPEL15",
    "title": "Arlec Black 15m Piggy Back Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/BPEL15.jpg?v=1762752091"
  },
  {
    "sku": "FL221RV",
    "title": "Arlec Black 15W DIY LED Portable Flood Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/FL221RV_CPIN004909_2_OL.pdf?v=1754378966",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_15W_LED_DIY_Portable_Flood_Light_FL221RV.jpg?v=1762755554"
  },
  {
    "sku": "MAL318RV",
    "title": "Arlec Black 15W LED Security Sensor Floodlight with Movement Activation",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL318RV_CPIN004950_3_OL.pdf?v=1754379035",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_15W_LED_Security_Sensor_Floodlight_MAL318RV.jpg?v=1762755829"
  },
  {
    "sku": "FL225",
    "title": "Arlec Black 15W Plug-In LED Portable Flood Light with Clamp",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/FL225_CPIN004947_3_OL.pdf?v=1754378966",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_15W_DIY_Portable_LED_Floodlight_With_Clamp_FL225.jpg?v=1762755565"
  },
  {
    "sku": "MAL802HA",
    "title": "Arlec Black 16W Smart Security Light with Movement Activated Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL802HA_CPIN005638-4OL.pdf?v=1754379036",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_15W_Security_Floodlight_With_Movement_Activated_Sensor_MAL802HA.jpg?v=1762831327"
  },
  {
    "sku": "MAL081",
    "title": "Arlec Black 19W LED Security Sensor Flood Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL081CPIN007693.pdf?v=1754379028",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_DIY_Twinhead_Tricolour_LED_Security_Sensor_Floodlight_MAL081.jpg?v=1762755773"
  },
  {
    "sku": "PB32-G",
    "title": "Arlec Black 2 Outlet Outdoor Powerboard with Removable Garden Stake",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2_Outlet_Outdoor_Powerboard_with_Removable_Garden_Stake_PB32-G.jpg?v=1762829310"
  },
  {
    "sku": "MAL114",
    "title": "Arlec Black 2 x 150W Globes Security Sensor Flood Light with Movement Activation",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL114_CPIN002313_10_OL.pdf?v=1754379035",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Enodia_150W_Twin_Security_Flood_Light_With_Sensor_MAL114.jpg?v=1762755783"
  },
  {
    "sku": "PC900BK",
    "title": "Arlec Black 2-Hour Compact Countdown Timer",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Black_2_Hour_Compact_Countdown_Timer_PC900BK.jpg?v=1762756222"
  },
  {
    "sku": "ASLR200M",
    "title": "Arlec Black 200W Solar Portable Blanket Kit with MPPT Controller",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ASLR200M_CPIN007501_OL.pdf?v=1754378927",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_200W_Solar_Portable_Blanket_with_MPPT_Controller_ASLR200M_1.jpg?v=1762755069"
  },
  {
    "sku": "GEL20",
    "title": "Arlec Black 20m Rubber Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_20m_10A_Rubber_Extension_Lead_GEL20.jpg?v=1762829257"
  },
  {
    "sku": "WL0008",
    "title": "Arlec Black 20W 1400lm Rechargeable LED Work Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/WL0008_CPIN004086_2_OL.pdf?v=1754379101",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_20W_1400lm_Rechargeable_LED_Work_Light_WL0008_29403b2c-bf58-474f-8a9a-2e304aade90b.jpg?v=1762756523"
  },
  {
    "sku": "FL352",
    "title": "Arlec Black 20W DIY Plug-In LED Security Portable Flood Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/FL352_CPIN005108_3_OL.pdf?v=1754378971",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_20W_LED_D.I.Y._Security_Floodlight_FL352.jpg?v=1762755580"
  },
  {
    "sku": "MAL352",
    "title": "Arlec Black 20W LED DIY Security Sensor Flood Light with Movement Activation",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL352HACPIN007652_OL.pdf?v=1754379031",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_20W_LED_DIY_Security_Floodlight_With_PIR_Sensor_MAL352.jpg?v=1762755849"
  },
  {
    "sku": "AWL2314",
    "title": "Arlec Black 20W LED Rechargeable Work Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWL2314_CPIN007389-2_OL.pdf?v=1754378928",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_20W_LED_Rechargeable_Work_Light_AWL2314.jpg?v=1762755208"
  },
  {
    "sku": "MAL300RV",
    "title": "Arlec Black 20W Security Sensor Flood Light with Movement Activation",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL300RV_CPIN003106_2.pdf?v=1754379028",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_20W_LED_Security_Sensor_Twin_Flood_Light_MAL300RV.jpg?v=1762831259"
  },
  {
    "sku": "ASLR2320",
    "title": "Arlec Black 20W Solar Charger with USB Outlet",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ASLR2320.pdf?v=1754454687",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_20W_Solar_Charger_with_USB_Outlet_ASLR2320.jpg?v=1762755094"
  },
  {
    "sku": "MAL298",
    "title": "Arlec Black 20W Twin Head Hardwired Floodlight With Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL298_CPIN007410_OL.pdf?v=1754379037",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Black_20W_Twin_Head_Hardwired_Floodlight_With_Sensor_MAL298.jpg?v=1762755800"
  },
  {
    "sku": "CH235BK",
    "title": "Arlec Black 2300W Convection Heater With Remote Control And Fan Boost",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CH235BK_CPIN005091.pdf?v=1754378921",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2300W_Convection_Heater_With_Remote_Control_And_Fan_Boost_CH235BK_1.jpg?v=1762832085"
  },
  {
    "sku": "PC627BK-P",
    "title": "Arlec Black 24-Hour Compact Mechanical Timer",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PC627BK-P.jpg?v=1787901134"
  },
  {
    "sku": "PC44BK",
    "title": "Arlec Black 24-Hour Heavy-Duty Outdoor Mechanical Timer",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PC44BK_CPIN005591-3_OL.pdf?v=1754379037",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Black_24_Hour_Weatherproof_Timer_PC44BK.jpg?v=1762756109"
  },
  {
    "sku": "PC726BK-2PK",
    "title": "Arlec Black 24-Hour Mechanical Timer - 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_24_Hour_Mechanical_Timer_PC726BK-2PK_1.jpg?v=1763448757"
  },
  {
    "sku": "PC726BK-2PK3",
    "title": "Arlec Black 24-Hour Slimline Mechanical Timer - Twin Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "PC726BK-2PK2",
    "title": "Arlec Black 24-Hour Slimline Mechanical Timer - Twin Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_24_Hour_Mechanical_Timer_PC726BK-2PK_357d4297-4adc-4527-983f-ce38bd5bc175.jpg?v=1787901786"
  },
  {
    "sku": "PC627BK",
    "title": "Arlec Black 24-HourCompact Mechanical Timer",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PC627_CPIN003349-5.pdf?v=1754379037",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_24_Hour_Compact_Mechanical_Timer_PC627BK.jpg?v=1762756175"
  },
  {
    "sku": "FH810BK",
    "title": "Arlec Black 2400W Fan Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/FH810BKCPIN005031v2.pdf?v=1754378964",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2400W_Fan_Heater_FH810BK.jpg?v=1762832123"
  },
  {
    "sku": "FL352HA",
    "title": "Arlec Black 24W DIY Plug-In LED Security Portable Flood Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/FL352HA_CPIN007762_OL.pdf?v=1754378974",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Black_24W_DIY_Plug-In_LED_Security_Portable_Flood_Light_FL352HA.jpg?v=1762755603"
  },
  {
    "sku": "UC661",
    "title": "Arlec Black 26cm CCT Ring Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC661.pdf?v=1754477174",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC661HERO_67bf3260-125c-4508-8d5d-754c4291c2ab.png?v=1765257350"
  },
  {
    "sku": "ALD261HA",
    "title": "Arlec Black 2m Grid Connect Smart USB Strip Light with Bluetooth",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD261HA.pdf?v=1761633272",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2m_Grid_Connect_Smart_USB_Strip_Light_ALD261HA.jpg?v=1762754662"
  },
  {
    "sku": "BPEL2",
    "title": "Arlec Black 2m Piggy Back Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2m_Black_Piggyback_Extension_Lead_-_2m_BPEL2.jpg?v=1762752076"
  },
  {
    "sku": "AWL2314T",
    "title": "Arlec Black 2X20W LED Rechargeable Work Light With Tripod",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWL2314T_CPIN007389-2_OL.pdf?v=1754378928",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2X20W_LED_Rechargeable_Work_Light_With_Tripod_AWL2314T.jpg?v=1762755218"
  },
  {
    "sku": "PA1123BKHA",
    "title": "Arlec Black 3.3kW Smart Portable Aircon",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PA1123BKHACPIN007483_4_OL.pdf?v=1754379043",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Black_3.3kW_Smart_Portable_Aircon_PA1123BKHA.jpg?v=1762756061"
  },
  {
    "sku": "ASFL3000",
    "title": "Arlec Black 3000lm Solar LED Floodlight with PIR Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ASFL3000_IM.pdf?v=1790832945",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ASFL3000.png?v=1790829889"
  },
  {
    "sku": "FL353",
    "title": "Arlec Black 30W DIY Plug-In LED Security Portable Flood Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/FL353_CPIN005108_3_OL.pdf?v=1754378971",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_30W_LED_DIY_Security_Floodlight_FL353.jpg?v=1762755588"
  },
  {
    "sku": "MAL298P",
    "title": "Arlec Black 30W DIY Twin LED PAR38 Security Flood Light With PIR Motion Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL298P_CPIN007412_OL.pdf?v=1754379038",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_30W_DIY_Twin_LED_PAR38_Security_Flood_Light_With_PIR_Motion_Sensor_MAL298P.jpg?v=1762755811"
  },
  {
    "sku": "MAL326RV",
    "title": "Arlec Black 30W LED DIY Security Sensor Flood Light with Movement Activation",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL326RV_CPIN004928.pdf?v=1754379029",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_30W_LED_Security_Sensor_Twin_Flood_Light_MAL326RV.jpg?v=1762831278"
  },
  {
    "sku": "MAL296",
    "title": "Arlec Black 30W Triple Head LED Security Flood Light With PIR Motion Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL294_MAL295_MAL296CPIN007639_2_OL.pdf?v=1754379036",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_30W_Triple_Head_LED_Security_Flood_Light_With_PIR_Motion_Sensor_MAL296.jpg?v=1762755793"
  },
  {
    "sku": "AT0501",
    "title": "Arlec Black 3D Zoomable Aluminum Torch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_280lm_3D_Zoomable_Aluminium_Torch_AT0501.jpg?v=1762830955"
  },
  {
    "sku": "PB45-2LBK",
    "title": "Arlec Black 3m 4-Outlet Powerboard with Surge Protection & On/Off Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4_Outlet_Black_Surge_Protected_Powerboard_PB45-2LBK.jpg?v=1762751390"
  },
  {
    "sku": "AEL3BK2PK-P",
    "title": "Arlec Black 3m Domestic Extension Lead-2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_3m_Black_Extension_Lead_-_2_Pack_AEL3BK2PK-P.jpg?v=1762752070"
  },
  {
    "sku": "PB44BK2PK-P",
    "title": "Arlec Black 4 Outlet Individually Switched Powerboard - Twin Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB44BK2PK-P_b67e9a48-4b44-4cfd-bbef-b214465b0f81.jpg?v=1780379431"
  },
  {
    "sku": "PB4PPBK-P2",
    "title": "Arlec Black 4 Outlet Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB4PPBK-P2.jpg?v=1763372041"
  },
  {
    "sku": "PB34BUPD",
    "title": "Arlec Black 4 Outlets with USB A&C Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB34BUPD.jpg?v=1787825696"
  },
  {
    "sku": "PB34-G",
    "title": "Arlec Black 4-Outlet Outdoor Powerboard with Removable Garden Stake",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB34-GCPIN007968_OL.pdf?v=1754379035",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4_Outlet_Outdoor_Powerboard_with_Removable_Garden_Stake_PB34-G.jpg?v=1762831384"
  },
  {
    "sku": "PB34T-G",
    "title": "Arlec Black 4-Outlet Outdoor Powerboard with Timer and Removable Garden Stake",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB34T-GCPIN007973_OL.pdf?v=1754379036",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4_Outlet_Outdoor_Powerboard_with_Timer_and_Removable_Garden_Stake_PB34T-G_1.jpg?v=1762829332"
  },
  {
    "sku": "PB4PPBK-P",
    "title": "Arlec Black 4-Outlet Overload Protected Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4_Outlet_Powerboard_-_Black_PB4PPBK-P.jpg?v=1762752489"
  },
  {
    "sku": "PB46-BK",
    "title": "Arlec Black 4-Outlet Overload Protected Powerboard with USB Charger Built in 2 USB Charging Ports",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Individually_Switched_4_Outlet_Surge_Protected_Power_Board_With_2_USB_Charger_PB46-BK.jpg?v=1762829377"
  },
  {
    "sku": "PB44OW-BK",
    "title": "Arlec Black 4-Outlet Safety Overload Warning Alarm Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4_Outlet_Black_Individually_Switched_Powerboard_with_Safety_Overload_Warning_Alarm_PB44OW-BK.jpg?v=1762752603"
  },
  {
    "sku": "PB45PDBK-P",
    "title": "Arlec Black 4-Outlet Surge Powerboard with PD20W Fast  Rapid Charging USB",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4_Outlet_Surge_Powerboard_With_Rapid_Charging_USB_PB45PDBK-P.jpg?v=1762829128"
  },
  {
    "sku": "PB4KS-BK",
    "title": "Arlec Black 4-Outlet Surge Protected Powerboard with Master Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4_Outlet_Surge_Powerboard_Black_PB4KS-BK.jpg?v=1762752435"
  },
  {
    "sku": "PB4UCK-BK",
    "title": "Arlec Black 4-Outlet Surge Protected Powerboard with USB A&C Charger and Master Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Black_4-Outlet_Surge_Protected_Powerboard_with_USB_A_C_Charger_and_Master_Switch_PB4UCK-BK.jpg?v=1762752513"
  },
  {
    "sku": "APF4022BR",
    "title": "Arlec Black 40cm 3-Blade Pedestal Fan with Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/APF4022BR_CPIN006788OL.pdf?v=1754378926",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_40cm_Black_3_Blade_Pedestal_Fan_With_Remote_APF4022BR.jpg?v=1762830878"
  },
  {
    "sku": "APDC405B",
    "title": "Arlec Black 40cm 5-Blade DC Pedestal Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/APDC405B_CPIN006192OL.pdf?v=1754378921",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_40cm_DC_Pedestal_Fan_APDC405B.jpg?v=1762831436"
  },
  {
    "sku": "APDC402B",
    "title": "Arlec Black 40cm 5-Blade DC Pedestal Fan (APDC402B)",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/APDC402BCPIN005417.pdf?v=1754378914",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_40cm_Pedestal_DC_Fan_APDC402B.jpg?v=1762831425"
  },
  {
    "sku": "APDC406B",
    "title": "Arlec Black 40cm 5-Blade DC Pedestal Fan with Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/APDC406BCPIN007952_OL.pdf?v=1754378923",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_40cm_DC_Pedestal_Fan_with_Remote_Control_APDC406B_2.jpg?v=1762830842"
  },
  {
    "sku": "APF407BR",
    "title": "Arlec Black 40cm 5-Blade Pedestal Fan with Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/APF407BR_CPIN004629_2.pdf?v=1754378914",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_45cm_Pedestal_Fan_APF407BR.jpg?v=1762830871"
  },
  {
    "sku": "APF405223BK",
    "title": "Arlec Black 40cm 5-Blade Pesdestal Fan with Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/APF405223BKCPIN007419-2_OL.pdf?v=1754378926",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_40cm_Pedestal_Fan_With_Remote_APF405223BK.jpg?v=1762830909"
  },
  {
    "sku": "AWF205",
    "title": "Arlec Black 40cm 5-Blade Wall Fan with Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWF205_CPIN004217.pdf?v=1754378926",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_40cm_Black_Wall_Fan_With_Remote__Timer_AWF205_1.jpg?v=1762831065"
  },
  {
    "sku": "AWF40524R",
    "title": "Arlec Black 40cm 5-Blade Wall Fan with Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWF40524R_CPIN007908_OL.pdf?v=1754378926",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_40cm_Wall_Fan_With_Remote_AWF40524R.jpg?v=1762755167"
  },
  {
    "sku": "AWF4058R",
    "title": "Arlec Black 40cm 5-Blade Wall Fan with Remote Control (AWF4058R)",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWF4058R_CPIN006246-2OL.pdf?v=1754378923",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_40cm_Black_Remote_Controllable_Wall_Fan_AWF4058R_webp.jpg?v=1762831078"
  },
  {
    "sku": "AFDC4501HA",
    "title": "Arlec Black 45cm 18-Blade Grid Connect Smart DC Floor Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AFDC4501HACPIN006245_2OL.pdf?v=1754378928",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_45cm_Black_Grid_Connect_Smart_DC_Floor_Fan_AFDC4501HA.jpg?v=1762754584"
  },
  {
    "sku": "AWDC001HA",
    "title": "Arlec Black 45cm Grid Connect Smart DC Wall Fan with Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWDC001HA_CPIN004666_5_OL.pdf?v=1754378926",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_45cm_Grid_Connect_Smart_DC_Wall_Fan_AWDC001HA.jpg?v=1762831054"
  },
  {
    "sku": "APF5023TS",
    "title": "Arlec Black 50cm 3-Blade Pedestal Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/APF5023CPIN007627OL.pdf?v=1754378927",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_50cm_Black_Pedestal_Fan_APF5023.jpg?v=1762830894"
  },
  {
    "sku": "AFF107",
    "title": "Arlec Black 50cm 5-Black High Velocity Floor Fan with Carry Handle",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AFF107_CPIN003386.pdf?v=1754378912",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_50cm_Harrier_Floor_Fan_AFF107.jpg?v=1762830720"
  },
  {
    "sku": "ABF2023BK",
    "title": "Arlec Black 50cm 5-Blade  Box Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABF2023BKCPIN007406_OL.pdf?v=1754378919",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_50cm_High_Velocity_Box_Fan_ABF2023BK.jpg?v=1762830628"
  },
  {
    "sku": "ABF2022",
    "title": "Arlec Black 50cm 5-Blade High Velocity Box Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABF2022CPIN006792OL.pdf?v=1754378919",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_50cm_Black_High_Velocity_Box_Fan_ABF2022.jpg?v=1762830603"
  },
  {
    "sku": "ABF200",
    "title": "Arlec Black 50cm 5-Blade High Velocity Floor Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABF200_CPIN007897_OL.pdf?v=1754378926",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_50cm_High_Velocity_Box_Fan_ABF200.jpg?v=1762754232"
  },
  {
    "sku": "FL355",
    "title": "Arlec Black 50W DIY Plug-In LED Security Portable Flood Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/FL355_CPIN005108_3_OL.pdf?v=1754378971",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_50W_LED_DIY_Security_Floodlight_FL355_e59d5915-0b2c-4394-aad1-547d24cd1f02.jpg?v=1762755596"
  },
  {
    "sku": "BPEL5",
    "title": "Arlec Black 5m Piggy Back Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_5m_Black_Piggyback_Extension_Lead_BPEL5.jpg?v=1762752083"
  },
  {
    "sku": "WL5",
    "title": "Arlec Black 5W LED Recharge Handheld Inspection Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/WL5CPIN006438_OL.pdf?v=1754379104",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_5W_LED_Recharge_Handheld_Inspection_Light_WL5.jpg?v=1762756505"
  },
  {
    "sku": "PB65L-BK",
    "title": "Arlec Black 6-Outlet Individually Switched Powerboard with Surge Protector",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Black_Individually_Switched_Surge_Protected_6_Outlet_Powerboard_PB65L-BK.png?v=1762829401"
  },
  {
    "sku": "PB6PP2PK-BK",
    "title": "Arlec Black 6-Outlet Powerboard - 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Black_6_Outlet_Powerboard_-_2_Pack_PB6PP2PK-BK.jpg?v=1762752529"
  },
  {
    "sku": "SWP-LSBK-K",
    "title": "Arlec Black 6-Outlet Surge Protect Powerboard with 3 Wide Spaced Outlets",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Black_6-Outlet_Surge_Protect_Powerboard_with_3_Wide_Spaced_Outlets_SWP-LSBK-K.jpg?v=1762751399"
  },
  {
    "sku": "MAL634",
    "title": "Arlec Black 6.5W LED Spotlight With Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL634_CPIN004020_3.pdf?v=1754379025",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_6.5W_LED_Spotlight_With_Sensor_MAL634.jpg?v=1762755935"
  },
  {
    "sku": "AIDF60B",
    "title": "Arlec Black 60cm 3-Blade Industrial Drum Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AIDF60BCPIN006237OL.pdf?v=1754378922",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_60cm_Black_Industrial_Drum_Fan_AIDF60B.jpg?v=1762830752"
  },
  {
    "sku": "WL67",
    "title": "Arlec Black 60W Handheld Work Light With 5m Lead",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/WL67CPIN003975.pdf?v=1754379095",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_60W_Handheld_Work_Light_With_5m_Lead_WL67.jpg?v=1762756576"
  },
  {
    "sku": "AIF265123BK",
    "title": "Arlec Black 70cm 5-Blade Pedestal Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AIF265123BK_CPIN007394_3_OL.pdf?v=1754378922",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_70cm_Industrial_Pedestal_Fan_AIF265123BK.jpg?v=1762754613"
  },
  {
    "sku": "AWF753023R",
    "title": "Arlec Black 75cm 3-Blade Industrial Wall Fan with Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWF753023R_CPIN007405OL.pdf?v=1754378927",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_75cm_Industrial_Wall_Fan_With_Remote_Control_AWF753023R_2.jpg?v=1762755176"
  },
  {
    "sku": "AIF7530B",
    "title": "Arlec Black 75cm 3-Blade Pedestal Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AIF7530B_CPIN006241_2OL.pdf?v=1754378924",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_75cm_Black_3_Blade_Industrial_Pedestal_Fan_AIF7530B.jpg?v=1762754605"
  },
  {
    "sku": "WL0120",
    "title": "Arlec Black 8.5W 700lm LED Handheld Inspection Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/WL0120_CPIN005656-2_OL.pdf?v=1754379098",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_8.5W_700lm_LED_Handheld_Inspection_Light_WL0120_1.jpg?v=1762756603"
  },
  {
    "sku": "AIDF9024",
    "title": "Arlec Black 90cm 3-Blade Industrial Drum Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AIDF9024_CPIN007929_OL.pdf?v=1754378924",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_90cm_Black_Drum_Industrial_Fan_AIDF9024_1.jpg?v=1762754595"
  },
  {
    "sku": "ATF35223BK",
    "title": "Arlec Black 91cm 55W Tower Fan with Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ATF35223BK.pdf?v=1754454441",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_91cm_Tower_Fan_With_Remote_ATF35223BK.jpg?v=1762831035"
  },
  {
    "sku": "SB902",
    "title": "Arlec Black 9L Sensor Bin",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/SB902.png?v=1784187738"
  },
  {
    "sku": "SH122AC",
    "title": "Arlec Black Accessory Kit for Arlec SH122HA Robotic Vacuum",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/SH122AC_CPIN006861_OL.pdf?v=1754379104",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Accessory_Kit_for_SH122HA_Robotic_Vacuum_SH122AC.jpg?v=1762756288"
  },
  {
    "sku": "ABL3910BK",
    "title": "Arlec Black Apex 10W Oval Led Bunker",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL3910WH_IM.pdf?v=1790832947",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL3910BK.png?v=1790674810"
  },
  {
    "sku": "ABL004",
    "title": "Arlec Black Ashley Exterior Wall Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL004_IM.pdf?v=1790832943",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL004.jpg?v=1790831732"
  },
  {
    "sku": "ABL1159",
    "title": "Arlec Black Ashley II Decorative Wall Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL1159CPIN007634_OL.pdf?v=1754378915",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Ashley_II_Exterior_Wall_Light_ABL1159_1.jpg?v=1762754540"
  },
  {
    "sku": "LVS635",
    "title": "Arlec Black Aurora Solar LED Path Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS635.png?v=1793253800"
  },
  {
    "sku": "MAL855",
    "title": "Arlec Black Battery Operated Wireless Interconnectable Sensor Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL855_CPIN007457_2_OL.pdf?v=1754379036",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Black_Battery_Operated_Wireless_Interconnectable_Sensor_Light_MAL855.jpg?v=1762831339"
  },
  {
    "sku": "BAT01",
    "title": "Arlec Black Battery Tester",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Battery_Tester_BAT01.jpg?v=1762755308"
  },
  {
    "sku": "ABL390CH",
    "title": "Arlec Black Bordon LED Step Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL390CH_CPIN005236_2_OL.pdf?v=1754378914",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL390CH.jpg?v=1762754456"
  },
  {
    "sku": "ABL318",
    "title": "Arlec Black Bristol Exterior Farm Wall Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CPIN003301_5_OL.pdf?v=1792394469",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL318.jpg?v=1792394802"
  },
  {
    "sku": "ABL0158BK",
    "title": "Arlec Black Bulkhead Oval Bunker Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL0158BK_IM.pdf?v=1790832945",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL0158BK.png?v=1790829237"
  },
  {
    "sku": "ABL5851",
    "title": "Arlec Black Burly Bunker Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL5851CPIN007629_OL.pdf?v=1754378916",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Burly_LED_Bunker_Light_ABL5851_1.jpg?v=1762754549"
  },
  {
    "sku": "CSF06P4",
    "title": "Arlec Black Ceiling Fan Blade Sleeve - 4 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Ceiling_Fan_Sleeve_-_4_Pack_CSF06P4.jpg?v=1762751840"
  },
  {
    "sku": "PC726BK",
    "title": "Arlec Black Compact 24-Hour Timer",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Black_Compact_24_Hour_Timer_PC726BK.jpg?v=1762756189"
  },
  {
    "sku": "MAL343",
    "title": "Arlec Black Compact Movement Activated Security Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL343_CPIN002323_6_OL.pdf?v=1754379035",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Black_Compact_Movement_Activated_Security_Sensor_MAL343.jpg?v=1762755842"
  },
  {
    "sku": "EX20",
    "title": "Arlec Black DIY 120mm 4 Blade Ceiling Fan With 4m Power Cord",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_200mm_White_Fan_Exhaust_EX20_22.jpg?v=1762755491"
  },
  {
    "sku": "CSF2020DIY",
    "title": "Arlec Black DIY 120mm 4-Blade Ceiling Fan with 4m Power Cord",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CSF2020DIY.pdf?v=1763620254",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CSF2020DIY.jpg?v=1763367768"
  },
  {
    "sku": "WEL5BK",
    "title": "Arlec Black Domestic 5m Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Black_Domestic_5m_Extension_Lead_WEL5BK_1.jpg?v=1762752945"
  },
  {
    "sku": "ABL422BK",
    "title": "Arlec Black Doppia Large LED CCT Up & Down Wall Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL422BK_CPIN007682_3_OL.pdf?v=1754378915",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Large_Doppia_LED_CCT_Slim_Line_Wall_Light_ABL422BK.jpg?v=1762754510"
  },
  {
    "sku": "ABL420BK",
    "title": "Arlec Black Doppia Medium LED CCT Up & Down Wall Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL420BK_CPIN007682_3_OL.pdf?v=1787911500",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Medium_Doppia_LED_CCT_Slim_Line_Wall_Light_ABL420BK.jpg?v=1762754502"
  },
  {
    "sku": "ABL419BK",
    "title": "Arlec Black Doppia Small LED CCT Up & Down Wall Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL419BK_CPIN007682_3_OL.pdf?v=1754378915",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Small_Doppia_LED_CCT_Slim_Line_Wall_Light_ABL419BK.jpg?v=1762754491"
  },
  {
    "sku": "ABL105BK",
    "title": "Arlec Black Dorset LED Round CCT Bunker Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL105BKCPIN007601_OL.pdf?v=1754378915",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Dorset_14W_CCT_LED_Round_Bunker_Light_ABL105BK.jpg?v=1762754289"
  },
  {
    "sku": "ABL023",
    "title": "Arlec Black Dura Oval LED Bunker Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL023_CPIN006014-3_OL.pdf?v=1754378914",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_15W_LED_Oval_Black_Bunker_Light_ABL023.jpg?v=1762754279"
  },
  {
    "sku": "MAL315HA",
    "title": "Arlec Black Grid Connect Smart  20W Security Sensor Flood Light with Movement Activation",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL315HACPIN005461_3_OL.pdf?v=1754379038",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_20W_Grid_Connect_Smart_Security_Light_With_Movement_Activated_Sensor_MAL315HA.jpg?v=1762755822"
  },
  {
    "sku": "GLD304HA",
    "title": "Arlec Black Grid Connect Smart 1350lm 15W PAR38 E27 LED CCT Globe",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_PAR38_E27_LED_1350lm_15W_CCT_Globe_GLD304HA.jpg?v=1762755643"
  },
  {
    "sku": "GLD303HA",
    "title": "Arlec Black Grid Connect Smart 15W 1350lm LED PAR38 E27 RGB+CCT Globe",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD303HA.pdf?v=1754454871",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_15W_1350lm_Grid_Connect_Smart_LED_PAR38_E27_CCT_Globe_GLD303HA.jpg?v=1762755632"
  },
  {
    "sku": "HLMP05HA",
    "title": "Arlec Black Grid Connect Smart Ambient Bar Light & Spotlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/HLMP05HA_CPIN007906_OL.pdf?v=1754378974",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Smart_Ambient_Bar_Light_HLMP05HA.jpg?v=1762831237"
  },
  {
    "sku": "ALP223HA",
    "title": "Arlec Black Grid Connect Smart Desk Light- 2 Pack",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALP223HACPIN007194_OL.pdf?v=1754378915",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_Desktop_Bar_Lights_-_Twin_Pack_ALP223HA.jpg?v=1762830816"
  },
  {
    "sku": "SH142HA",
    "title": "Arlec Black Grid Connect Smart Laser Robotic Vacuum",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/SH142HACPIN007131_OL.pdf?v=1754379107",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_Laser_Robotic_Vacuum_SH142HA.jpg?v=1762756328"
  },
  {
    "sku": "PC191BKHA-2PK",
    "title": "Arlec Black Grid Connect Smart Plug In Socket With Energy Meter - 2 Pack",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PC191BKHA_IM_GC.pdf?v=1754379031",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_Plug_In_Socket_With_Energy_Meter_-_2_Pack_PC191BKHA-2PK_1.jpg?v=1762752799"
  },
  {
    "sku": "PA1206HA",
    "title": "Arlec Black Grid Connect Smart Reverse Cycle Portable Air Conditioner",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PA1206HA_CPIN005469_3_OL.pdf?v=1754379043",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Black_Smart_Portable_Reverse_Cycle_Air_Conditioner_With_Grid_Connect_PA1206HA.jpg?v=1762831359"
  },
  {
    "sku": "SH122HA",
    "title": "Arlec Black Grid Connect Smart Robotic Vacuum",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/SH122HA_CPIN006421_OL.pdf?v=1754379106",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_Robotic_Vacuum_SH122HA_1.jpg?v=1762756301"
  },
  {
    "sku": "FL052HA",
    "title": "Arlec Black Grid Connect Smart Security Flood Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/FL052HA_CPIN004876.pdf?v=1754378971",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_15W_Security_Floodlight_FL052HA.jpg?v=1762755516"
  },
  {
    "sku": "ALP006HA",
    "title": "Arlec Black Grid Connect Smart Tabletop Spotlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALP006HA_CPIN007863_OL.pdf?v=1754378917",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_Tabletop_Spotlight_ALP006HA.jpg?v=1762754925"
  },
  {
    "sku": "ATL026",
    "title": "Arlec Black Jace 4-in-1 Lamp",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ATL026.pdf?v=1754454928",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Jace_4_in_1_Lamp_ATL026.jpg?v=1762755155"
  },
  {
    "sku": "ABL0150BK",
    "title": "Arlec Black Kea LED Round Bunker Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL0150BKCPIN007618_OL.pdf?v=1754378915",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Kea_10W_LED_Bunker_Light_ABL0150BK.jpg?v=1762754374"
  },
  {
    "sku": "ABL368BK",
    "title": "Arlec Black Kent Large Round Bunker",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL368BK_CPIN003788_2_OL.pdf?v=1754378916",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Large_Kent_Aluminium_Bunker_Light_ABL368BK.jpg?v=1762754436"
  },
  {
    "sku": "ABL0159BK",
    "title": "Arlec Black Large Base Frosted Glass Diffuser Oval Bunker",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL0159BK.png?v=1790675064"
  },
  {
    "sku": "ABL018BK",
    "title": "Arlec Black Large Base Frosted Glass Diffuser Oval Bunker",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL018BK.png?v=1790827608"
  },
  {
    "sku": "ABLS0435",
    "title": "Arlec Black LED Solar Sensor Wall Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABLS0435CPIN007642_OL.pdf?v=1754378914",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_24cm_50lm_Solar_LED_Wall_Light_With_Sensor_ABLS0435.jpg?v=1762754558"
  },
  {
    "sku": "ABL112",
    "title": "Arlec Black LED Up & Down Wall Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL112CPIN007633_OL.pdf?v=1754378914",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_7W_LED_Adjustable_Beam_Angle_Up_and_Down_Wall_Light_ABL112_3.jpg?v=1762754358"
  },
  {
    "sku": "ABL1010B",
    "title": "Arlec Black Lida Decorative Wall Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL1010BCPIN007671_OL.pdf?v=1754378915",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_LIDA_Decorative_Exterior_Wall_Light_ABL1010B_1.jpg?v=1762754530"
  },
  {
    "sku": "ABL410BK",
    "title": "Arlec Black Marina CCT LED Exterior Wall Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL410BK_WH_CPIN007637_OL.pdf?v=1754378915",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Marina_CCT_LED_Exterior_Wall_Light_Black_ABL410BK.jpg?v=1762754475"
  },
  {
    "sku": "ABL431BK",
    "title": "Arlec Black Maynard Coach Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL431BK_IM.pdf?v=1790832945",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL431BK.png?v=1790831272"
  },
  {
    "sku": "ABL116BK",
    "title": "Arlec Black Medium Base Frosted Glass Diffuser Oval Bunker",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL116BK.png?v=1790827394"
  },
  {
    "sku": "LVS634",
    "title": "Arlec Black Mesa RGB or Cool White Solar Path Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS634_9531a2ac-1327-414f-a181-cfe943f58b03.png?v=1793094349"
  },
  {
    "sku": "ABL1010",
    "title": "Arlec Black Moxle Decorative Wall Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL1010CPIN007628_OL.pdf?v=1754378914",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Moxle_Decorative_Wall_Light_ABL1010.jpg?v=1762754521"
  },
  {
    "sku": "ABL577BK",
    "title": "Arlec Black Norwest Wall Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL577BK_IM.pdf?v=1790832945",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL577BK.png?v=1790583258"
  },
  {
    "sku": "ABL0158P2",
    "title": "Arlec Black Oval Bunker Lights-2 Pack",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL0158P2CPIN007638_OL.pdf?v=1754378916",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_E27_Oval_Bunker_Light_Bulkhead_Black_-_2_Pack_ABL0158P2.jpg?v=1762754385"
  },
  {
    "sku": "ABL115",
    "title": "Arlec Black Oval Caged Bunker Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL115_CPIN007599_OL.pdf?v=1754378917",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Black_Oval_Caged_Bunker_Light_ABL115.jpg?v=1762754314"
  },
  {
    "sku": "KDC02BK",
    "title": "Arlec Black Plug-in Door Chime With 150m Wireless Kinetic Push Button",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/KDC02BK_CPIN007706_3_OL.pdf?v=1754378975",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Plug-in_Door_Chime_With_150m_Wireless_Kinetic_Push_Button_-_Black_KDC02BK.jpg?v=1762753743"
  },
  {
    "sku": "FL100",
    "title": "Arlec Black Portable DIY Flood Light with Fully Integrated LED",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/FL100_CPIN005495_2_OL.pdf?v=1754378966",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_10W_LED_Security_Light_FL100.jpg?v=1762755527"
  },
  {
    "sku": "WLK10TR",
    "title": "Arlec Black Rechargeable 1000lm LED Tripod Worklight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/WLK10TR_CPIN007598_2_OL.pdf?v=1754379105",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Single-Head_Rechargeable_Work_light_With_Tripod_WLK10TR.jpg?v=1762756708"
  },
  {
    "sku": "AWL2306",
    "title": "Arlec Black Rechargeable LED Utility Light With Clamp",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWL2306_CPIN007059_OL.pdf?v=1754378927",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Rechargeable_LED_Utility_Light_With_Clamp_AWL2306.jpg?v=1762831099"
  },
  {
    "sku": "NL132B",
    "title": "Arlec Black Rechargeable Magnet Mount Sensor Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL132B.png?v=1781068625"
  },
  {
    "sku": "APRF005",
    "title": "Arlec Black Replacement HEPA 13 Filter & Honeycomb Filter Suitable for APRF005HA",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Replacement_Filter_Bundle_-_For_APR005HA_APRF005.jpg?v=1762755026"
  },
  {
    "sku": "ALP220",
    "title": "Arlec Black RGB Desk Lights - Twin Pack",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALP220.pdf?v=1754477173",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ArlecBlackRGBDeskLights-TwinPack1.png?v=1765259442"
  },
  {
    "sku": "ALP217",
    "title": "Arlec Black RGB Headphone Stand",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALP217.pdf?v=1754477174",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ArlecBlackRGBHeadphoneStand1.png?v=1765259331"
  },
  {
    "sku": "ABL391RLBK",
    "title": "Arlec Black Ridge Rounded Bunker",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL391RLBK_IM.pdf?v=1790832946",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL391RLBK.png?v=1790763885"
  },
  {
    "sku": "LVS661BK",
    "title": "Arlec Black Ritter Sensor Solar Wall Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS661BK_CPIN003929-2OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Black_Ritter_Sensor_Solar_Wall_Light_LVS661BK.jpg?v=1762753487"
  },
  {
    "sku": "ABL111RBK",
    "title": "Arlec Black Round CCT LED Exterior Step Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL111RBK_SeriesCPIN007668_OL.pdf?v=1754378914",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4W_CCT_LED_Round_Black_Exterior_Step_Light_ABL111RBK.jpg?v=1762754337"
  },
  {
    "sku": "MAL831H",
    "title": "Arlec Black Single 500lm Solar Hybrid Powered  Head Security Sensor Flood Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL831H-832H_CPIN007695_OL.pdf?v=1754379034",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Black_Solar_Hybrid_Powered_Surnia_Single_Head_Security_Sensor_Floodlight_MAL831H_1.jpg?v=1762755994"
  },
  {
    "sku": "MAL811H",
    "title": "Arlec Black Single 800lm Solar Hybrid Powered Head Security Sensor Floodlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL811H-812HCPIN007696_OL.pdf?v=1754379034",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Solar_Hybrid_Powered_KETUPA_Single_Head_Security_Sensor_Floodlight_MAL811H_1.jpg?v=1762755971"
  },
  {
    "sku": "MAL832H",
    "title": "Arlec Black Single 900lm Solar Hybrid Powered  Head Security Sensor Flood Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL832H.pdf?v=1754454585",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Solar_Hybrid_Powered_SURNIA_Twin_Head_Security_Sensor_Floodlight_MAL832H_1.jpg?v=1762756006"
  },
  {
    "sku": "MAL633",
    "title": "Arlec Black Solar LED Flood Light with Movement Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL633_CPIN003316.pdf?v=1754379026",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Solar_LED_Flood_Light_With_Movement_Sensor_MAL633.jpg?v=1762831316"
  },
  {
    "sku": "ABL111SBLK",
    "title": "Arlec Black Square CCT LED Exterior Step Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL111SBLK_SeriesCPIN007668_OL.pdf?v=1754378915",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4W_CCT_LED_Square_Black_Exterior_Step_Light_ABL111SBLK.jpg?v=1762754325"
  },
  {
    "sku": "ABL017",
    "title": "Arlec Black Stinson Oval Louvred Bunker Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL017CPIN002773_3_OL.pdf?v=1754378918",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Large_Black_Oval_Louvred_Bunker_Light_ABL017.jpg?v=1762754261"
  },
  {
    "sku": "PB8SWTV",
    "title": "Arlec Black Surge 8 Outlet Protected Powerboard with USB, CAT6 and ADSL",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_8_Outlet_2_x_USB_Coax_Surge_Protect_Powerboard_PB8SWTV_1.jpg?v=1762752559"
  },
  {
    "sku": "DA01-S2PK",
    "title": "Arlec Black Surge Protected Vertical Double Adaptor- 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Surge_Protected_Vertical_Double_Adaptor_-_2_Pack_DA01-S2PK_1.jpg?v=1762829208"
  },
  {
    "sku": "ABL371BK",
    "title": "Arlec Black Sutton Aluminium Bunker",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL371BK_CPIN003792-4_OL.pdf?v=1754378918",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Sutton_LED_Aluminium_Bunker_ABL371BK.jpg?v=1762754448"
  },
  {
    "sku": "DC691",
    "title": "Arlec Black Touch Activated Wireless Door Chime",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Black_Touch_Activated_Wireless_Door_Chime_DC691.jpg?v=1762830422"
  },
  {
    "sku": "PB2UTC-B",
    "title": "Arlec Black Travel AdaptorKit Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Powerboard_With_PD30W_USB_C_Charging_Ports_Travel_Adaptor_Kit_PB2UTC-B.jpg?v=1762752408"
  },
  {
    "sku": "DA08-2PK",
    "title": "Arlec Black Triangular Double Adaptor -2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Triangular_Double_Adaptor_-_2_pack_DA08-2PK_6b912aef-4ca9-498c-9017-166187173f1b.jpg?v=1762752186"
  },
  {
    "sku": "MAL812H",
    "title": "Arlec Black Twin 1000lm Solar Hybrid Powered  Head Security Sensor Flood Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL812HCPIN007696_OL.pdf?v=1754379034",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Solar_Hybrid_Powered_Ketupa_Twin_Head_Security_Sensor_Floodlight_MAL812H.jpg?v=1762755984"
  },
  {
    "sku": "MAL400",
    "title": "Arlec Black Twin 20W LED DIY Security Sensor Flood Light with Movement Activation",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL400_CPIN004070.pdf?v=1754379025",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_20W_LED_Black_Twin_Head_Sensor_Security_Flood_Light_MAL400.jpg?v=1762831290"
  },
  {
    "sku": "MAL412",
    "title": "Arlec Black Twin 20W LED Security Floodlight with Movement Activation",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL412_CPIN004079-2_OL.pdf?v=1754379036",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_20W_LED_Light_Security_Sensor_MAL412.jpg?v=1762831300"
  },
  {
    "sku": "MAL535",
    "title": "Arlec Black Twin Par38 Castalia DIY Compact Security Flood Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL535_CPIN002339_8_OL.pdf?v=1754379033",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Twin_Par38_Castalia_DIY_Compact_Security_Flood_Light_MAL535.jpg?v=1762755879"
  },
  {
    "sku": "MAL616",
    "title": "Arlec Black Twin Security Flood Light with Bayonet Lampholder Adaptor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL616.pdf?v=1756118041",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Black_Twin_Security_Floodlight_with_Bayonet_Lampholder_Adaptor_MAL616_2.jpg?v=1762755917"
  },
  {
    "sku": "MAL656",
    "title": "Arlec Black Twin Security Flood Light with Power Point Plug",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL656.pdf?v=1756118041",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Black_Twin_Security_Floodlight_with_Power_Point_Plug_MAL656_2.jpg?v=1762755948"
  },
  {
    "sku": "SH142AC",
    "title": "Arlec BlackAccessory Kit for Arlec SH142HA Robotic Vacuum",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Accessory_Kit_for_SH142HA_Robotic_Vacuum_SH142AC.jpg?v=1762756314"
  },
  {
    "sku": "CNZ15",
    "title": "Arlec Blue 15m Heavy Duty Caravan Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_15m_Caravan_Extension_Lead_CNZ15.jpg?v=1762752162"
  },
  {
    "sku": "PB4PDBRBL-P",
    "title": "Arlec Blue 4-Outlet Powerboard PD30W USB A&C with Braided Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB4PDBRBL-P.jpg?v=1762829270"
  },
  {
    "sku": "PB4MBR-BL-K",
    "title": "Arlec Blue 4-Outlet Powerboard with Braided Power Cord",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Blue_4-Outlet_Powerboard_with_Braided_Power_Cord_PB4MBR-BL-K.jpg?v=1762752451"
  },
  {
    "sku": "BREL5-BL-K",
    "title": "Arlec Blue 5m Braided Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Blue_5m_Braided_Extension_Lead_BREL5-BL-K_1.jpg?v=1762752100"
  },
  {
    "sku": "PB6K-H-K",
    "title": "Arlec Blue 6-Outlet Powerboard with Master Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Alrec_Blue_6-Outlet_Powerboard_with_Master_Switch_PB6K-H-K.jpg?v=1762751297"
  },
  {
    "sku": "WEL3-BLGR-K",
    "title": "Arlec Blue and Green Domestic 3m Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Blue_and_Green_Domestic_3m_Extension_Lead_WEL3-BLGR-K_1.jpg?v=1762752926"
  },
  {
    "sku": "PB8WUPD-H-K",
    "title": "Arlec Blue Hexagon 8 Outlet Powerboard with Wide Spaced Outlets and USB A&C Ports",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Blue_Hexagon_8_Outlet_Powerboard_with_Wide_Spaced_Outlets_and_USB_A_C_Ports_PB8WUPD-H-K.jpg?v=1762751409"
  },
  {
    "sku": "AT0082",
    "title": "Arlec Blue LED Fish Dynamo Torch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Fish_Kids_Wind_Up_Dynamo_Torch_AT0082.jpg?v=1762830948"
  },
  {
    "sku": "PB4-L-K",
    "title": "Arlec Blue Lighting 4-Outlet Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Alrec_Blue_Lighting_4-Outlet_Powerboard_PB4-L-K.jpg?v=1762751308"
  },
  {
    "sku": "PB5RU-R-K",
    "title": "Arlec Blue Round 5 Outlet Powerboard with USB A & C Charging Ports",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Blue_Round_5_Outlet_Powerboard_with_USB_A___C_Charging_Ports_PB5RU-R-K.jpg?v=1762751418"
  },
  {
    "sku": "BAT6V",
    "title": "Arlec Blue Super Heavy-Duty Lantern Battery",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Blue_Super_Heavy-Duty_Lantern_Battery_BAT6V.jpg?v=1762755315"
  },
  {
    "sku": "PB3RUPD-TWCLBL",
    "title": "Arlec Blue Tweenie Cloud 3-Outlet Fast Charging USB Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB3RUPD-TWCLBL.png?v=1784179752"
  },
  {
    "sku": "DCF5241HA",
    "title": "Arlec Boston II  White 4-Blades 130cm Grid Connect Smart DC Ceiling Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DCF5241HA_CPIN004982-3_OL.pdf?v=1769054443",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_130cm_White_Blades_Grid_Connect_Smart_Boston_II_Ceiling_Fan_DCF5241HA.jpg?v=1762751893"
  },
  {
    "sku": "DCF5240BL",
    "title": "Arlec Boston II Black 4-Blade 130cm DC Ceiling Fan With CCT Light and Remote",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DCF5240_CPIN005460_3_updated_OL_0bef9cee-2ffe-40ad-989f-541c1a72dde2.pdf?v=1754453700",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Boston_II_Black_4-Blade_130cm_DC_Ceiling_Fan_With_CCT_Light_and_Remote_DCF5240BL.jpg?v=1762751856"
  },
  {
    "sku": "DCF2027",
    "title": "Arlec Boston II Matte Black  4-Blade 130cm DC Ceiling Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DCF2027_CPIN005504-2_OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Boston_II_Matte_Black__4-Blade_130cm_DC_Ceiling_Fan_DCF2027.jpg?v=1762751979"
  },
  {
    "sku": "DCF5241",
    "title": "Arlec Boston II White 4-Blade 130cm DC Ceiling Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DCF5241_CPIN005504-2OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Boston_II_White_4-Blade_130cm_DC_Ceiling_Fan_DCF5241.jpg?v=1762751823"
  },
  {
    "sku": "DCF5240WL",
    "title": "Arlec Boston II White 4-Blade 130cm DC Ceiling Fan With CCT Light and Remote",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DCF5240CPIN005460_3updated_OL_7996b142-2009-40b5-a637-75b672bd6ff6.pdf?v=1754453593",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Boston_II_White_4-Blade_130cm_DC_Ceiling_Fan_With_CCT_Light_and_Remote_DCF5240WL.jpg?v=1762751846"
  },
  {
    "sku": "DCF3644WL",
    "title": "Arlec Boston II White 4-Blade 91cm DC Ceiling Fan  with CCT and Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DCF3644WLCPIN003615OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Boston_II_White_4-Blade_91cm_DC_Ceiling_Fan__with_CCT_and_Remote_Control_DCF3644WL.jpg?v=1762751950"
  },
  {
    "sku": "DCF5242HA",
    "title": "Arlec Boston White 4-Blades 130cm Grid Connect Smart DC Ceiling Fan with Light and Remote",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DCF5242HACPIN005457_3_OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_130cm_White_4_Blade_Grid_Connect_Smart_DC_Ceiling_Fan_With_LED_Light_And_Remote_DCF5242HA.jpg?v=1762751904"
  },
  {
    "sku": "PB3LC-P",
    "title": "Arlec Braided Powerboard and Extension Lead Combo Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB3LC-P.png?v=1789026052"
  },
  {
    "sku": "LVA1842",
    "title": "Arlec Brick Clip Fasteners - 10 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVA1842.jpg?v=1765440323"
  },
  {
    "sku": "BEDL2-BS",
    "title": "Arlec Burnished Lilac 2m Ordinary Duty Braided Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/BEDL2-BS.png?v=1784798403"
  },
  {
    "sku": "BEDL5-BS",
    "title": "Arlec Burnished Lilac 5m Ordinary Duty Braided Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/BEDL5-BS.png?v=1784798770"
  },
  {
    "sku": "AT0020",
    "title": "Arlec Camping LED Lantern",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Blue_Camping_LED_Lantern_AT0020_1.jpg?v=1762755105"
  },
  {
    "sku": "UC465KIT",
    "title": "Arlec CCT and Dimmable Rechargeable 2.4GHz Linkable Cabinet Light Kit With PIR",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC465KIT.jpg?v=1781695049"
  },
  {
    "sku": "UC476S",
    "title": "Arlec CCT and Dimmable Rechargeable Motion Sensor Cabinet Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC476S.png?v=1781254755"
  },
  {
    "sku": "CSF2020",
    "title": "Arlec Chicago White 4-Blade 120cm AC Ceiling Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CSF2020_CPIN005635-2OL.pdf?v=1754378971",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CSF2020_6c2c2aaf-ad48-4e4e-9c4b-292f941f650e.jpg?v=1779792895"
  },
  {
    "sku": "CSF2020WL",
    "title": "Arlec Chicago White 4-Blade 120cm AC Ceiling Fan with Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CSF2020WL_CPIN006327-2_OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Chicago_White_4-Blade_120cm_AC_Ceiling_Fan_with_Light_CSF2020WL.jpg?v=1762752011"
  },
  {
    "sku": "THBK2",
    "title": "Arlec Chrome Heated Towel Rail Bracket Kit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Chrome_Heated_Towel_Rail_Bracket_Kit_THBK2.jpg?v=1762757017"
  },
  {
    "sku": "NL0850",
    "title": "Arlec Circadian Rhythm Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL0850.png?v=1781610832"
  },
  {
    "sku": "PB45L-TP-BU",
    "title": "Arlec Clear Blue 4 Outlet Surge Protected Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB45L-TP-BU.png?v=1780397022"
  },
  {
    "sku": "PB45L-TP-GE",
    "title": "Arlec Clear Green 4 Outlet Surge Protected Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB45L-TP-GE.png?v=1780398646"
  },
  {
    "sku": "PB45L-TP-BL",
    "title": "Arlec Clear Grey 4 Outlet Surge Protected Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB45L-TP-BL.png?v=1780398845"
  },
  {
    "sku": "PB45L-TP-PI",
    "title": "Arlec Clear Pink 4 Outlet Surge Protected Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB45L-TP-PI.png?v=1780399240"
  },
  {
    "sku": "AM490",
    "title": "Arlec Compact Entry Detector Alarm / Chime",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AM490_CPIN003646_4_OL.pdf?v=1754378926",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Compact_Entry_Detector_Alarm__Chime_AM490.jpg?v=1762753826"
  },
  {
    "sku": "MAL540",
    "title": "Arlec Compact Movement Activated Sensor White",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Compact_Movement_Activated_Sensor_White_MAL540.jpg?v=1762753842"
  },
  {
    "sku": "LVS648",
    "title": "Arlec Crackle Ball Path Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS648.png?v=1787900487"
  },
  {
    "sku": "LVE356",
    "title": "Arlec Cream Light Flame Effect Plastic Candle",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Cream_Light_Flame_Effect_Plastic_Candle_LVE356.jpg?v=1762829695"
  },
  {
    "sku": "PB32B-G",
    "title": "Arlec Dark Grey 2 Outlet Outdoor Powerboard With Removable Garden Stake",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB32B-G.jpg?v=1780636741"
  },
  {
    "sku": "CSF484BDIY",
    "title": "Arlec DIY Black 4-Blade 120cm Simple Hang and Plug-In AC Ceiling Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CSF484BDIY_CPIN006317OL.pdf?v=1754378975",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_120cm_Black_AC_DIY_4_Blade_Ceiling_Fan_CSF484BDIY.jpg?v=1762752037"
  },
  {
    "sku": "CSF120C",
    "title": "Arlec DIY White 3-Blade 120cm Simple Hang and Plug-In AC Ceiling Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CSF120C_CPIN003217-6_OL.pdf?v=1754378974",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1200mm_3_Blade_Ceiling_Fan_CSF120C.jpg?v=1762752043"
  },
  {
    "sku": "NL0009",
    "title": "Arlec Dual Sensor Mouse Motion Nightlight",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Dual_Sensor_Mouse_Motion_Nightlight_NL0009.jpg?v=1762754047"
  },
  {
    "sku": "NL901",
    "title": "Arlec Dusk To Dawn LED Night Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Dusk_To_Dawn_LED_Night_Light_NL901.jpg?v=1762830550"
  },
  {
    "sku": "NL902",
    "title": "Arlec Dusk To Dawn Switch-On Sensor Night Light - Twin Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Dusk_To_Dawn_Switch-On_Sensor_Night_Light_-_Twin_Pack_NL902.jpg?v=1762830531"
  },
  {
    "sku": "LVS05LINK",
    "title": "Arlec Echo Solar Linkable 16W LED Adjustable Outdoor Wall Light with PIR Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS05LINK_IM.pdf?v=1790832946",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS05LINK.png?v=1790581619"
  },
  {
    "sku": "LVA003",
    "title": "Arlec Entertainment Light Gutter Clips",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Entertainment_Light_Gutter_Clips_LVA003.jpg?v=1762753247"
  },
  {
    "sku": "EV200E-16C3P7",
    "title": "Arlec EV 11kW 16A Three Phase Charging Cable 7m",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0871/6225/7691/files/EV200E-16C3P7.pdf?v=1730774492",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_7m_IP65_11kW_16A_Three_Phase_Type_2_Connector_EV_Charging_Cable_EV200E-16C3P7.jpg?v=1762751427"
  },
  {
    "sku": "EV200E-32C3P7",
    "title": "Arlec EV 22kW 32A Three Phase Charging Cable 7m",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0871/6225/7691/files/EV200E-32C3P7.pdf?v=1730774539",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_7m_IP65_22kW_32A_Three_Phase_Type_2_Connector_EV_Charging_Cable_EV200E-32C3P7.jpg?v=1762751434"
  },
  {
    "sku": "EV200E-32C1P7",
    "title": "Arlec EV 7.4kW 32A Single Phase Charging Cable 7m",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0871/6225/7691/files/EV200E-32C1P7.pdf?v=1730774453",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_7m_IP65_7.4kW_32A_Single_Phase_Type_2_Connector_EV_Charging_Cable_EV200E-32C1P7.jpg?v=1762751442"
  },
  {
    "sku": "EV200S-32W1P",
    "title": "Arlec EV 7kW 32A Charger Single Phase Wall Mounted",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0871/6225/7691/files/EV200S-32W1P_CPIN008034_OL_compressed.pdf?v=1730773788",
    "datasheet": "https://cdn.shopify.com/s/files/1/0871/6225/7691/files/EV200S-32W1P_data_sheet_v1.0.pdf?v=1735557397",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_IP55_7kW_32A_Single_Phase_Type_2_Connector_EV_Charger_With_5m_Cable_EV200S-32W1P.jpg?v=1762751449"
  },
  {
    "sku": "EVCM11",
    "title": "Arlec EV Charger Anti-Theft Tyre Lock",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Anti_theft_Tyre_EV_Charger_Cable_Lock_EVCM11.jpg?v=1762751465"
  },
  {
    "sku": "EVCM30",
    "title": "Arlec EV Charger Cable Holder Lockable-Type 2 (IEC-62196)",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Lockable_EV_Charger_Cable_Holder_EVCM30.jpg?v=1762751474"
  },
  {
    "sku": "EVCM28",
    "title": "Arlec EV Charger Cable Holder with Cable Tidy Heavy Duty-Type 2 (IEC-62196)",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Heavy_Duty_EV_Charger_Cable_Holder_EVCM28.jpg?v=1762751483"
  },
  {
    "sku": "EVCM04-2",
    "title": "Arlec EV Charger Cable Holder with Cable Tidy-Type 2 (IEC-62196)",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_EV_Wall_Mount_Type_2_Connector_Cable_Holder_EVCM04-2.jpg?v=1762751491"
  },
  {
    "sku": "EVCM05-2",
    "title": "Arlec EV Charger Cable Holder with Padlock-Type 2 (IEC-62196)",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/EVCM05-2CPIN008135_OL.pdf?v=1754378968",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec-Heavy-Duty-Lockable-Type-2-Connector-EV-Charger-Cable-Holder_EVCM05-2_0357968c-b342-4494-ad26-73335a0d14ad.jpg?v=1762751499"
  },
  {
    "sku": "EVCM77",
    "title": "Arlec EV Charger Cable Management System",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0871/6225/7691/files/EVCM77_CPIN008042_OL.pdf?v=1730773640",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_EV_Charging_Cable_Management_System_EVCM77.jpg?v=1762751509"
  },
  {
    "sku": "EVCM16",
    "title": "Arlec EV Charger Cable Strap (400mm X 50mm)-4 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Charger_Cable_Strap_-_Pack_of_4_EVCM16.jpg?v=1762751525"
  },
  {
    "sku": "EVCM14",
    "title": "Arlec EV Charger Cable Strap (430mm X 50mm)",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_EV_Charger_Cable_Strap_EVCM14.jpg?v=1762751533"
  },
  {
    "sku": "EVCM100",
    "title": "Arlec EV Charger Wall Mount Canopy",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Wall_Mount_EV_Charger_Canopy_EVCM100.jpg?v=1762751541"
  },
  {
    "sku": "EVCM02",
    "title": "Arlec EV Charging Cable Case",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Portable_Charger_and_Charging_Cable_Case_EVCM02.jpg?v=1762751554"
  },
  {
    "sku": "EVCM99",
    "title": "Arlec EV Charging Cable Retractor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_EV_Charging_Cable_Retractor_EVCM99.jpg?v=1762751566"
  },
  {
    "sku": "EV200E-20C1P5",
    "title": "Arlec EV IP65 4.6kW 20A Single Phase Type 2 Charging Cable 5m",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/EV200E-20C1P5_CPIN008005_OL_ba651f47-1d2e-4cc8-bbd1-3166457200e2.pdf?v=1754378969",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_5m_IP65_4.6kW_20A_Single_Phase_Type_2_Connector_EV_Charging_Cable_EV200E-20C1P5.jpg?v=1762751574"
  },
  {
    "sku": "EVCM06",
    "title": "Arlec EV Portable Charger Wall Mount Bracket",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Portable_EV_Charger_Wall_Mount_Bracket_EVCM06.jpg?v=1762751581"
  },
  {
    "sku": "EVCM03",
    "title": "Arlec EV Waterproof Protector Fabric",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Waterproof_EV_Charge_Port_Protector_EVCM03.jpg?v=1762751592"
  },
  {
    "sku": "ELHOOK-5",
    "title": "Arlec Extension Lead Hook Yellow - 5 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ELHOOK-5_1.png?v=1789016690"
  },
  {
    "sku": "ADF30523RW",
    "title": "Arlec Faux Timber 30cm 5-Blade Desk Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ADF30523RWCPIN007452_OL.pdf?v=1754378919",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_30cm_Desk_Fan_ADF30523RW.jpg?v=1762830711"
  },
  {
    "sku": "AFF40523RW",
    "title": "Arlec Faux Timber 40cm 5-Blade Floor Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AFF40523RWCPIN007456OL.pdf?v=1754378917",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_40cm_Floor_Fan_AFF40523RW_1.jpg?v=1762830733"
  },
  {
    "sku": "APF40523RB",
    "title": "Arlec Faux Timber 40cm 5-Blade Pedestal Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/APF40523RB_CPIN007477OL.pdf?v=1754378923",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_40cm_Pedestal_Fan_APF40523RB.jpg?v=1762830903"
  },
  {
    "sku": "AWF40523RB",
    "title": "Arlec Faux Timber 40cm 5-Blade Wall Fan with Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWF40523RB_CPIN007466_3_OL.pdf?v=1754378927",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_40cm_Wall_Fan_With_Remote_Control_AWF40523RB_1.jpg?v=1762831088"
  },
  {
    "sku": "LVX1790",
    "title": "Arlec Festive Curtain Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1790_CPIN007846_OL.pdf?v=1754379030",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Festive_Curtain_Light_LVX1790.jpg?v=1762829106"
  },
  {
    "sku": "ROH403S",
    "title": "Arlec Free Standing Heater Base",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ROH403SCPIN005769_6_OL.pdf?v=1754379103",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Free_Standing_Heater_Base_ROH403S.jpg?v=1762756878"
  },
  {
    "sku": "LVX305",
    "title": "Arlec Gold Christmas Ball",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX305_CPIN007267OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Gold_Christmas_Ball_String_Light_LVX305_1.jpg?v=1762830086"
  },
  {
    "sku": "PB3RUPD-TWSTOR",
    "title": "Arlec Gold Tweenie Star 3-Outlet Fast Charging USB Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB3RUPD-TWSTOR.png?v=1784179355"
  },
  {
    "sku": "ARLCT100",
    "title": "Arlec Green 100 x 2.5mm Cable Ties- 100 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_100_x_2.5mm_Cable_Ties_Green_100PK_ARLCT100_3.jpg?v=1762830919"
  },
  {
    "sku": "PB200G",
    "title": "Arlec Green 2-Outlets Outdoor Garden Stake Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2_IP44_Outlet_Outdoor_Power_Garden_Stake_PB200G.jpg?v=1762752707"
  },
  {
    "sku": "PB200G-P",
    "title": "Arlec Green 2-Outlets Outdoor Garden Stake Powerboard(promo)",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Outdoor_2_Outlet_Powerboard_Garden_Stake_PB200G-P.jpg?v=1762829431"
  },
  {
    "sku": "PB250G",
    "title": "Arlec Green 2-Outlets Outdoor Garden Stake Timer Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2_IP44_Outlet_Outdoor_Garden_Stake_Timer_Powerboard_PB250G.jpg?v=1762829441"
  },
  {
    "sku": "PB4PDBRPK-P",
    "title": "Arlec Green 4-Outlet Powerboard PD30W USB A&C with Braided Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4_Outlet_PD30W_Rapid_Charge_Powerboard_Oil_Green_PB4PDBRPK-P.jpg?v=1762829278"
  },
  {
    "sku": "PB4-H-K",
    "title": "Arlec Green Haxagon 4-Outlet Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Green_Haxagon_4-Outlet_Powerboard_PB4-H-K.jpg?v=1762751600"
  },
  {
    "sku": "PB6K-L-K",
    "title": "Arlec Green Lighting 6-Outlet Powerboard with Master Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Alrec_Green_Lighting_6-Outlet_Powerboard_with_Master_Switch_PB6K-L-K.jpg?v=1762751320"
  },
  {
    "sku": "DR320",
    "title": "Arlec Green Small IP54 Weatherproof Electrical Enclosure Box",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Green_Powerboard_Storage_Outdoor_Box_and_Cord_DR320_1.jpg?v=1762829233"
  },
  {
    "sku": "AT205",
    "title": "Arlec Green Torch and Pop-up Worklight",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Torch_and_Pop-up_Worklight_AT205.jpg?v=1762755126"
  },
  {
    "sku": "ARLLO02",
    "title": "Arlec Green XMAS Lighting Organiser- 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Xmas_Lighting_Organiser_-_2_Pack_ARLLO02.jpg?v=1762830926"
  },
  {
    "sku": "PB34BT-G",
    "title": "Arlec Grey 4 Outlet Outdoor Powerboard With Timer And Removable Garden Stake",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB34BT-G.jpg?v=1780389410"
  },
  {
    "sku": "PB4MBR-GY-K",
    "title": "Arlec Grey 4-Outlet Powerboard with Braided Power Cord",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grey_4-Outlet_Powerboard_with_Braided_Power_Cord_PB4MBR-GY-K.jpg?v=1762752460"
  },
  {
    "sku": "BREL5-GY-K",
    "title": "Arlec Grey 5m Braided Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grey_5m_Braided_Extension_Lead_BREL5-GY-K_1.jpg?v=1762752116"
  },
  {
    "sku": "PB36-L",
    "title": "Arlec Grey 6-Outlet Weather Protected Powerboard with Surge Protection",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB36_L_CPIN007934_OL.pdf?v=1754379036",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_IP55_6_Outlet_Weatherproof_Powerboard_with_Surge_Protection_PB36-L_1.jpg?v=1762829359"
  },
  {
    "sku": "DPH01",
    "title": "Arlec Grey Cable Carry Handle",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Extension_Lead_Organiser_DPH01.jpg?v=1762752327"
  },
  {
    "sku": "DR340",
    "title": "Arlec Grey Large IP54 Weatherproof Electrical Enclosure Box",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_5_Outlet_Weatherproof_Electrical_Enclosure_Box_DR340_5_1.png?v=1762752338"
  },
  {
    "sku": "PB34UPD",
    "title": "Arlec Grey Outdoor Fast Charging USB Powerboard with Surge Protection",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB34UPDCPIN007935_2_OL.pdf?v=1754379036",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_IP55_4_Outlet_Weatherproof_Powerboard_with_PD20W_Rapid_Charging_USB_A___C_PB34UPD.jpg?v=1762829349"
  },
  {
    "sku": "LVS645GY",
    "title": "Arlec Grey Render Finish Sandor Solar Bollard Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS645GYCPLB011119_3_OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grey_Render_Finish_Sandor_Solar_Bollard_Light_LVS645GY_1_3777e3ff-5fa9-4b21-b5f1-b57d9e59e00e.jpg?v=1762753270"
  },
  {
    "sku": "ALD293MTRHA",
    "title": "Arlec Grid Connect 2m Smart Dotless CCT COB Strip Light - Matter Compatible",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD293MTRHA.png?v=1781498765"
  },
  {
    "sku": "ALD993MTRHA",
    "title": "Arlec Grid Connect Smart 10m Dotless CCT COB Strip Light - Matter Compatible",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD993MTRHA.pdf?v=1785135072",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD993MTRHA.png?v=1781499603"
  },
  {
    "sku": "ALD963HA",
    "title": "Arlec Grid Connect Smart 10m Strip Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD963HA.pdf?v=1754477174",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ArlecGridConnectSmart10mStripLight1.png?v=1765259614"
  },
  {
    "sku": "GLD315MTRHA",
    "title": "Arlec Grid Connect Smart 10W E27 RGB+CCT and Tunable White LED Reflector Globe",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD315MTRHA.png?v=1793009735"
  },
  {
    "sku": "GLD310MTRHA",
    "title": "Arlec Grid Connect Smart 11W B22 1050lm Tunable White LED Globe - Matter Compatible",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD310MTRHA.png?v=1793013673"
  },
  {
    "sku": "GLD312MTRHA",
    "title": "Arlec Grid Connect Smart 11W E27 1050lm Tunable White LED Globe - Matter Compatible",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD312MTRHA.png?v=1793012007"
  },
  {
    "sku": "GLD304MTRHA",
    "title": "Arlec Grid Connect Smart 15W E27 CCT and Tunable White LED Reflector Globe",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD304MTRHA.png?v=1793008069"
  },
  {
    "sku": "GLD303MTRHA",
    "title": "Arlec Grid Connect Smart 15W E27 RGB+CCT and Tunable White LED Reflector Globe",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD303MTRHA.png?v=1793007443"
  },
  {
    "sku": "MAL352HA",
    "title": "Arlec Grid Connect Smart 24W  CCT LED Security Sensor Floodlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL352HACPIN007652_OL.pdf?v=1754379031",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_24W_2500lm_CCT_LED_Security_Sensor_Floodlight_MAL352HA.jpg?v=1762755857"
  },
  {
    "sku": "CHR381HA",
    "title": "Arlec Grid Connect Smart 2m RGB Strip Light with Razer Chroma",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CHR381HA.pdf?v=1754477174",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CHR381HAHERO.png?v=1774319046"
  },
  {
    "sku": "ALP422HA",
    "title": "Arlec Grid Connect Smart 2m x 2m Pixel Curtain Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALP422HA.pdf?v=1754477173",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ArlecGridConnectSmart2mx2mPixelCurtainLight1.png?v=1765258855"
  },
  {
    "sku": "CHR373HA",
    "title": "Arlec Grid Connect Smart 3m Woven Rope Light with Razer Chroma",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CHR373HA.pdf?v=1754477173",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ArlecGridConnectSmart3mWovenRopeLightwithRazerChroma1.png?v=1765258376"
  },
  {
    "sku": "GLD381MTRHA",
    "title": "Arlec Grid Connect Smart 4.7W GU10 350lm RGB and Tunable White LED Globe - Matter Compatible",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD381MTRHA.png?v=1793014410"
  },
  {
    "sku": "ALD593MTRHA",
    "title": "Arlec Grid Connect Smart 5m Dotless CCT COB Strip Light - Matter Compatible",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD593MTRHA.png?v=1781500223"
  },
  {
    "sku": "CHR336HA",
    "title": "Arlec Grid Connect Smart 5m Neon Rope Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CHR336HA_IM.pdf?v=1793006709",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CHR336HA.png?v=1793080591"
  },
  {
    "sku": "CHR382HA",
    "title": "Arlec Grid Connect Smart 5m RGB Strip Light with Razer Chroma",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CHR382HA.pdf?v=1754477173",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CHR382HAHERO_1.jpg?v=1765256802"
  },
  {
    "sku": "GLD361MTRHA",
    "title": "Arlec Grid Connect Smart 5W B15 470lm RGB and Tunable White Candle LED Globe - Matter Compatible",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD361MTRHA.png?v=1793013143"
  },
  {
    "sku": "GLD365MTRHA",
    "title": "Arlec Grid Connect Smart 5W B15 RGB+CCT and Tunable White Fancy Round LED Globe - Matter Compatible",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD365MTRHA.png?v=1793010258"
  },
  {
    "sku": "GLD360MTRHA",
    "title": "Arlec Grid Connect Smart 5W E14 470lm RGB and Tunable White Candle LED Globe - Matter Compatible",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD360MTRHA.png?v=1793012500"
  },
  {
    "sku": "GLD364MTRHA",
    "title": "Arlec Grid Connect Smart 5W E14 470lm RGB and Tunable White Fancy Round LED Globe - Matter Compatible",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD364MTRHA.png?v=1793014123"
  },
  {
    "sku": "GLD320MTRHA",
    "title": "Arlec Grid Connect Smart 9W B22 870lm RGB and Tunable White LED Globe - Matter Compatible",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD370E27HA_IM.pdf?v=1793011262",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD320MTRHA.png?v=1793011717"
  },
  {
    "sku": "GLD370B22HA",
    "title": "Arlec Grid Connect Smart 9W B22 A60 RGB+CCT and Tunable White LED Globe with Remote",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD370B22HA_IM.pdf?v=1793010812",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD370B22HA.png?v=1793010777"
  },
  {
    "sku": "GLD370E27HA",
    "title": "Arlec Grid Connect Smart 9W E27 A60 RGB+CCT and Tunable White LED Globe with Remote",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD370E27HA_IM.pdf?v=1793011262",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD370E27HA.png?v=1793011410"
  },
  {
    "sku": "NL0101HA",
    "title": "Arlec Grid Connect Smart Bedside Assist Light Kit",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL0101HACPIN005512.pdf?v=1754379030",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_Bedside_Assist_Light_Kit_NL0101HA.jpg?v=1762754164"
  },
  {
    "sku": "APR005HA",
    "title": "Arlec Grid Connect Smart Big Room Air-Purifier with UV-C Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/APR005HA_CPIN0069498ppOL.pdf?v=1754378928",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Black_40cm_5-Blade_Pesdestal_Fan_with_Remote_Control_APR005HA.jpg?v=1762754995"
  },
  {
    "sku": "SH010HA",
    "title": "Arlec Grid Connect Smart Body Analysis Scale",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/SH010HA.pdf?v=1761633271",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/SH010HA.png?v=1762757345"
  },
  {
    "sku": "CFR225HA",
    "title": "Arlec Grid Connect Smart Ceiling Fan Remote Control Kit",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CPIN006334_3_OL_9fc4191a-f0c9-4aa0-871f-6daaa8b1eaf4.pdf?v=1754453970",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_Ceiling_Fan_Remote_Control_Kit_CFR225HA.jpg?v=1762751988"
  },
  {
    "sku": "SG022HA",
    "title": "Arlec Grid Connect Smart Home Button",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/SG022HACPIN006931OL.pdf?v=1754379101",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_Home_Button_SG022HA.jpg?v=1762753805"
  },
  {
    "sku": "SG120HA",
    "title": "Arlec Grid Connect Smart Home Control Kit",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/SG120HACPIN006930OL.pdf?v=1754379103",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_Home__Control_Kit_SG120HA.jpg?v=1762753857"
  },
  {
    "sku": "SG023HA",
    "title": "Arlec Grid Connect Smart Home Motion Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/SG023HACPIN006932OL.pdf?v=1754379101",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_Home_Motion_Sensor_SG023HA.jpg?v=1762753848"
  },
  {
    "sku": "SGSP4HA",
    "title": "Arlec Grid Connect Smart Home Sensor Kit",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/SGSP4HA_CPIN004983.pdf?v=1754379103",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_Home_Sensor_Kit_SGSP4HA.jpg?v=1762830457"
  },
  {
    "sku": "CHR360HA",
    "title": "Arlec Grid Connect Smart Modular Hexagon Lights 9pk with Razer Chroma",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CHR360HA.pdf?v=1754477174",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ArlecGridConnectSmartModularHexagonLights9-PiecewithRazerChroma_1.jpg?v=1765257880"
  },
  {
    "sku": "SGS02HA",
    "title": "Arlec Grid Connect Smart Motion Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/SGS02HA_CPIN004974.pdf?v=1754379100",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_Motion_Sensor_SGS02HA_1.jpg?v=1762830447"
  },
  {
    "sku": "CHR370HA",
    "title": "Arlec Grid Connect Smart Neon Flex 5m with Razer Chroma",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CHR370HA.pdf?v=1754477174",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ArlecGridConnectSmartNeonFlex5mwithRazerChroma1.jpg?v=1765258212"
  },
  {
    "sku": "CHR340MTRHA",
    "title": "Arlec Grid Connect Smart Pegboard Headphone Stand - Matter Compatible",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CHR340MTRHA_im.pdf?v=1793005591",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CHR340MTRHA_1.png?v=1793005861"
  },
  {
    "sku": "PC193HA",
    "title": "Arlec Grid Connect Smart Plug In Multi-Function Socket With USB",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "NL4258HA",
    "title": "Arlec Grid Connect Smart Plug In Night Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL4258HA.pdf?v=1754455150",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_Plug_In_Night_Light_NL4258HA.jpg?v=1762830571"
  },
  {
    "sku": "CHR351HA",
    "title": "Arlec Grid Connect Smart RGB Corner Light with Razer Chroma",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CHR351HA.pdf?v=1754477173",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ArlecGridConnectSmartRGBCornerLightwithRazerChroma1.jpg?v=1765259069"
  },
  {
    "sku": "CHR352HA",
    "title": "Arlec Grid Connect Smart RGB Desk Lights Twin Pack with Razer Chroma",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CHR352HA.pdf?v=1754477174",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ArlecGridConnectSmartRGBDeskLightsTwinPackwithRazerChroma1.jpg?v=1765259217"
  },
  {
    "sku": "CHR390MTRHA",
    "title": "Arlec Grid Connect Smart RGB Mouse Pad - Matter Compatible",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CHR390MTRHA_IM.pdf?v=1793006258",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CHR390MTRHA.png?v=1793006468"
  },
  {
    "sku": "UC508MTRHA",
    "title": "Arlec Grid Connect Smart RGBW Puck Lights - 4 Pack - Matter Compatible",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC508MTRHA_IM.pdf?v=1784787701",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC508MTRHA.jpg?v=1784787932"
  },
  {
    "sku": "SH172HA",
    "title": "Arlec Grid Connect Smart Robotic Window Cleaner",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/SH172HA_CPIN008092_OL.pdf?v=1759738191",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/SH172HA.jpg?v=1762757302"
  },
  {
    "sku": "ALP215HA",
    "title": "Arlec Grid Connect Smart Tri-Zone Floor Lamp",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALP215HA_IM.pdf?v=1793004255",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALP215HA.png?v=1793004194"
  },
  {
    "sku": "ALP235HA",
    "title": "Arlec Grid Connect Smart Wall Washing Lights 5m RGB CCT Grid",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALP235HA.pdf?v=1754477173",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALP235HAHERO.png?v=1765255656"
  },
  {
    "sku": "PB44-HW-OB",
    "title": "Arlec Halloween Orange and Black 4-Outlet Individually Switched Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB44-HW-OB.png?v=1785302582"
  },
  {
    "sku": "PB34B-G-HW-OB",
    "title": "Arlec Halloween Orange and Black 4-Outlet Weatherproof Powerboard with Removable Garden Stake",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB34B-G-HW-OB.png?v=1785208879"
  },
  {
    "sku": "PB44-HW-PB",
    "title": "Arlec Halloween Purple and Black 4-Outlet Individually Switched Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB44-HW-PB.jpg?v=1787907298"
  },
  {
    "sku": "PB34B-G-HW-PB",
    "title": "Arlec Halloween Purple and Black 4-Outlet Weatherproof Powerboard with Removable Garden Stake",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB34B-G-HW-PB.png?v=1785208764"
  },
  {
    "sku": "PB44-HW-PG",
    "title": "Arlec Halloween Purple and Green 4-Outlet Individually Switched Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB44-HW-PG.png?v=1785302746"
  },
  {
    "sku": "PB34B-G-HW-PG",
    "title": "Arlec Halloween Purple and Green 4-Outlet Weatherproof Powerboard with Removable Garden Stake",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB34B-G-HW-PG.png?v=1785207666"
  },
  {
    "sku": "ABL378BK",
    "title": "Arlec Halton Black Exterior Coach Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL378BK_CPIN003790_4_OL.pdf?v=1792391322",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL378BK.jpg?v=1792391521"
  },
  {
    "sku": "THBK1",
    "title": "Arlec Heated Towel Rail Bracket Kit White - White",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Heated_Towel_Rail_Bracket_Kit_White_-_White_THBK1.jpg?v=1762757010"
  },
  {
    "sku": "THT10",
    "title": "Arlec Heated Towel Rail Timer",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/THT10_CPIN003230OL.pdf?v=1754379098",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Heated_Towel_Rail_Timer_THT10.jpg?v=1762757026"
  },
  {
    "sku": "NEO03",
    "title": "Arlec Hello Sign LED Neon Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NEO03CPIN007955_OL.pdf?v=1754379028",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Hello_Sign_LED_Neon_Light_NEO03.jpg?v=1762753866"
  },
  {
    "sku": "NL1009",
    "title": "Arlec Hidden Motion Sensor Plug-In Night Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL1009.png?v=1781234998"
  },
  {
    "sku": "DC688",
    "title": "Arlec High Gloss White Finish Modern Plug-In Door Chime",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_High_Gloss_White_Finish_Modern_Plug-In_Door_Chime_DC688.jpg?v=1762831175"
  },
  {
    "sku": "CSF1240HWL",
    "title": "Arlec Hugo  Matte White 4-Blade127cm Hugger AC Ceiling Fan With CCT LED Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CSF1240HWL_CPIN006328-2OL.pdf?v=1754378978",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Hugo__Matte_White_4-Blade127cm_Hugger_AC_Ceiling_Fan_With_CCT_LED_Light_CSF1240HWL.jpg?v=1762751995"
  },
  {
    "sku": "PB200G-P2",
    "title": "Arlec IP44 2 Outlet Outdoor Power Garden Stake",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB200G-P2_1.jpg?v=1763459009"
  },
  {
    "sku": "CLS2-Y2-P2",
    "title": "Arlec IP44 Outdoor Cord Box CLS2-Y2-P - 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_IP44_Outdoor_Cord_Safe_Box_-_2_Pack_CLS2-Y2_1.jpg?v=1763447608"
  },
  {
    "sku": "PB36B",
    "title": "Arlec IP55 6 Outlet Weatherproof Powerboard With Surge Protection",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB36B.jpg?v=1780392785"
  },
  {
    "sku": "EVP16A",
    "title": "Arlec IP65 2.4kW Type 2 Portable Charger With 7m Cable",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0871/6225/7691/files/EVP16A.pdf?v=1730775213",
    "datasheet": "https://cdn.shopify.com/s/files/1/0871/6225/7691/files/EVP16A_data_sheet_v1.0.pdf?v=1735557407",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_IP65_2.4kW_Type_2_Connector_EV_Portable_Charger_With_7m_Cable_EVP16A.jpg?v=1762751611"
  },
  {
    "sku": "CSF8730WHL",
    "title": "Arlec Kinder White 3-Blade 87cm AC Ceiling Fan with Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CSF8730WHL_CPIN006329OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Kinder_White_3-Blade_87cm_AC_Ceiling_Fan_CSF8730WHL.jpg?v=1762751793"
  },
  {
    "sku": "LVS611",
    "title": "Arlec Ladybug LED Garden Lantern",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS611.png?v=1788343402"
  },
  {
    "sku": "NL0001",
    "title": "Arlec LED Automatic Dusk To Dawn Nightlight - 3 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_LED_Automatic_Dusk_To_Dawn_Nightlight_-_3_Pack_NL0001.jpg?v=1762753930"
  },
  {
    "sku": "NL0003",
    "title": "Arlec LED Bumble Bee Nightlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL0003_CPIN003136.pdf?v=1754379024",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_LED_Bumble_Bee_Nightlight_NL0003.jpg?v=1762754082"
  },
  {
    "sku": "NL2544-2",
    "title": "Arlec LED Flashing Glow Stick with Strobing Effect - Pack of 2",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL2544-2.jpg?v=1765263962"
  },
  {
    "sku": "LVS042",
    "title": "Arlec LED Garden Path Solar Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_LED_Garden_Path_Solar_Light_LVS042.jpg?v=1762753282"
  },
  {
    "sku": "NL0002",
    "title": "Arlec LED Lady Bug Nightlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL0002_CPIN003136_3OL.pdf?v=1754379034",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_LED_Lady_Bug_Nightlight_NL0002.jpg?v=1762753905"
  },
  {
    "sku": "NL301",
    "title": "Arlec LED Plug-In Dusk to Dawn Night Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_9W_720lm_RGB_CCT_Grid_Connect_Smart__LED_Downlight_NL301.jpg?v=1762754203"
  },
  {
    "sku": "LVS668BK",
    "title": "Arlec LED Solar Fence Light - 4 Pack",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS668BK_CPIN004153_OL.pdf?v=1754378978",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_LED_Solar_Fence_Light_-_4_Pack__LVS668BK.jpg?v=1762753475"
  },
  {
    "sku": "LVS532",
    "title": "Arlec LED Vintage Glass Effect Accent Solar Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS532_CPIN005242_2_OL.pdf?v=1754378977",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_LED_Vintage_Glass_Effect_Accent_Solar_Light_LVS532.jpg?v=1762753387"
  },
  {
    "sku": "LVS531",
    "title": "Arlec LED Wave Glass Effect Accent Solar Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS531_CPIN005242_OL.pdf?v=1754378975",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_LED_Wave_Glass_Effect_Accent_Solar_Light_LVS531.jpg?v=1762753533"
  },
  {
    "sku": "NL0046",
    "title": "Arlec LED Wireless Linkable Sensor Light Kit",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL0046_CPIN004080_2.pdf?v=1754379023",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_LED_Wireless_Linkable_Sensor_Light_Kit_NL0046.jpg?v=1762753960"
  },
  {
    "sku": "LVE355",
    "title": "Arlec Light Flame Effect Plastic Candle Black",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Light_Flame_Effect_Plastic_Candle_Black_LVE355.jpg?v=1762829726"
  },
  {
    "sku": "LVE358",
    "title": "Arlec Light Flame Effect Plastic Candle With Glass Black Base",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Light_Flame_Effect_Plastic_Candle_With_Glass_Black_Base_LVE358.jpg?v=1762829686"
  },
  {
    "sku": "LVE357",
    "title": "Arlec Light Flame Effect Plastic Candle With Glass Timber Look Base",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Light_Flame_Effect_Plastic_Candle_With_Glass_Timber_Look_Base_LVE357.jpg?v=1762829677"
  },
  {
    "sku": "NL4003",
    "title": "Arlec Linkable Nightlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL4003_CPIN006620OL.pdf?v=1754379029",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Linkable_Nightlight_NL4003_1.jpg?v=1762754055"
  },
  {
    "sku": "NL4074-2",
    "title": "Arlec Linkable Sensor Nightlight Twin Pack",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL4074-2_CPIN006620_3OL.pdf?v=1754379037",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Linkable_Sensor_Nightlight_Twin_Pack_NL4074-2.jpg?v=1762753988"
  },
  {
    "sku": "LVX999",
    "title": "Arlec Low Voltage 100 LED Multi-colour Music Sync String Lights",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX999_CPIN006594.pdf?v=1754379021",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_100_LED_Multi-Colour_Music_String_Lights_LVX999.jpg?v=1762830139"
  },
  {
    "sku": "LVE908HA",
    "title": "Arlec Low Voltage 4 RGBW LED Smart Bollard Lights",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE908HA.pdf?v=1754454979",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4_Smart_Low_Voltage_RGBW_LED_Bollard_Lights_LVE908HA.jpg?v=1762830161"
  },
  {
    "sku": "LVE907HA",
    "title": "Arlec Low Voltage 4 RGBW LED Smart Spot Lights",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE907HA_LVE980HA_CPIN006590.pdf?v=1754378975",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4_Smart_Low_Voltage_RGBW_LED_Spot_Lights_LVE907HA.jpg?v=1762830147"
  },
  {
    "sku": "LVX998",
    "title": "Arlec Low Voltage 70 LED Multi-colour Music Pre-Shaped Lights (Star or Tree)",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX998_CPIN006595_OL.pdf?v=1754379025",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_70_LED_Multi-Colour_Music_Pre-Shaped_Lights__Star_or_Tree__LVX998.jpg?v=1762830122"
  },
  {
    "sku": "LV1994",
    "title": "Arlec Low Voltage Halloween Projector Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV1994.png?v=1780035907"
  },
  {
    "sku": "LVX1853",
    "title": "Arlec Low Voltage Laser Projector With Speaker",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1853.jpg?v=1765272964"
  },
  {
    "sku": "LVX1849",
    "title": "Arlec Low Voltage LED Acrylic Penguin",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1849.jpg?v=1765273955"
  },
  {
    "sku": "LVX789",
    "title": "Arlec Low Voltage LED Candle Stake Lights With Flame Effect - Pack of 3",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX789.pdf?v=1784004544",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX789.jpg?v=1784004356"
  },
  {
    "sku": "LVX1852",
    "title": "Arlec Low Voltage LED Christmas Projector Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1852.jpg?v=1765271622"
  },
  {
    "sku": "LVX1108",
    "title": "Arlec Low Voltage Snow Falling Light Projector",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1108_CPIN007254OL.pdf?v=1754379041",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Snow_Falling_Light_Projector_LVX1108.jpg?v=1762830174"
  },
  {
    "sku": "LVS637CM",
    "title": "Arlec Lumina Cool White and Blue Solar Deck Light - Pack of 2",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS637CM_IM.pdf?v=1793081586",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS637CM.png?v=1793081957"
  },
  {
    "sku": "SH131HA",
    "title": "Arlec Lumiray Grid Connect Smart Laser Robot Vacuum & Mop",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/SH135HA.pdf?v=1761633597",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/SH131HA.jpg?v=1762757314"
  },
  {
    "sku": "SH135HA",
    "title": "Arlec Lumiray Plus Grid Connect Smart Laser Robot Vacuum & Mop With Auto-Empty Dock",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/SH135HA.pdf?v=1761633597",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/SH135HA.jpg?v=1762757327"
  },
  {
    "sku": "DCF4001BHA",
    "title": "Arlec Madrid Black 4-Blade 130cm Grid Connect Smart DC Ceiling Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DCF4001BHA_CPIN004931-4_OL.pdf?v=1754378978",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Madrid_Black_4-Blade_130cm_Grid_Connect_Smart_DC_Ceiling_Fan_DCF4001BHA.jpg?v=1762751812"
  },
  {
    "sku": "DCF4002BHA",
    "title": "Arlec Madrid Black 4-Blade 130cm Grid Connect Smart DC Ceiling Fan with Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DCF4002BHA_CPIN004892-4_OL.pdf?v=1754378971",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Madrid_Black_4-Blade_130cm_Grid_Connect_Smart_DC_Ceiling_Fan_DCF4002BHA.jpg?v=1762751925"
  },
  {
    "sku": "DCF4002WHA",
    "title": "Arlec Madrid White 4-Blade 130cm Grid Connect Smart DC Ceiling Fan with Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DCF4002WHA_CPIN004892-4_OL.pdf?v=1754378971",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Madrid_White_4-Blade_130cm_Grid_Connect_Smart_DC_Ceiling_Fan_DCF4002WHA_193377f3-64cd-4de8-878f-a15cdebaddb2.jpg?v=1762751914"
  },
  {
    "sku": "DCF4001WHA",
    "title": "Arlec Madrid White 4-Blade 130cm Grid Connect Smart DC Ceiling Fan With Remote",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DCF4001BHA_CPIN004931-4_OL.pdf?v=1754378978",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DCF4001WHA_dad278b6-606f-4627-a082-ca55ddd158ab.jpg?v=1768985271"
  },
  {
    "sku": "DCF52424WL",
    "title": "Arlec Maison 4-Blade 132cm DC Ceiling Fan with CCT and Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DCF52424WL_CPIN007861_OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Maison_132CM_4_Blade_ABS_CCT_Light_Remote_DC_Ceiling_Fan_DCF52424WL.jpg?v=1762829147"
  },
  {
    "sku": "ABL112WH",
    "title": "Arlec Matte White Versa LED Adjustable Beam Angle Up & Down Exterior Wall Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL112WH.png?v=1793604250"
  },
  {
    "sku": "CSF7602BL",
    "title": "Arlec Maxy Black 5-Blade 76cm AC Ceiling Fan With Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CSF7602BL_CPIN005662-3OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Maxy_Black_5-Blade_76cm_AC_Ceiling_Fan_With_Light_CSF7602BL.jpg?v=1762751960"
  },
  {
    "sku": "LVS633",
    "title": "Arlec Mesa RGB or Cool White Solar Path Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS633.png?v=1788496994"
  },
  {
    "sku": "NL0019",
    "title": "Arlec Mini Plug In Nightlight - 3 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Mini_Plug_In_Nightlight_-_3_Pack_NL0019.jpg?v=1762754074"
  },
  {
    "sku": "NL0020",
    "title": "Arlec Mini Plug-In Nightlight",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ARLEC_Mini_Plug-In_Nightlight_NL0020.jpg?v=1762753999"
  },
  {
    "sku": "NL0010",
    "title": "Arlec Mini Q-Shaped Auto Night Light - Twin Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Mini_Q-Shaped_Auto_Night_Light_-_Twin_Pack_NL0010_fdfa8a08-87ee-4a86-bb5d-4a29ed728488.jpg?v=1762753896"
  },
  {
    "sku": "BEDL2-MJ",
    "title": "Arlec Misty Jade 2m Ordinary Duty Braided Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/BEDL2-MJ.png?v=1784798594"
  },
  {
    "sku": "BEDL5-MJ",
    "title": "Arlec Misty Jade 5m Ordinary Duty Braided Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/BEDL5-MJ_2.png?v=1784798901"
  },
  {
    "sku": "NL4134",
    "title": "Arlec Motion Activated Nightlight",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Motion_Activated_Nightlight_NL4134.jpg?v=1762753968"
  },
  {
    "sku": "DC700",
    "title": "Arlec Multi Colour Battery Operated Wireless Door Chime",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DC700_CPIN004290.pdf?v=1754378964",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Multi_Colour_Battery_Operated_Wireless_Door_Chime_DC700.jpg?v=1762830430"
  },
  {
    "sku": "LV1612",
    "title": "Arlec Multi Colour Low Voltage LED Garden Arch Rope Light Stakes - Pack of 4",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV1612_CPIN006130_3OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4_Pack_Multi_Colour_LED_Garden_Arch_Rope_light_Stakes_Low_Voltage_LV1612.jpg?v=1762829790"
  },
  {
    "sku": "NL210",
    "title": "Arlec Multipurpose LED Push Light Set",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Multipurpose_LED_Push_Light_Set_NL210.jpg?v=1762754213"
  },
  {
    "sku": "LVE098",
    "title": "Arlec Mushroom Ambient Touch Lamp",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE098CPIN008194_OL.pdf?v=1754378974",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Mushroom_Ambient_Touch_Lamp_LVE098.jpg?v=1762829667"
  },
  {
    "sku": "ARLCT200-150",
    "title": "Arlec Natural 150 x 3.5mm Cable Ties- 200 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ARLEC_150_x_3.5mm_Cable_Ties_Natural_-_200_Pack_ARLCT200-150.jpg?v=1762755048"
  },
  {
    "sku": "NL4289",
    "title": "Arlec Neon Rainbow Wall Mounted Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL4289CPIN006739_OL.pdf?v=1754379033",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Neon_Rainbow_Wall_Mounted_Light_NL4289.jpg?v=1762830468"
  },
  {
    "sku": "NL4074",
    "title": "Arlec Night Glow Linkable Night Light - 2 Pack",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL4074_CPIN006620_3OL.pdf?v=1754379041",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Night_Glow_Linkable_Night_Light_-_2_Pack__NL4074.jpg?v=1762754115"
  },
  {
    "sku": "NL4253",
    "title": "Arlec Night Light with Dusk to Dawn Switch-on Sensor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Night_Light_with_Dusk_to_Dawn_Switch-on_Sensor_NL4253.jpg?v=1762753883"
  },
  {
    "sku": "DCF5236WL",
    "title": "Arlec Nusa 3-Blade 130cm DC Ceiling Fan with CCT and Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DCF5236WL_CPIN007662_3_OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Nusa_3-Blade_130cm_DC_Ceiling_Fan_with_CCT_and_Remote_Control_DCF5236WL.jpg?v=1762751875"
  },
  {
    "sku": "PB970",
    "title": "Arlec Orange 1.8m & 4-Outlets Heavy Duty Power Block",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB970_CPIN005047.pdf?v=1754379035",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_15A_4_Outlet_Heavy_Duty_Power_Block_with_Safety_Switch_PB970.jpg?v=1762829463"
  },
  {
    "sku": "PB960",
    "title": "Arlec Orange 1.8m & 4-Outlets Heavy Duty Power Block with Safety Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Orange_1.8m_4-Outlets_Heavy_Duty_Power_Block_with_Safety_Switch_PB960_1.jpg?v=1762752727"
  },
  {
    "sku": "PB940FS",
    "title": "Arlec Orange 1.8m & 4-Outlets Heavy Duty Power Block with Type FS RCD",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB940FS_CPIN006363_2_OL.pdf?v=1754379039",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4_Outlet_Portable_Power_Block_with_Type_FS_RCD_Safety_Switch_PB940FS.jpg?v=1762752716"
  },
  {
    "sku": "PB960U",
    "title": "Arlec Orange 1.8m Heavy Duty Power Block with USB Charger",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB960CPIN005046.pdf?v=1754379037",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4_Outlet_Heavy_Duty_Portable_Safety_Switch_with_Double_USB_PB960U_61bf8d70-1736-489b-a022-9c900f06fb63.jpg?v=1762829454"
  },
  {
    "sku": "ORE18",
    "title": "Arlec Orange 1.8m Heavy Duty Safety Extension Lead with In Line RCD Safety Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ORE18_IM.pdf?v=1754379037",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1.8m_Heavy_Duty_Extension_Lead_ORE18.jpg?v=1762752393"
  },
  {
    "sku": "PB92M",
    "title": "Arlec Orange 10A to 15A Compact Single Outlet Power Adaptor with MCB Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB92MCPIN008118_OL.pdf?v=1754379039",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_10A_to_15A_Compact_Single_Power_Adaptor_PB92M_6c5f63b2-0d86-4b33-b8ff-7164f7ca5097.jpg?v=1762829421"
  },
  {
    "sku": "PB92",
    "title": "Arlec Orange 10A to 15A Compact Single Outlet Power Adaptor with RCBO Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB92_CPIN006288_3OL.pdf?v=1754379038",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB92.jpg?v=1762752670"
  },
  {
    "sku": "PB93M",
    "title": "Arlec Orange 10A to 15A Single Outlet Power Adaptor with MCB Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB93M_CPIN008258_OL.pdf?v=1754379039",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB93M_d313feba-3fca-495e-b5f5-c28cd977b991.jpg?v=1777424640"
  },
  {
    "sku": "PB93",
    "title": "Arlec Orange 10A to 15A Single Outlet Power Adaptor with RCBO Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB93_CPIN005803_4OL.pdf?v=1754379039",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_10A_To_15A_Single_Outlet_Power_Adaptor_PB93.jpg?v=1762752678"
  },
  {
    "sku": "CNZR10",
    "title": "Arlec Orange 10m Heavy Duty Camping Power Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Heavy_Duty_Camping_Power_Lead_CNZR10.jpg?v=1762752170"
  },
  {
    "sku": "CEL15D",
    "title": "Arlec Orange 15m Extra Heavy Duty Caravan Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_15m_15a_Extra_Heavy_Duty_Caravan_Extension_Lead_CEL15D.jpg?v=1762752124"
  },
  {
    "sku": "ORE15",
    "title": "Arlec Orange 15m Safety Extension Lead with In Line RCD Safety Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ORE15_IM.pdf?v=1754379029",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_15m_Orange_In-Line_Safety_Switch_Heavy_Duty_Lead_Extension_ORE15.jpg?v=1762752384"
  },
  {
    "sku": "WL0027",
    "title": "Arlec Orange 2 x 3W 400lm Multi Purpose Portable LED Work Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/WL0027_CPIN004224_3_OL.pdf?v=1754379101",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2_x_3W_400lm_Multi_Purpose_Portable_LED_Work_Light_WL0027.jpg?v=1762756547"
  },
  {
    "sku": "CEL20",
    "title": "Arlec Orange 20m Extra Heavy Duty Caravan Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec20m15AExtraHeavyDutyCaravanExtensionLead_CEL20.jpg?v=1762752133"
  },
  {
    "sku": "WL0170",
    "title": "Arlec Orange 20W 1500lm Rechargeable LED Work Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/WL0170_CPIN005817-2_OL.pdf?v=1754379104",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_20W_1500lm_Rechargeable_LED_Work_Light__WL0170.jpg?v=1762756661"
  },
  {
    "sku": "PB94",
    "title": "Arlec Orange 2m & 4-Outlet Portable Power Block with Safety Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB94CPIN612_5_OL.pdf?v=1754379043",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4_Outlet_Portable_Power_Block_with_Safety_Switch_PB94.jpg?v=1762752700"
  },
  {
    "sku": "PB970-L",
    "title": "Arlec Orange 2m & 4-Outlets Heavy Duty Power Block",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB970-LCPIN007855_OL.pdf?v=1754379040",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_15A_4_Outlet_Heavy_Duty_Power_Block_with_Safety_Switch_PB970-L_1.jpg?v=1762752755"
  },
  {
    "sku": "PB960UPD",
    "title": "Arlec Orange 2m & 4-Outlets Heavy Duty Power Block with PD20W Fast Charging USB C",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB960UPD_CPIN007817_2_OL.pdf?v=1754379040",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4_Outlet_Heavy_Duty_Portable_Safety_Switch_with_Double_USB_PB960U.jpg?v=1762752747"
  },
  {
    "sku": "PB960-L",
    "title": "Arlec Orange 2m & 4-Outlets Heavy Duty Power Block with Safety Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB960-LCPIN007811_OL.pdf?v=1754379040",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_10A_4_Outlet_Heavy_Duty_Power_Block_with_Safety_Switch_PB960-L_1.jpg?v=1762752730"
  },
  {
    "sku": "PB960FS",
    "title": "Arlec Orange 2m& 4-Outlets Heavy Duty Power Block with Type FS RCD",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB960FS_CPIN006362_2_OL.pdf?v=1754379040",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4_Outlet_Heavy_Duty_Portable_Power_Block_with_Type_FS_RCD_Safety_Switch_PB960FS.jpg?v=1762752737"
  },
  {
    "sku": "WL0030",
    "title": "Arlec Orange 30W 2100lm Rechargeable LED Work Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/WL0030_CPIN004524_3_OL.pdf?v=1754379100",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_30W_2100lm_Rechargeable_LED_Work_Light_WL0030.jpg?v=1762756557"
  },
  {
    "sku": "WL0038",
    "title": "Arlec Orange 4000lm Dual Power Worklight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/WL0038_CPIN007904-2_OL.pdf?v=1754379100",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4000lm_Dual_Power_Worklight_WL0038.jpg?v=1762756566"
  },
  {
    "sku": "PB36",
    "title": "Arlec Orange 6-Outlet Weather Protected Powerboard",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB36CPIN004941.pdf?v=1754379033",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_IP55_6_Outlet_Weatherproof_Powerboard_PB36.jpg?v=1762752589"
  },
  {
    "sku": "PB36B-HW-OB",
    "title": "Arlec Orange and Black Halloween 6-Outlet Weatherproof Powerboard with Surge Protection",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB36B-HW-OB.png?v=1784182492"
  },
  {
    "sku": "DPBH10",
    "title": "Arlec Orange and Black Twin Outlet Power Handle",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Twin_Outlet_Power_Handle_DPBH10.jpg?v=1762752320"
  },
  {
    "sku": "AWL2312",
    "title": "Arlec Orange LED Rechargeable Inspection Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWL2312_CPIN007392-2_OL.pdf?v=1754378924",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1200lm_LED_Rechargeable_Inspection_Light_AWL2312.jpg?v=1762755187"
  },
  {
    "sku": "CLS2",
    "title": "Arlec Orange Outdoor Safety Cord Box",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_IP44_Outdoor_Safety_Box_CLS2.jpg?v=1762752150"
  },
  {
    "sku": "PB91",
    "title": "Arlec Orange Plug In RCD Safety Switch",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB91CPIN002878_3_OL.pdf?v=1754379040",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Single_Outlet_Safety_Switch_PB91.jpg?v=1762752663"
  },
  {
    "sku": "PB970FS",
    "title": "Arlec Orange Type FS RCD 2 metre & 4-Outlets Heavy Duty Power Block",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB970FS_CPIN006361_2_OL.pdf?v=1754379040",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_15A_4_Outlet_Heavy_Duty_Portable_Power_Block_with_Type_FS_RCD_Safety_Switch_PB970FS.jpg?v=1762752763"
  },
  {
    "sku": "PB4MBR-PK-K",
    "title": "Arlec Pink 4-Outlet Powerboard with Braided Power Cord",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Pink_4-Outlet_Powerboard_with_Braided_Power_Cord_PB4MBR-PK-K.jpg?v=1762752469"
  },
  {
    "sku": "PB4-Z-K",
    "title": "Arlec Pink 4-Outlet Zig Zag Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Pink_4-Outlet_Zig_Zag_Powerboard_PB4-Z-K.jpg?v=1762751618"
  },
  {
    "sku": "BREL5-PK-K",
    "title": "Arlec Pink 5m Braided Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Pink_5m_Braided_Extension_Lead_BREL5-PK-K_1.jpg?v=1762752108"
  },
  {
    "sku": "WEL3-PIPU-K",
    "title": "Arlec Pink and Purple Domestic 3m Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Pink_and_Purple_Domestic_3m_Extension_Lead_WEL3-PIPU-K_1.jpg?v=1762752916"
  },
  {
    "sku": "PB8WUPD-B-K",
    "title": "Arlec Pink Beads 8 Outlet Powerboard with Wide Spaced Outlets and USB A&C Ports",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB8WUPD-B-K.jpg?v=1762751625"
  },
  {
    "sku": "NL9102P",
    "title": "Arlec Pink Ceramic Flower Lamp",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL9102P.png?v=1781066182"
  },
  {
    "sku": "PB5RU-H-K",
    "title": "Arlec Pink Hexagon 5 Outlet Powerboard with USB A & C Charging Ports",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Pink_Hexagon_5_Outlet_Powerboard_with_USB_A___C_Charging_Ports_PB5RU-H-K.jpg?v=1762751634"
  },
  {
    "sku": "PB3RUPD-TWCLPI",
    "title": "Arlec Pink Tweenie Cloud 3-Outlet Fast Charging USB Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB3RUPD-TWCLPI.png?v=1784179962"
  },
  {
    "sku": "PB3RUPD-TWHRPI",
    "title": "Arlec Pink Tweenie Heart 3-Outlet Fast Charging USB Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB3RUPD-TWHRPI.png?v=1784178194"
  },
  {
    "sku": "PB6K-W-K",
    "title": "Arlec Pink Wave 6-Outlet Powerboard with Master Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Pink_Wave_6-Outlet_Powerboard_with_Master_Switch_PB6K-W-K.jpg?v=1762751645"
  },
  {
    "sku": "DC681",
    "title": "Arlec Plug In Modern Compact Design Door Chime",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DC681_CPIN002793-5_1.pdf?v=1754378963",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Plug_In_Modern_Compact_Design_Door_Chime_DC681.jpg?v=1762830435"
  },
  {
    "sku": "KDCP01",
    "title": "Arlec Plug-in Door Chime With 100m Wireless Kinetic Push Button - White",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/KDCP01_CPIN007698-2OL.pdf?v=1754378975",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Plug-in_Door_Chime_With_100m_Wireless_Kinetic_Push_Button_-_White_KDCP01.jpg?v=1762753778"
  },
  {
    "sku": "KDC02",
    "title": "Arlec Plug-in Door Chime With 150m Wireless Kinetic Push Button - White",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/KDC02_CPIN007706_3_OL.pdf?v=1754378976",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Plug-in_Door_Chime_With_150m_Wireless_Kinetic_Push_Button_-_White_KDC02.jpg?v=1762753764"
  },
  {
    "sku": "PBHB2AC",
    "title": "Arlec Portable White Powerboard with USB A & USB C Outlets",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2_Outlet_Portable_Power_Board_With_USB-A___USB-C_PBHB2AC.jpg?v=1762752792"
  },
  {
    "sku": "DA36PD20",
    "title": "Arlec Power Adaptor with PD20W USB with 180 Rotating Socket",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_Plug_In_Multi-Function_Socket_With_USB_PD20W_DA36PD20.jpg?v=1762752270"
  },
  {
    "sku": "DC166",
    "title": "Arlec Premium 38 Sound Battery Powered Wireless Door Chime",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DC166_CPIN005642_3OL.pdf?v=1754378974",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Premium_38_Sound_Battery_Powered_Wireless_Door_Chime_DC166.jpg?v=1762753709"
  },
  {
    "sku": "DC166-2",
    "title": "Arlec Premium 38 Sound Battery Powered Wireless Door Chime - Twin Pack",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DC166-2_CPIN005642_3OL.pdf?v=1754378974",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AArlec_Premium_38_Sound_Battery_Powered_Wireless_Door_Chime_-_Twin_Pack_DC166-2.jpg?v=1762753751"
  },
  {
    "sku": "PB36B-HW-PB",
    "title": "Arlec Purple and Black Halloween 6-Outlet Weatherproof Powerboard with Surge Protection",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB36B-HW-PB.png?v=1784186573"
  },
  {
    "sku": "PB36B-HW-PG",
    "title": "Arlec Purple and Green Halloween 6-Outlet Weatherproof Powerboard with Surge Protection",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB36B-HW-PG.png?v=1784186716"
  },
  {
    "sku": "PB4-W-K",
    "title": "Arlec Purple Wave 4-Outlet Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Purple_Wave_4-Outlet_Powerboard_PB4-W-K.jpg?v=1762751651"
  },
  {
    "sku": "PB6K-Z-K",
    "title": "Arlec Purple Zig Zag 6-Outlet Powerboard with Master Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Purple_Zig_Zag_6-Outlet_Powerboard_with_Master_Switch_PB6K-Z-K.jpg?v=1762751659"
  },
  {
    "sku": "BEDL2-RW",
    "title": "Arlec Rain Wished 2m Ordinary Duty Braided Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/BEDL2-RW.jpg?v=1784797617"
  },
  {
    "sku": "NMH4AAA",
    "title": "Arlec Rechargeable AAA 900MAh Battery - 4 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "NL1648",
    "title": "Arlec Rechargeable Amber Motion Sensor Night Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL1648.png?v=1781674649"
  },
  {
    "sku": "NL614",
    "title": "Arlec Rechargeable Cat Paw Nightlight - Mint Green",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Rechargeable_Cat_Paw_Nightlight_-_Mint_Green_NL614.jpg?v=1762754139"
  },
  {
    "sku": "NL613",
    "title": "Arlec Rechargeable Cat Paw Nightlight - Pink",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL613_CPIN007999_OL.pdf?v=1754379029",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Rechargeable_Cat_Paw_Nightlight_-_Pink_NL613.png?v=1762754148"
  },
  {
    "sku": "NL0225",
    "title": "Arlec Rechargeable Clip Reading Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL0225_IM.pdf?v=1793082301",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL0225.png?v=1793082363"
  },
  {
    "sku": "RDL2",
    "title": "Arlec Rechargeable Fluorescent Lantern",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/a74b3abb-0cc1-4b26-9da3-b02c166defce.jpg?v=1763374833"
  },
  {
    "sku": "UC4630EXT",
    "title": "Arlec Rechargeable Linkable Puck Light Extension Pack - 1 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC4630EXT.png?v=1781861382"
  },
  {
    "sku": "UC4630KIT",
    "title": "Arlec Rechargeable Linkable Puck Light Kit With Remote - 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC4630KIT_1.png?v=1781861461"
  },
  {
    "sku": "NMHSOL3",
    "title": "Arlec Rechargeable Ni-MH 1000mAh High Capacity Battery- 4 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "NL9107",
    "title": "Arlec Rechargeable Night Light With White Noise Machine",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL9107.jpg?v=1781678582"
  },
  {
    "sku": "NL022",
    "title": "Arlec Rechargeable Toaster-Shaped Night Light - Pink",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL022CPIN008030_OL.pdf?v=1754379040",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Rechargeable_Toaster-Shaped_Night_Light_-_Pink_NL022.jpg?v=1762754156"
  },
  {
    "sku": "NL4296",
    "title": "Arlec Rectangle Linkable Ambient Nightlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL4296_CPIN006620_3OL.pdf?v=1754379038",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Rectangle_Linkable_Ambient_Nightlight_NL4296.jpg?v=1762754005"
  },
  {
    "sku": "NL4297",
    "title": "Arlec Rectangle Linkable Ambient Nightlight - Twin Pack",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL4297_CPIN007406_OL.pdf?v=1754379038",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Rectangle_Linkable_Ambient_Nightlight_-_Twin_Pack_NL4297.jpg?v=1762754089"
  },
  {
    "sku": "REL15",
    "title": "Arlec Red 15m Extra Heavy Duty Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_15m_1.5mm__10A_3_Core_Extra_Heavy_Duty_Extension_Lead_REL15_1.jpg?v=1762829488"
  },
  {
    "sku": "REL20",
    "title": "Arlec Red 20m Extra Heavy Duty Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_20m_1.5mm__10A_3_Core_Extra_Heavy_Duty_Extension_Lead_REL20.jpg?v=1762829499"
  },
  {
    "sku": "TEL20",
    "title": "Arlec Red 3 Tuff 20m Extra Heavy Duty Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_20m_Extra_Heavy_Duty_Triple_Socket_Extension_Lead_TEL20.jpg?v=1762829526"
  },
  {
    "sku": "REL30",
    "title": "Arlec Red 30m Extra Heavy Duty Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_30m_1.5mm__10A_3_Core_Extra_Heavy_Duty_Extension_Lead_REL30_1.jpg?v=1762829509"
  },
  {
    "sku": "LVX306",
    "title": "Arlec Red Christmas Ball",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX306_CPIN007267.pdf?v=1754378978",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Red_Christmas_Ball_String_Light_LVX306_1_da696df6-4fac-4659-99f7-77d508b01dd3.jpg?v=1762830048"
  },
  {
    "sku": "PB3RUPD-TWHRRE",
    "title": "Arlec Red Tweenie Heart 3-Outlet Fast Charging USB Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB3RUPD-TWHRRE_8fbe0412-ebd3-4f09-99eb-be6bdd4d5f10.png?v=1784179582"
  },
  {
    "sku": "CFR325",
    "title": "Arlec Remote Control Ceiling Fan Kit",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CFR325_CPIN002732_2_OL.pdf?v=1754378924",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Remote_Control_Ceiling_Fan_Kit_CFR325.jpg?v=1762751802"
  },
  {
    "sku": "LVE160HA",
    "title": "Arlec RGB Colour Changing Grid Connect Smart 160 LED Ball",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE1016HA_LVE160HA_CPIN006128_OL.pdf?v=1754378981",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_RGB_Colour_Changing_Grid_Connect_Smart_160_LED_Ball_Lights_LVE160HA.jpg?v=1762753094"
  },
  {
    "sku": "ALP218",
    "title": "Arlec RGB Cylinder Tower Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALP218_CPIN008311-2_OL.pdf?v=1764650573",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALP218.jpg?v=1764649408"
  },
  {
    "sku": "ALP325HA",
    "title": "Arlec RGB Grid Connect Smart Strip Light with Screen Sync and Camera Module",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALP325HA_CPIN007427_OL.pdf?v=1754378919",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_Multi-Colour_Screen_Sync_Strip_Light_ALP325HA.jpg?v=1762754975"
  },
  {
    "sku": "ALP313HA",
    "title": "Arlec RGB Grid Connect Smart Strip Light with Screen Sync and Colour Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALP313HA_CPIN007199_OL.pdf?v=1754378919",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ArlecRGBGridConnectSmartStripLightwithScreenSyncandColourSensor1.jpg?v=1765258546"
  },
  {
    "sku": "NL1011",
    "title": "Arlec RGBW Back-Lit Dimmable Night Light With Dusk To Dawn Sensor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL1011.png?v=1780551031"
  },
  {
    "sku": "NL1013",
    "title": "Arlec RGBW Night Light With Dusk To Dawn Sensor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL1013.png?v=1781762113"
  },
  {
    "sku": "UC507RGBW",
    "title": "Arlec RGBW Puck Light Kit With Remote - 4 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC507RGBW.png?v=1781859648"
  },
  {
    "sku": "NL0069",
    "title": "Arlec Rocket LED Motion Activated Night Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL0069CPIN004993_3_OL.pdf?v=1754379041",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Rocket_LED_Motion_Activated_Night_Light_NL0069.jpg?v=1762754108"
  },
  {
    "sku": "LVX1106",
    "title": "Arlec Rotating Stars Candle Light Projector With Remote",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1106_CPIN007253_OL.pdf?v=1754379041",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Rotating_Stars_Candle_Light_Projector_LVX1106.jpg?v=1762830183"
  },
  {
    "sku": "NL1041",
    "title": "Arlec Round Lit Square Shape Plug In Motion Sensor Night Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL1041.png?v=1781063229"
  },
  {
    "sku": "NL7001",
    "title": "Arlec Round Night Light with Dusk To Dawn Switch-on Sensor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Night_Light_With_Dusk_To_Dawn_Switch-on_Sensor_NL7001.jpg?v=1762754181"
  },
  {
    "sku": "NL4214",
    "title": "Arlec Round Night Light with Movement Activated Sensor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Night_Light_with_Movement_Activated_Sensor_NL4214.jpg?v=1762754174"
  },
  {
    "sku": "NL4102",
    "title": "Arlec Sensor Night Glow Linkable Night Light - 2 Pack",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL4102_CPIN006620OL.pdf?v=1754379029",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Sensor_Night_Glow_Linkable_Night_Light_-_2_Pack_NL4102_c4f66d64-4aa1-4c29-bf94-530dad8efe8d.jpg?v=1762830560"
  },
  {
    "sku": "EHB275P2",
    "title": "Arlec Silver 275W Infra-Red Heat Lamp - 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_High_Gloss_White_Finish_Modern_Plug-In_Door_Chime_EHB275P2.jpg?v=1762755422"
  },
  {
    "sku": "ALD268HA",
    "title": "Arlec Silver 2m Grid Connect Smart LED Strip Light with Sound Sync",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD268HA_CPIN007136_2_OL.pdf?v=1754378919",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_2m_Sound_Sync_Strip_Light_ALD268HA.jpg?v=1762754676"
  },
  {
    "sku": "PB68T",
    "title": "Arlec Silver 6-Outlet Surge Protected Wide Spaced Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_6_Outlet_Surge_Protected_Wide_Spaced_Powerboard_PB68T.jpg?v=1762829410"
  },
  {
    "sku": "LVX307",
    "title": "Arlec Silver Christmas Ball",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX307_CPIN007267.pdf?v=1754379024",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Silver_Christmas_Ball_String_Light_LVX307.jpg?v=1762830064"
  },
  {
    "sku": "AM122",
    "title": "Arlec Slim Window Vibration Alarm",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AM122_CPIN007893_OL.pdf?v=1754378918",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Slim_Window_Vibration_Alarm_AM122.jpg?v=1762753832"
  },
  {
    "sku": "ATBL821MS",
    "title": "Arlec Small Graffiti Sitting Mouse",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CPIN008475_OL.pdf?v=1767848290",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ATBL821MS.jpg?v=1767850816"
  },
  {
    "sku": "ATBL821RB",
    "title": "Arlec Small Graffiti Sitting Rabbit",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CPIN008475_OL.pdf?v=1767848290",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ATBL821RB.jpg?v=1767849993"
  },
  {
    "sku": "ATBL821FR",
    "title": "Arlec Small Graffiti Standing Frog",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CPIN008475_OL.pdf?v=1767848290",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ATBL821FR.jpg?v=1767848980"
  },
  {
    "sku": "APDC40326BHA",
    "title": "Arlec Smart 40cm DC Pedestal Fan With Remote",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/APDC40326BHA_IM.pdf?v=1783932765",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/APDC40326BHA_312f06a6-56d8-4848-b822-7bcf2fa452b6.png?v=1783933664"
  },
  {
    "sku": "LVE1021HA",
    "title": "Arlec Smart 50 RGB Low Voltage LED Small Berry String Lights",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE1017HA_LVE1018HA_LVE1019HA_LVE1021HA_LVE1022HA_CPIN006114_OL.pdf?v=1754378982",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_SMART_50_RGB_LED_Small_Berry_String_Lights_Low_Voltage_LVE1021HA.jpg?v=1762829820"
  },
  {
    "sku": "CEH243HA",
    "title": "Arlec Smart Grid Connect 2400W Tower Heater",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CEH243HA_CPIN008090_OL.pdf?v=1754378924",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Smart_Grid_Connect_2400W_Tower_Heater_CEH243HA_1.jpg?v=1762756727"
  },
  {
    "sku": "RMO370HA",
    "title": "Arlec Smart Grid Connect 4-in-1 Remote",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/RMO370HA.pdf?v=1789458117",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/RMO370HA.png?v=1789458763"
  },
  {
    "sku": "LVE800HA",
    "title": "Arlec Smart Grid Connect 800 LED Bud Lights",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE800HA_CPIN005419.pdf?v=1754378976",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Smart_800_LED_Bud_Lights_With_Grid_Connect_LVE800HA.jpg?v=1762753103"
  },
  {
    "sku": "PB4PDBRST-P",
    "title": "Arlec Smokey Taupe 4-Outlet Powerboard PD30W USB A&C with Braided Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4_Outlet_PD30W_Rapid_Charge_Powerboard_Simply_Taupe_PB4PDBRST-P.jpg?v=1762829287"
  },
  {
    "sku": "LVX527",
    "title": "Arlec Solar Gingerbread Family Stake Light - Pack of 6",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX527.pdf?v=1784001704",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX527_c45bba8e-6a1e-4a67-84d6-b0a70c8ada58.png?v=1793091436"
  },
  {
    "sku": "LV1997",
    "title": "Arlec Solar Laser Projector With Speaker",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV1997_CPIN008635_OL.pdf?v=1783676245",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LV1997.jpg?v=1783675503"
  },
  {
    "sku": "LVS667BK",
    "title": "Arlec Solar LED Fence Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS667BK_CPIN004153OL.pdf?v=1754378976",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Solar_LED_Fence_Light_LVS667BK.jpg?v=1762830225"
  },
  {
    "sku": "LVE388",
    "title": "Arlec Solar Light Rattan Candle",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Solar_Light_Rattan_Candle_LVE388.jpg?v=1762829703"
  },
  {
    "sku": "LVS04LINK",
    "title": "Arlec Solar Linkable Round Outdoor Wall Light with PIR Motion Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS04LINK_IM.pdf?v=1790832946",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS04LINK.png?v=1790576026"
  },
  {
    "sku": "LVS02LINK",
    "title": "Arlec Solar Linkable Twin Head Security Flood Light With PIR Motion Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS02LINK_IM.pdf?v=1790832947",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS02LINK.png?v=1790576469"
  },
  {
    "sku": "LVX1781",
    "title": "Arlec Solar Poly Resin Gingerbread Man Festive Stake Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Solar_Poly_Resin_Gingerbread_Man_Festive_Stake_Light_LVX1781.jpg?v=1762753654"
  },
  {
    "sku": "LVX1780",
    "title": "Arlec Solar Poly Resin Soldier Festive Stake Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Solar_Poly_Resin_Soldier_Festive_Stake_Light_LVX1780.jpg?v=1762753641"
  },
  {
    "sku": "LVE188",
    "title": "Arlec Solar Powered 10m Warm White Thin LED Rope Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE188_LVE189_LVE190_CPIN004583_7_OL_1.pdf?v=1784006147",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE188_a37d0887-72d1-401d-8051-b39687bffbf2.jpg?v=1784006105"
  },
  {
    "sku": "LVS288",
    "title": "Arlec Solar Powered Dog Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Solar_Powered_Dog_Light_LVS288.png?v=1762830237"
  },
  {
    "sku": "LVS290",
    "title": "Arlec Solar Powered Toadstool LED Stake Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Toadstool_Solar_Powered_LED_Stake_Light_LVS290.jpg?v=1762830283"
  },
  {
    "sku": "LVX528",
    "title": "Arlec Solar Santa and Candy Cane Stake Light - Pack of 5",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX528.pdf?v=1784004069",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX528.png?v=1784003861"
  },
  {
    "sku": "LVS666SS",
    "title": "Arlec Solar Wall Light With Motion Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS666SS_CPIN004152.pdf?v=1754378972",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Solar_Wall_Light_With_Motion_Sensor_LVS666SS.jpg?v=1762753397"
  },
  {
    "sku": "ABL204",
    "title": "Arlec Stainless Steel 10W LED Marine Grade Down Wall Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL204_CPIN003315.pdf?v=1754378911",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_5W_LED_Marine_Grade_Wall_Light_ABL204.jpg?v=1762754406"
  },
  {
    "sku": "ABL203",
    "title": "Arlec Stainless Steel 5W LED Marine Grade Down Wall Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL203_CPIN003260.pdf?v=1754378911",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_5W_240V_LED_Marine_Grade_Wall_Light_ABL203.jpg?v=1762754398"
  },
  {
    "sku": "ABL206",
    "title": "Arlec Stainless Steel Marine Grade Adjustable LED Wall Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL206_CPIN003261.pdf?v=1754378912",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_5W_Marine_Grade_Adjustable_LED_Wall_Light_ABL206.jpg?v=1762754418"
  },
  {
    "sku": "ABL110SS",
    "title": "Arlec Stainless Steel Oval Caged Bunker Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL110SS_1.png?v=1790849830"
  },
  {
    "sku": "ABL111RSS",
    "title": "Arlec Stainless Steel Round CCT LED Exterior Step Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL111RBK_SeriesCPIN007668_OL.pdf?v=1754378914",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL111RSS.png?v=1791520726"
  },
  {
    "sku": "ABL204HA",
    "title": "Arlec Stainless Steel Smart Grid Connect LED Marine Grade Down Wall Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL204HA_CPIN004679-4.pdf?v=1754378917",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_Up_And_Down_LED_Wall_Light_ABL204HA.jpg?v=1762830648"
  },
  {
    "sku": "ABL104",
    "title": "Arlec Stainless Steel Up Down Wall Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL104_IM.pdf?v=1793604089",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "NL0028",
    "title": "Arlec Toadstool Night Light With AAA Batteries",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL0028CPIN007800_OL.pdf?v=1754379033",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Toadstool_Night_Light_With_AAA_Batteries_NL0028.jpg?v=1762830541"
  },
  {
    "sku": "NL022M",
    "title": "Arlec Toaster-Shaped Rechargeable Night Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL022M_CPIN008030_OL.pdf?v=1754379031",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Toaster-Shaped_Rechargeable_Night_Light_NL022M.jpg?v=1762754130"
  },
  {
    "sku": "NL101CCT",
    "title": "Arlec Touch Dimmable Multifunction CCT Night Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL101CCT.png?v=1781066801"
  },
  {
    "sku": "NL4207",
    "title": "Arlec Triangle Night Light With Movement Activated Sensor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Night_Light_With_Movement_Activated_Sensor_NL4207_2_e6eba1c8-7c7c-4906-bac9-02f0f5deb33e.jpg?v=1762754190"
  },
  {
    "sku": "NL0073",
    "title": "Arlec UFO LED Projector Night Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL0073CPIN004990-2OL.pdf?v=1754379031",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_UFO_LED_Projector_Night_Light_NL0073.jpg?v=1762754065"
  },
  {
    "sku": "UC471EXT",
    "title": "Arlec Ultra-thin Cabinet Light Extension Kit",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC471EXT_1db25fac-42f1-4340-a80a-e8946ff630fc.png?v=1781247651"
  },
  {
    "sku": "LVS536",
    "title": "Arlec Up and Down Solar Wall Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS536_CPIN007624OL.pdf?v=1754378981",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Up_and_Down_Solar_Wall_Light_LVS536.jpg?v=1762830330"
  },
  {
    "sku": "NL0216-5P",
    "title": "Arlec USB LED Laptop Light  5 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL0216-5P.png?v=1793080485"
  },
  {
    "sku": "NL9104RGB",
    "title": "Arlec USB Mini Night Light - 10 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL9104RGB_36b20864-8602-4036-94e3-509edc49c3ae.jpg?v=1781677339"
  },
  {
    "sku": "NL153DF",
    "title": "Arlec USB Powered RGBW Aroma Diffuser",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL153DF.png?v=1781672654"
  },
  {
    "sku": "LVE090",
    "title": "Arlec Warm White Ambient Touch Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVE090_CPIN007738_OL.pdf?v=1754378974",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Warm_White_Ambient_Touch_Light_LVE090.jpg?v=1762829714"
  },
  {
    "sku": "DA51",
    "title": "Arlec White 1 Outlet Premium Surge Adaptor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Premium_Surge_Adaptor_-_1_Outlet_DA51.jpg?v=1762752288"
  },
  {
    "sku": "PB45L",
    "title": "Arlec White 1.8m 4-Outlet Powerboard with Surge Protection & On/Off Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1.8m_Lead_Surge_Protected_Powerboard_PB45L.jpg?v=1762829119"
  },
  {
    "sku": "WEL18D",
    "title": "Arlec White 1.8m Dual Outlet Split Domestic Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1.8m_Domestic_Dual_Outlet_Split_Extension_Lead_WEL18D_1.jpg?v=1762752968"
  },
  {
    "sku": "EPL10",
    "title": "Arlec White 10 metre Ring Pull Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_10m_White_Ring_Pull_Extension_Lead_EPL10_1.jpg?v=1762752373"
  },
  {
    "sku": "ALD965HA",
    "title": "Arlec White 10m 2000lm Grid Connect Smart LED Strip Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD965HA_CPIN006978_OL.pdf?v=1754378917",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_10m_Grid_Connect_Smart_CCT_Strip_Light_ALD965HA.jpg?v=1762754902"
  },
  {
    "sku": "ELR4S-K",
    "title": "Arlec White 10m Cable Reel",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_10m_Cable_Reel_ELR4S-K_2c10db54-5d21-460e-b286-deead3b398a2.jpg?v=1762752347"
  },
  {
    "sku": "WEL10",
    "title": "Arlec White 10m Domestic Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_10m_Domestic_Extension_Lead_WEL10_1.jpg?v=1762752953"
  },
  {
    "sku": "AEL10",
    "title": "Arlec White 10m Extension Lead",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AEL10_CPIN004414_2.pdf?v=1754378916",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_10m_Household_Extension_Lead_White_AEL10.jpg?v=1762829184"
  },
  {
    "sku": "ALD968HA",
    "title": "Arlec White 10m Grid Connect Smart LED Strip Light with Sound Sync",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD968HA_CPIN006982_3_OL.pdf?v=1754378917",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_10m_Grid_Connect_Smart_Sound_Sync_Strip_Light_ALD968HA.jpg?v=1762754913"
  },
  {
    "sku": "PEL10",
    "title": "Arlec White 10m Piggy Back Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_10m_White_Piggyback_Extension_Lead_PEL10.jpg?v=1762752868"
  },
  {
    "sku": "ATF1105R",
    "title": "Arlec White 110cm 45W Tower Fan with Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ATF1105R_CPIN007920_-_2_OL.pdf?v=1754378923",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_110cm_45W_Tower_Fan_with_Remote_Control_ATF1105R.jpg?v=1762755136"
  },
  {
    "sku": "ATF110WH",
    "title": "Arlec White 110cm 55W Tower Fan with Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ATF110WHCPIN006799_3_OL.pdf?v=1754378924",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_110cm_Tower_Fan_With_Touch_Remote_ATF110WH.jpg?v=1762830970"
  },
  {
    "sku": "PB12PPKS-2PK",
    "title": "Arlec White 12 Outlet Master Switched Powerboard - 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_12_Outlet_Master_Switched_Powerboard_-_2_Pack_PB12PPKS-2PK.jpg?v=1762829300"
  },
  {
    "sku": "PB12PP",
    "title": "Arlec White 12 Outlet Power Board With Surge Protection",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_12_Outlet_Power_Board_With_Surge_Protection_PB12PP.jpg?v=1762752581"
  },
  {
    "sku": "PB12-PDKS",
    "title": "Arlec White 12 Outlet Surge Protected Powerboard with PD20W Rapid Charging USB 2xA&C",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_12_Outlet_Surge_Protected_Powerboard_With_PD20W_Rapid_Charging_USB_2xA_And_2xC_PB12-PDKS.jpg?v=1762752573"
  },
  {
    "sku": "EL345",
    "title": "Arlec White 120cm DIY 20/40W Dualpower + Tricolour LED Batten Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/EL345_CPIN006492_OL.pdf?v=1754378967",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_120cm_40W_DIY_Dual-Power_And_Tri-Colour_Tri-Proof_LED_Batten_Light_EL345.jpg?v=1762755471"
  },
  {
    "sku": "EL450HA",
    "title": "Arlec White 120cm Grid Connect Smart LED Batten",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/EL450HA_CPIN006732_OL.pdf?v=1754378978",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_120cm_40W_CCT_Grid_Connect_LED_Smart_DIY_Batten_Light_EL450HA.jpg?v=1762755479"
  },
  {
    "sku": "EL282",
    "title": "Arlec White 120cm Integrated LED Batten",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/EL282_CPIN006995_OL_5a588287-4f8d-4793-9721-b23152d387df.pdf?v=1754378967",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_120cm_32W_DIY_Multi-Power_And_Tri-Colour_IP20_LED_Batten_Light_EL282.jpg?v=1762755455"
  },
  {
    "sku": "EL45TC",
    "title": "Arlec White 120cm Tri-Proof LED Batten",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/EL25TC_EL45TC_CPIN005592_5_OL_1.pdf?v=1754378968",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_120cm_40W_Tri-Colour_Tri-Proof_LED_Batten_Light_EL45TC.jpg?v=1762755439"
  },
  {
    "sku": "UC552HA",
    "title": "Arlec White 12W 87cm Grid Connect Smart  Linkable CCT Bar Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC552HA_CPIN006973_OL.pdf?v=1754379102",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_87cm_Linkable_CCT_Bar_Light_UC552HA.jpg?v=1762756470"
  },
  {
    "sku": "UC452",
    "title": "Arlec White 12W 87cm Linking Bar Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC452_CPIN004391-2-P_OL.pdf?v=1754379098",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_12W_87cm_Linking_Bar_Light_UC452.jpg?v=1762756383"
  },
  {
    "sku": "ADF2875WH",
    "title": "Arlec White 13cmPortable Mini Fan with LED Night Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ADF2875WHCPIN006809_OL.pdf?v=1754378915",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_13cm_White_LED_Light_USB_Desk_Fan_ADF2875WH.jpg?v=1762830690"
  },
  {
    "sku": "WEL15",
    "title": "Arlec White 15m Domestic Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_15m_Domestic_Extension_Lead_WEL15_1.jpg?v=1762752960"
  },
  {
    "sku": "ADF1706R",
    "title": "Arlec White 17cm Desk Fan with Remote Control",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_17cm_Air_Circulator_With_Remote_ADF1706R_2.jpg?v=1762830678"
  },
  {
    "sku": "APF1810R",
    "title": "Arlec White 18cm 3-Blade Pedestal Fan with Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/APF1810RCPIN007903_OL.pdf?v=1754378926",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_18cm_Pedestal_Fan_With_Remote_APF1810R_2.jpg?v=1762830860"
  },
  {
    "sku": "HTB01",
    "title": "Arlec White 18L Towel Warmer Bucket",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/HTB01.jpg?v=1784187293"
  },
  {
    "sku": "PB45",
    "title": "Arlec White 1m 4-Outlet Powerboard with Surge Protection & On/Off Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/4_Outlet_4_Switch_Surge_Powerbord_PB45.jpg?v=1762751672"
  },
  {
    "sku": "ALD172",
    "title": "Arlec White 1m Corner LED Strip Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD172CPIN006975_2_OL.pdf?v=1754378914",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1m_Corner_LED_Strip_Light_ALD172_1.jpg?v=1762754639"
  },
  {
    "sku": "PEL1",
    "title": "Arlec White 1m Piggy Back Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1m_Piggyback_Extension_Lead_-_1m_PEL1.jpg?v=1762752846"
  },
  {
    "sku": "EPL2",
    "title": "Arlec White 2 metre Ring Pull Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2m_White_Ring_Pull_Extension_Lead_EPL2_1.jpg?v=1762752353"
  },
  {
    "sku": "PBHB2AC-30W",
    "title": "Arlec White 2 Outlet Portable Powerboard with PD30W Rapid Charging USB 2xA & 2xC",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2_Outlet_Portable_Powerboard_with_PD30W_Rapid_Charging_USB_2xA___2xC_PBHB2AC-30W.jpg?v=1762752784"
  },
  {
    "sku": "DA52",
    "title": "Arlec White 2 Outlet Premium Surge Adaptor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_2_Outlet_Premium_Surge_Adaptor_DA52_1.jpg?v=1762752295"
  },
  {
    "sku": "DA42",
    "title": "Arlec White 2 USB Outlets with High Powered USB Charger",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_2_USB_Outlets_with_High_Powered_USB_Charger_DA42.jpg?v=1762752280"
  },
  {
    "sku": "DA09-K",
    "title": "Arlec White 2 Way Double Adaptor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_2_Way_Double_Adaptor_DA09-K.jpg?v=1762752194"
  },
  {
    "sku": "PC900",
    "title": "Arlec White 2-Hour Compact Countdown Timer",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2_Hour_Compact_Countdown_Timer_PC900.jpg?v=1762756213"
  },
  {
    "sku": "DH103",
    "title": "Arlec White 2-Litre Dehumidifier",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2L_Dehumidifier_DH103.jpg?v=1762831184"
  },
  {
    "sku": "PA0724TS",
    "title": "Arlec White 2.05kW Portable Air Conditioner With Remote",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PA0724TSCPIN007976_OL.pdf?v=1754379042",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2.05kW_Portable_Air_Conditioner_With_Remote_PA0724TS.jpg?v=1762831349"
  },
  {
    "sku": "PA0922",
    "title": "Arlec White 2.60KW Portable Conditioner",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PA0922_CPIN006805-2OL.pdf?v=1754379043",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_2.60KW_Portable_Conditioner_PA0922.jpg?v=1762756039"
  },
  {
    "sku": "AEX20",
    "title": "Arlec White 200mm Ceiling Exhaust Fan",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AEX20.webp?v=1784872363"
  },
  {
    "sku": "MEF20",
    "title": "Arlec White 200mm Energy Efficient Ceiling Exhaust Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MEF20_CPIN1084_3_OL.pdf?v=1754379030",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_200mm_Energy_Efficient_Exhaust_Fan_MEF20_3.jpg?v=1762756018"
  },
  {
    "sku": "UC532",
    "title": "Arlec White 20cm CCT Sensor Bar Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC532_CPIN006969_3_OL.pdf?v=1754379100",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_20cm_CCT_Sensor_Bar_Light_UC532.jpg?v=1762756447"
  },
  {
    "sku": "AEL20",
    "title": "Arlec White 20m Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_20m_Extension_Lead_AEL20.jpg?v=1762829176"
  },
  {
    "sku": "CH235",
    "title": "Arlec White 2300W Convection Heater With Remote Control And Fan Boost",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CH235CPIN004037.pdf?v=1754378921",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2300W_Convection_Heater_With_Remote_Control_And_Fan_Boost_CH235_1.jpg?v=1762832077"
  },
  {
    "sku": "PC44",
    "title": "Arlec White 24-Hour Heavy-Duty Weatherproof Mechanical Timer",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PC44_CPIN005591.pdf?v=1754379033",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PC44.jpg?v=1788519304"
  },
  {
    "sku": "PC726",
    "title": "Arlec White 24-Hour Slimline Timer",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_24-Hour_Slimline_Timer_PC726.jpg?v=1762756182"
  },
  {
    "sku": "PC723",
    "title": "Arlec White 24-Hour Surge Protected Timer",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PC723.jpg?v=1787902081"
  },
  {
    "sku": "PC729",
    "title": "Arlec White 24-Hour Timer - 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_24-Hour_Timer_-_2_Pack_PC729_1.jpg?v=1762756205"
  },
  {
    "sku": "PC722-P",
    "title": "Arlec White 24-Hour Twin Socket Mechanical Timer",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PC722-P.png?v=1787900646"
  },
  {
    "sku": "PC722",
    "title": "Arlec White 24-Hour Twin Socket Timer with Double Pole Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PC722.jpg?v=1787907041"
  },
  {
    "sku": "PC44-2PK",
    "title": "Arlec White 24-Hour Weatherproof Timer - Twin Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PC44-2PK.jpg?v=1788518547"
  },
  {
    "sku": "AEX25",
    "title": "Arlec White 250mm Ceiling Exhaust Fan",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AEX25.webp?v=1784872389"
  },
  {
    "sku": "MEF25",
    "title": "Arlec White 250mm Energy Efficient Ceiling Exhaust Fan",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_250mm_Energy_Efficient_Exhaust_Fan_MEF25.jpg?v=1762756025"
  },
  {
    "sku": "PW002",
    "title": "Arlec White 2L Automatic Dispenser Pet Drinking Fountain",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PW002CPIN007050_OL.pdf?v=1754379102",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2L_Automatic_Dispenser_Pet_Drinking_Fountain_PW002.jpg?v=1762756269"
  },
  {
    "sku": "AEL2",
    "title": "Arlec White 2m Domestic Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2m_White_Household_Extension_Lead_AEL2_162cd671-a3fc-4f2b-8a17-a8cad88aa8a3.jpg?v=1762829168"
  },
  {
    "sku": "PEL2",
    "title": "Arlec White 2m Piggy Back Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2m_Black_Piggyback_Extension_Lead_-_2m_PEL2.jpg?v=1762752853"
  },
  {
    "sku": "PPEL2",
    "title": "Arlec White 2m Piggyback Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_2m_Piggyback_Extension_Lead_PPEL2_1.jpg?v=1762752871"
  },
  {
    "sku": "PB34BL",
    "title": "Arlec White 3 Outlet Powerboard with Bluetooth Speaker and Built In USB Charging Ports",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB34BL_CPIN006439_OL.pdf?v=1754379036",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_3_Outlet_Powerboard_With_Wireless_Speaker_PB34BL.jpg?v=1762829321"
  },
  {
    "sku": "PB3UC",
    "title": "Arlec White 3 Outlet Triangular Powerboard with USB A&C Charger",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_3_Outlet_Triangular_Powerboard_With_PD18W_Fast_Charging_USBs_PB3UC.jpg?v=1762752418"
  },
  {
    "sku": "PB3PPUC-K",
    "title": "Arlec White 3 Outlets with USB A&C Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_3_Outlets_with_USB_A_C_Powerboard_PB3PPUC-k.jpg?v=1762751680"
  },
  {
    "sku": "AEH100",
    "title": "Arlec White 3-in-1 Bathroom Solution",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AEH100_CPIN006841_OL.pdf?v=1754378920",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_3-In-1_Bathroom_Heater_AEH100.jpg?v=1762754575"
  },
  {
    "sku": "PA1122WH",
    "title": "Arlec White 3.3KW Portable Air Conditioner",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PA1122WHCPIN006806_OL.pdf?v=1754379043",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_3.3KW_11000_BTU_Portable_Air_Conditioner_PA1122WH.jpg?v=1762756049"
  },
  {
    "sku": "ABF12123WH",
    "title": "Arlec White 30cm 5-Blade Box Fan with Oscillation & Timer",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABF12123WHCPIN007371_OL.pdf?v=1754378918",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_30cm_Box_Fan__ABF12123WH.jpg?v=1762754243"
  },
  {
    "sku": "ABF1223TS",
    "title": "Arlec White 30cm 5-Blade Rotating Louvre Box Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABF1223TS_CPIN007924_OL.pdf?v=1754378918",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Box_Fan_30_cm_With_Timer_ABF1223TS.jpg?v=1762830617"
  },
  {
    "sku": "MAL321RV",
    "title": "Arlec White 30W LED DIY Security Sensor Flood Light with Movement Activation",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL321RV_CPIN004912.pdf?v=1754379030",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_LED_Twin_Security_Floodlight_MAL321RV.jpg?v=1762831270"
  },
  {
    "sku": "ALD322",
    "title": "Arlec White 3m 1350lm LED Strip Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD322_CPIN004420.pdf?v=1754378909",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_3m_IP68_Cool_White_LED_Strip_Light_ALD322.jpg?v=1762830789"
  },
  {
    "sku": "ALD321",
    "title": "Arlec White 3m 1600lm LED Strip Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD321_CPIN004420.pdf?v=1754378909",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_3m_IP68_Warm_White_LED_Strip_Light_ALD321.jpg?v=1762830778"
  },
  {
    "sku": "ALD348",
    "title": "Arlec White 3m 2000lm LED Strip Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD348CPIN006976OL.pdf?v=1754378920",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_3m_Warm_White_Dotless_Strip_Light_ALD348.jpg?v=1762754837"
  },
  {
    "sku": "PB4KS-3-K",
    "title": "Arlec White 3m 4-Outlet Surge Powerboard with Master Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_5m_4-Outlet_Surge_Powerboard_with_Master_Switch_PB4-H-K.jpg?v=1762751733"
  },
  {
    "sku": "ALD341CCT",
    "title": "Arlec White 3m 600lm LED Strip Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD341CCT_CPIN006062OL.pdf?v=1754378915",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_3m_600lm_CCT_IP44_LED_Strip_Light_ALD341CCT_1.jpg?v=1762754826"
  },
  {
    "sku": "AEL3-2PK",
    "title": "Arlec White 3m Domestic Extension Lead - 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AEL3-2PK-P_Hero.jpg?v=1763448480"
  },
  {
    "sku": "ALP133HA",
    "title": "Arlec White 3m Grid Connect Smart Plush Light with Sound Sync",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALP133HA_CPIN007136_2_OL.pdf?v=1754378922",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_3m_Grid_Connect_Smart_Plush_Strip_Light_With_Sound_Sync_ALP133HA.jpg?v=1762830807"
  },
  {
    "sku": "CSF122W",
    "title": "Arlec White 4-Blade 120cm AC Ceiling Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CSF122SeriesCPIN005425-4OL.pdf?v=1754453776",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_120cm_4_Blade_White_Ceiling_Fan_CSF122W.jpg?v=1762751935"
  },
  {
    "sku": "PB4MWC",
    "title": "Arlec White 4-Outlet Detachable 10W Wireless Charger",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4_Outlet_Powerboard_With_Detachable_10W_Wireless_Charger_PB4MWC.jpg?v=1762752477"
  },
  {
    "sku": "PB4KSHA",
    "title": "Arlec White 4-Outlet Grid Connect Smart Powerboard",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB4KSHA_CPIN004948.pdf?v=1754379035",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_4_Outlet_Powerboard_PB4KSHA.jpg?v=1762752442"
  },
  {
    "sku": "PB4UHA",
    "title": "Arlec White 4-Outlet Grid Connect Smart Powerboard with USB A&C Charger",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB4UHACPIN007489_OL.pdf?v=1754379038",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_4_Outlet_Powerboard_with_USB_A___C_Charger_PB4UHA.jpg?v=1762752521"
  },
  {
    "sku": "PB44B-L",
    "title": "Arlec White 4-Outlet Individually Switched Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4_Outlet_Individually_Switched_Powerboard_PB44B-L.jpg?v=1762752596"
  },
  {
    "sku": "PB46PD30",
    "title": "Arlec White 4-Outlet Individually Switched Surge Powerboard with PD30W Rapid Charging USB A & C",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4_Outlet_Individually_Switched_Surge_Powerboard_With_PD30W_Rapid_Charging_USB_A_And_C_PB46PD30.jpg?v=1762752626"
  },
  {
    "sku": "PB46-BKU",
    "title": "Arlec White 4-Outlet Individually with Fast Charging USB Powerboard with Premium Surge Protection",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec4OutletIndividuallySwitchedSurgePowerboardwithPD45WRapidChargingUSBA_C_PB46-BKU_1.jpg?v=1762752618"
  },
  {
    "sku": "PB46",
    "title": "Arlec White 4-Outlet Overload Protected Powerboard with USB Charger Built in 2 USB Charging Ports",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4_Outlet_Surge_Protected_Powerboard_With_USB_Charger_PB46.jpg?v=1762829370"
  },
  {
    "sku": "PBCB4AC-K",
    "title": "Arlec White 4-Outlet Power Cube with USB A+C",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_4-Outlet_Power_Cube_with_USB_A_C_PBCB4AC-K.jpg?v=1762752771"
  },
  {
    "sku": "FWPK-K",
    "title": "Arlec White 4-Outlet Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_4-Outlet_Powerboard_FWPK-K_1.jpg?v=1762751688"
  },
  {
    "sku": "FWP",
    "title": "Arlec White 4-Outlet Powerboard with Overload Protection",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_4-Outlet_Powerboard_with_Overload_Protection_FWP.jpg?v=1762751698"
  },
  {
    "sku": "FWP-S",
    "title": "Arlec White 4-Outlet Powerboard with Surge Protection",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_4-Outlet_Powerboard_with_Surge_Protection_FWP-S_1.jpg?v=1762751707"
  },
  {
    "sku": "PB4U4C",
    "title": "Arlec White 4-Outlet Powerboard with USB 2A & 2C Charging Ports",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4_Outlet_Powerboard_With_USB_2A_And_2C_Charging_Ports_PB4U4C.jpg?v=1762752498"
  },
  {
    "sku": "PB44OW-P",
    "title": "Arlec White 4-Outlet Safety Overload Warning Alarm Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4_Outlet_Individually_Switched_Powerboard_with_Safety_Overload_Warning_Alarm_PB44OW-P.jpg?v=1762752610"
  },
  {
    "sku": "FWPK-S-K",
    "title": "Arlec White 4-Outlet Surge Protected Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_4-Outlet_Surge_Protected_Powerboard_FWPK-S-K_2.jpg?v=1762751716"
  },
  {
    "sku": "PB44-K",
    "title": "Arlec White 4-Outlet with 4 Switch Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_4-Outlet_with_4_Switch_Powerboard_PB44-K.jpg?v=1762751727"
  },
  {
    "sku": "GTA32",
    "title": "Arlec White 4-Port Compact USB Charger with 3 USB -A & 1 USB -C Port",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4_Port_Compact_USB_Charger_GTA32.jpg?v=1762831219"
  },
  {
    "sku": "GTA34",
    "title": "Arlec White 4-Port Compact USB Charger with 3 USB -A & 1 USB -C Port with Holder",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4_Port_Compact_USB_Charger_With_Holder_GTA34.jpg?v=1762831229"
  },
  {
    "sku": "APDC7HA",
    "title": "Arlec White 40cm 5-Blade DC Grid Connect Smart Pedestal Fan with Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/APDC7HA_CPIN0048492.pdf?v=1754378914",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_40cm_White_Smart_Pedestal_Fan_With_Grid_Connect_APDC7HA.jpg?v=1762830829"
  },
  {
    "sku": "APDC160WHA",
    "title": "Arlec White 40cm 5-Blade Grid Connect Smart DC  Motor Pedestal Fan with Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/APDC160WHA_CPIN006171-2_OL.pdf?v=1754378927",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_40cm_White_Grid_Connect_Smart_Remote_Controlled_Pedestal_Fan_APDC160WHA.jpg?v=1762754984"
  },
  {
    "sku": "APF4023HA",
    "title": "Arlec White 40cm 5-Blade Grid Connect Smart Pedestal Fan with Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/APF4023HA_CPIN007476_OL.pdf?v=1754378923",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_40cm_Smart_Pedestal_Fan_with_Remote_APF4023HA_1.jpg?v=1762754221"
  },
  {
    "sku": "APF4057B",
    "title": "Arlec White 40cm 5-Blade Pedestal Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/APF4057B_CPIN006244_2_OL.pdf?v=1754378923",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_40cm_Black_5_Blade_Pedestal_Fan_APF4057B.jpg?v=1762830886"
  },
  {
    "sku": "UC534",
    "title": "Arlec White 40cm CCT Sensor Bar Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC534_CPIN007178_2_OL.pdf?v=1754379100",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_40cm_CCT_Sensor_Bar_Light_UC534.jpg?v=1762756453"
  },
  {
    "sku": "APF019",
    "title": "Arlec White 45cm 5-Blade DC Pedestal Fan",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/APF019_CPIN003395_3OL.pdf?v=1754378924",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_40cm_DC_Pedestal_Fan_with_Remote_Control_APDC406B_1_629fa9b6-b0f4-4d77-afef-349df0f2b247.jpg?v=1762830851"
  },
  {
    "sku": "PF001",
    "title": "Arlec White 4L Automatic Pet Feeder",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PF001CPIN007046_2_OL.pdf?v=1754379104",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4L_Automatic_Pet_Feeder_PF001.jpg?v=1762756243"
  },
  {
    "sku": "DES4",
    "title": "Arlec White 4m Extension Lead with 4 Power Outlets",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4m_Extension_Lead_With_4_Power_Outlets_DES4.jpg?v=1762752311"
  },
  {
    "sku": "UC450",
    "title": "Arlec White 4W 31cm Linkable Bar Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC450_CPIN004391-2_OL.pdf?v=1754379100",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4W_31cm_Linkable_Bar_Light_UC450.jpg?v=1762756366"
  },
  {
    "sku": "EPL5",
    "title": "Arlec White 5 metre Ring Pull Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_5m_White_Ring_Pull_Extension_Lead_EPL5_1.jpg?v=1762752361"
  },
  {
    "sku": "ALD275HA",
    "title": "Arlec White 540lm Grid Connect Smart LED Downlight with Flushed Lens",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD275HA_CPIN007573_OL.pdf?v=1754378913",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_6W_70mm_Grid_Connect_Smart_RGB_CCT_LED_Downlight_ALD275HA.jpg?v=1762754707"
  },
  {
    "sku": "ATF2218WH",
    "title": "Arlec White 56cm Bladless Tower Fan with Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ATF2218WH_CPIN006187-3OL.pdf?v=1754378923",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_56cm_Oparara_Remote_Controlled_Bladeless_Fan_ATF2218WH.jpg?v=1762830997"
  },
  {
    "sku": "ALD275RV",
    "title": "Arlec White 570lm LED Downlight with Flushed Lens",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD275RV_CPIN007659OL.pdf?v=1754378913",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_6W_Tri-Colour_Dimmable_LED_Downlight_ALD275RVc.png?v=1762754723"
  },
  {
    "sku": "PF002HA",
    "title": "Arlec White 5L Grid Connect Smart Pet Feeder",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PF002HACPIN007044_3_OL.pdf?v=1754379104",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_5L_Grid_Connect_Smart_Pet_Feeder_PF002HA.jpg?v=1762756231"
  },
  {
    "sku": "PFC002HA",
    "title": "Arlec White 5L Grid Connect Smart Pet Feeder with Camera",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PFC002HACPIN007045-3_OL.pdf?v=1754379106",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_5L_Grid_Connect_Smart_Pet_Feeder_with_Camera_PFC002HA.jpg?v=1762756256"
  },
  {
    "sku": "ALD541CCT",
    "title": "Arlec White 5m 1000lm LED Strip Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD541CCT_CPIN006062OL.pdf?v=1754378920",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_5m_800lm_CCT_IP44_LED_Strip_Light_ALD541CCT_1.jpg?v=1762754866"
  },
  {
    "sku": "ALD563HA",
    "title": "Arlec White 5m Grid Connect Smart LED Strip Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD563HA_CPIN007136_OL.pdf?v=1754378926",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ArlecWhite5mGridConnectSmartLEDStripLight1.jpg?v=1765260441"
  },
  {
    "sku": "ALD556HA",
    "title": "Arlec White 5m Grid Connect Smart LED Strip Light with Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD556HA_CPIN004679_7_OL.pdf?v=1754378920",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_5m_LED_White___Colour_Changing_Strip_Light_with_Remote_ALD556HA.jpg?v=1762754857"
  },
  {
    "sku": "ALD568HA",
    "title": "Arlec White 5m Grid Connect Smart LED Strip Light with Sound Sync",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD568HA_CPIN007136_2_OL.pdf?v=1754378918",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_5m_Sound_Sync_Strip_Light_ALD568HA.jpg?v=1762754891"
  },
  {
    "sku": "PEL5",
    "title": "Arlec White 5m Piggy Back Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_5m_Piggy_Back_Extension_Lead_PEL5.jpg?v=1762752860"
  },
  {
    "sku": "PB66",
    "title": "Arlec White 6-Outlet Individually Switched Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_6-Outlet_Individually_Switched_Powerboard_PB66.jpg?v=1762752633"
  },
  {
    "sku": "SWP-K",
    "title": "Arlec White 6-Outlet Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_6-Outlet_Powerboard_SWP-K.jpg?v=1762829518"
  },
  {
    "sku": "PB67",
    "title": "Arlec White 6-Outlet Powerboard with 6 Surge Protection & On/Off Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_6-Outlet_Powerboard_with_6_Surge_Protection___OnOff_Switch_PB67_a1dea811-0eff-46c1-b337-74d6e0cf7956.jpg?v=1762751740"
  },
  {
    "sku": "SWP",
    "title": "Arlec White 6-Outlet Powerboard with Overload Protection",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_6-Outlet_Powerboard_with_Overload_Protection_SWP.jpg?v=1762751748"
  },
  {
    "sku": "SWPK",
    "title": "Arlec White 6-Outlet Powerboard with Side Entry Plug",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_6-Outlet_Powerboard_SWP-K_25897f13-3bbd-49de-90a1-b75f9110218d.jpg?v=1762751755"
  },
  {
    "sku": "PB6RT",
    "title": "Arlec White 6-Outlet Rotatable Powerboard with Surge Protection",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_6_Outlet_Rotatable_Powerboard_with_Surge_Protection_PB6RT.jpg?v=1762752538"
  },
  {
    "sku": "PB66B-L",
    "title": "Arlec White 6-Outlet Safety Overload Protection Individually Switch Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB66B.jpg?v=1762752639"
  },
  {
    "sku": "PB6WU2S",
    "title": "Arlec White 6-Outlet Space Saving Powerboard with Double USB",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_6_Outlet_Space_Saving_Powerboard_With_2.4A_USB_Charger_PB6WU2S.jpg?v=1762752545"
  },
  {
    "sku": "SWP-LS",
    "title": "Arlec White 6-Outlet Surge Protect Plug Pack Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_6-Outlet_Surge_Protect_Plug_Pack_Powerboard_SWP-LS.jpg?v=1762751764"
  },
  {
    "sku": "SWP-S",
    "title": "Arlec White 6-Outlet Surge Protected Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_6-Outlet_Surge_Protected_Powerboard_SWP-S.jpg?v=1762751774"
  },
  {
    "sku": "PB61LT",
    "title": "Arlec White 6-Outlet Surge Protected Powerboard and Entertain Series",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/6_Outlet_Surge_Entertainment_Powerbord_PB61LT.jpg?v=1762829385"
  },
  {
    "sku": "PB63",
    "title": "Arlec White 6-Outlet Surge Protected Powerboard and Phone Line Outlet",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Surge___Data_Protected_6_Outlet_pboard_PB63.jpg?v=1762829394"
  },
  {
    "sku": "PB66UAC",
    "title": "Arlec White 6-Outlet Surge Protected Powerboard with PD20W Rapid Charging USBs",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec6OutletSurgeProtectedPowerboardwithPD20WRapidChargingUSBs_PB66UAC.jpg?v=1762752648"
  },
  {
    "sku": "PB6WUPD30",
    "title": "Arlec White 6-Outlet Vertical Powerboard with PD30W Rapid Charging USB A & C",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_6_Outlet_Vertical_Powerboard_with_PD30W_Rapid_Charging_USB_A___C_PB6WUPD30.jpg?v=1762752553"
  },
  {
    "sku": "EL325",
    "title": "Arlec White 60cm DIY 10/20W Dualpower + Tricolour LED Batten Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/EL325_CPIN006492_OL.pdf?v=1754378968",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_60cm_20W_DIY_Dual-Power_and_Tri-Colour_Tri-Proof_LED_Batten_Light_EL325.jpg?v=1762755464"
  },
  {
    "sku": "EL280",
    "title": "Arlec White 60cm Integrated LED Batten",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/EL282_CPIN006995_OL_5a588287-4f8d-4793-9721-b23152d387df.pdf?v=1754378967",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_60cm_LED_DIY_Multi-Power_And_Tri-Colour_IP20_18W_Batten_Light_EL280.jpg?v=1762755448"
  },
  {
    "sku": "EL25TC",
    "title": "Arlec White 60cm Tri-Proof LED Batten",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/EL25TC_EL45TC_CPIN005592_5_OL_1.pdf?v=1754378968",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_60cm_20W_Tri-Proof_LED_Batten_Light__Tri-Colour_EL25TC.jpg?v=1762755429"
  },
  {
    "sku": "ALD270",
    "title": "Arlec White 650lm LED Downlight with Low Recessed Lens",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD270_CPIN007787OL.pdf?v=1754378914",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_7W_70mm_IP65_Tricolour_Dimmable_LED_Downlight_ALD270.jpg?v=1762754690"
  },
  {
    "sku": "PB87",
    "title": "Arlec White 7 Outlet Surge Protected Powerboard With Dual USB Charger",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_7-Outlet_Surge_Powerboard_With_USB_Charger_PB87.jpg?v=1762752655"
  },
  {
    "sku": "ALD095HA",
    "title": "Arlec White 720lm Grid Connect Smart LED Downlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD095HA_CPIN004679_7_OL.pdf?v=1754378919",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_9W_720lm_RGB_CCT_Grid_Connect_Smart__LED_Downlight_ALD095HA.jpg?v=1762754620"
  },
  {
    "sku": "ALD295HA",
    "title": "Arlec White 740lm Grid Connect Smart LED Downlight with Flushed Lens",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD295CPIN004400_4_OL.pdf?v=1754378914",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_9W_92mm_Grid_Connect_Smart_RGB_CCT_LED_Downlight_ALD295HA.jpg?v=1762754744"
  },
  {
    "sku": "ALD295P5HA",
    "title": "Arlec White 740lm Grid Connect Smart LED Downlight with Flushed Lens-5 Pack",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD295CPIN004400_4_OL.pdf?v=1754378914",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_9W_92mm_Grid_Connect_Smart_RGB_CCT_LED_Downlight_-_5_Pack_ALD295P5HA.jpg?v=1762754770"
  },
  {
    "sku": "ALD450",
    "title": "Arlec White 750lm LED Downlight with Flushed Lens",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD450CPIN0076134OL.pdf?v=1754378913",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_8W_Nightlight_Function_LED_Downlight_ALD450.jpg?v=1762754847"
  },
  {
    "sku": "ALD271",
    "title": "Arlec White 775lm LED Downlight with Low Recessed Lens",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD271_CPIN007787OL.pdf?v=1754378914",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_9W_92mm_IP65_Tricolour_Dimmable_LED_Downlight_ALD271.jpg?v=1762754698"
  },
  {
    "sku": "PPEL7",
    "title": "Arlec White 7m Piggyback Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_7m_Piggyback_Extension_Lead_PPEL7_1.jpg?v=1762752880"
  },
  {
    "sku": "UC473",
    "title": "Arlec White 7W Aluminium Wide Angle Corner Bar LED Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC473_CPIN004389.pdf?v=1754379097",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_7W_Aluminium_Wide_Angle_Corner_Bar_LED_Light_UC473.jpg?v=1762756399"
  },
  {
    "sku": "PB8PPUC-K",
    "title": "Arlec White 8 Outlets with USB A&C Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_8_Outlets_with_USB_A_C_Powerboard_PB8PPUC-K.jpg?v=1762751782"
  },
  {
    "sku": "ALD295RV",
    "title": "Arlec White 820lm LED Downlight with Flushed Lens",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD295RV_CPIN007659_OL_1.pdf?v=1754378914",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_9W_Tri-Colour_Dimmable_LED_Downlight_ALD295RV_1_21743efe-6f4a-4278-b23e-d59358fdcb0a.jpg?v=1762754782"
  },
  {
    "sku": "ALD295P10",
    "title": "Arlec White 820lm LED Downlight with Flushed Lens-10 Pack",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD295_CPIN004400_4_OL.pdf?v=1754378914",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_9W_92mm_Tri-Colour_Dimmable_LED_Downlight_Flushed_Lens_-_Pack_of_11_ALD295P10_1.jpg?v=1762754815"
  },
  {
    "sku": "ALD295P2",
    "title": "Arlec White 820lm LED Downlight with Flushed Lens-2 Pack",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD295CPIN004400_4_OL.pdf?v=1754378914",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_9W_92mm_Tri-Colour_Dimmable_LED_Downlight_Flushed_Lens_-_2_Pack_ALD295P2_2.png?v=1762754794"
  },
  {
    "sku": "ALD295P5RV",
    "title": "Arlec White 820lm LED Downlight with Flushed Lens-5 Pack",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD295_CPIN004400_4_OL.pdf?v=1754378914",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_9W_Tri-Colour_Dimmable_LED_Downlight_with_Plug_Bases_-_5_Pack_ALD295P5RV_1.jpg?v=1762754806"
  },
  {
    "sku": "ALD285",
    "title": "Arlec White 820lm LED Downlight with Recessed Lens",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD285_CPIN007566_OL.pdf?v=1754378913",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_9W_92mm_Tri-Colour_Recessed_Lens_Dimmable_LED_Downlight_ALD285.jpg?v=1762754733"
  },
  {
    "sku": "ALD285P2",
    "title": "Arlec White 820lm LED Downlight with Recessed Lens- 2 Pack",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD285_CPIN007566_OL.pdf?v=1754378913",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_9W_92mm_Tri-Colour_Dimmable_LED_Downlight_Recessed_Lens_-_2_Pack_ALD285P2.jpg?v=1762754757"
  },
  {
    "sku": "ADF10833",
    "title": "Arlec White 8cm Foldable Mini Fan with USB Power Cord",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ADF10833_CPIN006206OL.pdf?v=1754378920",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Click_8cm_Rechargeable_Foldable_Mini_Handheld_Desk_Fan_ADF10833.jpg?v=1762830699"
  },
  {
    "sku": "UC551HA",
    "title": "Arlec White 8W 57cm Grid Connect Smart Linkable CCT Bar Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC551HA_CPIN006973_OL.pdf?v=1754379102",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_57cm_Grid_Connect_Smart_Linkable_CCT_Bar_Light_UC551HA.jpg?v=1762756482"
  },
  {
    "sku": "UC451",
    "title": "Arlec White 8W 57cm Linking Bar Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC451_CPIN004391-2-P.pdf?v=1754379096",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_57cm_8W_Linking_Bar_Light_UC451.jpg?v=1762756375"
  },
  {
    "sku": "ALD192",
    "title": "Arlec White 900lm Multi-Power LED Downlight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD192_CPIN006377_OL.pdf?v=1754378915",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_9W_Multi-Lumen_Tri-Colour_Dimmable_LED_Downlight_ALD192.jpg?v=1762754654"
  },
  {
    "sku": "CDR90W",
    "title": "Arlec White 900mm White Ceiling Fan Accessory Rod",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_900mm_White_Ceiling_Fan_Accessory_Rod_CDR90W.jpg?v=1762755368"
  },
  {
    "sku": "ATF362RL",
    "title": "Arlec White 91cm 60W Tower Fan with Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ATF362RLCPIN006118_2OL.pdf?v=1754378926",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_91cm_60W_Tower_Fan_with_Remote_Control_ATF362RL.jpg?v=1762830978"
  },
  {
    "sku": "SB901",
    "title": "Arlec White 9L Sensor Bin",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/SB901.png?v=1784188203"
  },
  {
    "sku": "APR010",
    "title": "Arlec White Air Purifier with CADR",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/APR010_CPIN006947OL.pdf?v=1754378924",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Air_Purifier_With_CADR_100m_hr_APR010.jpg?v=1762755005"
  },
  {
    "sku": "APR014",
    "title": "Arlec White Air Purifier with Hepa 13 Filter",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/APR014_CPIN006948_2OL.pdf?v=1754378924",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Air_Purifier_With_CADR_160_m_hr_APR014.jpg?v=1762755014"
  },
  {
    "sku": "ABL3910WH",
    "title": "Arlec White Apex 10W Oval Led Bunker",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL3910WH_IM.pdf?v=1790832947",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL3910WH.png?v=1790658625"
  },
  {
    "sku": "DA27-P",
    "title": "Arlec White AU to EU Single Socket Inbound Travel Adaptor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "DA44TC-P",
    "title": "Arlec White AU to EU Single Socket Outbound Travel Adaptor with USB A &C PD20W port",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "DA26-P",
    "title": "Arlec White AU to IND  Single Socket Inbound Travel Adaptor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "PF009",
    "title": "Arlec White Automatic Pet Feeder for Wet & Dry Food",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PF009_CPIN008903_OL.pdf?v=1784621280",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PF009_b735760a-83db-4f34-802e-6682bc0bc3a1.png?v=1789727360"
  },
  {
    "sku": "MAL606",
    "title": "Arlec White B22 Globe Base DIY Oyster Sensor Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL606_MAL606SCPIN003375_5_OL.pdf?v=1754379033",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_DIY_Oyster_Sensor_Light_MAL606.jpg?v=1762755899"
  },
  {
    "sku": "CSF05P4",
    "title": "Arlec White Ceiling Fan Blade Sleeve - 4 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Ceiling_Fan_Blade_Sleeve_-_4_Pack_CSF05P4.jpg?v=1762751833"
  },
  {
    "sku": "NL9102W",
    "title": "Arlec White Ceramic Flower Lamp",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL9102W2.png?v=1781696236"
  },
  {
    "sku": "UC511",
    "title": "Arlec White COB Push Bar Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC511_CPIN007593_OL.pdf?v=1754379100",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_COB_Push_Bar_Light_UC511.jpg?v=1762756433"
  },
  {
    "sku": "PC627-B",
    "title": "Arlec White Compact 24-Hour Timer Switch",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "MAL344",
    "title": "Arlec White Compact Movement Activated Security Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL344_CPIN002324_6_OL.pdf?v=1754379034",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Andreas_Compact_Movement_Activated_Sensor_Security_Light_MAL344.jpg?v=1762755836"
  },
  {
    "sku": "DA38",
    "title": "Arlec White Compact Power Adapter with USB 3.4A",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DA38.jpg?v=1787724341"
  },
  {
    "sku": "DA06-K",
    "title": "Arlec White Cube Double Adaptor with USB A & C",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_Cube_Double_Adaptorwith_USB_A__C_DA06-K_1.jpg?v=1762752180"
  },
  {
    "sku": "7144DC",
    "title": "Arlec White DC Ceiling Fan Wall Controller - For DC Boston II",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/7144DC_CPIN006929OL.pdf?v=1754378911",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_DC_Ceiling_Fan_Wall_Controller_-_For_DC_Boston_II_7144DC.jpg?v=1762751867"
  },
  {
    "sku": "EX25",
    "title": "Arlec White DIY 250mm Exhaust Ceiling Fan",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_250mm_White_Exhaust_Fan_EX25_22.jpg?v=1762755498"
  },
  {
    "sku": "MAL626",
    "title": "Arlec White DIY LED Ceiling Oyster Sensor Light with Movement Activation",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL626CPIN003902_2_OL.pdf?v=1754379033",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_DIY_LED_Oyster_Sensor__Light_MAL626_1.jpg?v=1762755927"
  },
  {
    "sku": "WEL3",
    "title": "Arlec White Domestic 3m Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_Domestic_3m_Extension_Lead_WEL3_1.jpg?v=1762752908"
  },
  {
    "sku": "WEL5",
    "title": "Arlec White Domestic 5m Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_Domestic_5m_Extension_Lead_WEL5_1.jpg?v=1762752937"
  },
  {
    "sku": "ABL420WH",
    "title": "Arlec White Doppia Medium LED CCT Up & Down Wall Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL420BK_CPIN007682_3_OL.pdf?v=1787911500",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL420WH.png?v=1790853424"
  },
  {
    "sku": "9302CB",
    "title": "Arlec White Double Powerpoint with  USB-A and USB-C ports",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_Double_Powerpoint_with__USB-A_and_USB-C_ports_9302CB.jpg?v=1762832152"
  },
  {
    "sku": "ARL6221",
    "title": "Arlec White Double Powerpoint with USB A & C",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec-Double-Power-Point-With-USB-A-And-C-Charger_ARL6221_0e0d7720-db59-4d2a-b439-74692681edca.jpg?v=1762752058"
  },
  {
    "sku": "ABL022",
    "title": "Arlec White Dura Oval LED Bunker Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL022_CPIN006014-3_OL.pdf?v=1754378915",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_15W_White_Oval_LED_Bunker_Light_ABL022.jpg?v=1762754270"
  },
  {
    "sku": "PC223",
    "title": "Arlec White Energy Cost Electrical Meter",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PC223_CPIN007721OL.pdf?v=1754379040",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Energy_Cost_Electrical_Meter_PC223_1_340d4a0b-988b-4266-b5ae-54e77c486ddb.jpg?v=1762752823"
  },
  {
    "sku": "DA24-D",
    "title": "Arlec White EU to AU Double Socket Outbound Travel Adaptor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/DA24.jpg?v=1763360963"
  },
  {
    "sku": "DA24-P",
    "title": "Arlec White EU to AU Single Socket Outbound Travel Adaptor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "AECTF5022",
    "title": "Arlec white Evaporative Cooler with Remote & 12-Hour Timer",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AECTF5022CPIN006808OL.pdf?v=1754378922",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_5.5L_Remote_Control_Evaporative_Cooler_AECTF5022.jpg?v=1762754566"
  },
  {
    "sku": "DC3936",
    "title": "Arlec White Everyday Wireless Battery Doorchime",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_Everyday_Wireless_Battery_Doorchime_DC3936.jpg?v=1762755400"
  },
  {
    "sku": "DC3936-2",
    "title": "Arlec White Everyday Wireless Battery Doorchime with Dual Receivers",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_Everyday_Wireless_Battery_Doorchime_with_Dual_Receivers.jpg?v=1762755408"
  },
  {
    "sku": "DC3880",
    "title": "Arlec White Everyday Wireless Plug-In Doorchime",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_Everyday_Wireless_Plug-In_Doorchime_DC3880.jpg?v=1762755392"
  },
  {
    "sku": "PB2TC-20W",
    "title": "Arlec White Fast Charging USB Powerboard with Desktop Clamp",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2_Outlet_PD20W_USB_C_Powerboard_With_Desktop_Clamp_PB2TC-20W.jpg?v=1762752399"
  },
  {
    "sku": "GLD132P3HA",
    "title": "Arlec White Grid Connect Smart 12W 1050lm RGB Colour Mode E27 Globe - 3 Pack",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD132P3HA_CPIN004697-3_OL.pdf?v=1754378967",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_12W_1050lm_RGB_Colour_Mode_Grid_Connect_Smart_LED_E27_Globe_-_3_Pack_GLD132P3HA.jpg?v=1762831203"
  },
  {
    "sku": "GLD302HA",
    "title": "Arlec White Grid Connect Smart 15W 1350lm CCT PAR38 E27Globe",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD302HA_CPIN004679-4.pdf?v=1754378972",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1350lm_CCT_PAR38_Grid_Connect_Smart_ES_Globe_GLD302HA.jpg?v=1762755626"
  },
  {
    "sku": "PC192HA",
    "title": "Arlec White Grid Connect Smart 2.1A USB Charger with Power Socket",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PC192HA_CPIN005791_OL.pdf?v=1754379043",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_Plug_in_Socket_with_USB_PC192HA.jpg?v=1762756154"
  },
  {
    "sku": "GLD064HA",
    "title": "Arlec White Grid Connect Smart 4W 380lm Warm White Fancy Round SES Globe",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD064HA.pdf?v=1754455252",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_4W_380lm_Warm_White_Fancy_Round_SES_Globe_GLD064HA.jpg?v=1762755614"
  },
  {
    "sku": "PF006HA",
    "title": "Arlec White Grid Connect Smart 6L Pet Feeder",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PF006HA_CPIN008902_OL.pdf?v=1784621468",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PF006HA_8afe48c9-7ca3-4d59-be90-03c43306117c.png?v=1789727985"
  },
  {
    "sku": "GLD080HA",
    "title": "Arlec White Grid Connect Smart 6W 420lm GU10 Globe",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD080HA.pdf?v=1754455295",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_6W_420lm_GU10_Globe_GLD080HA.jpg?v=1762755623"
  },
  {
    "sku": "ALP281HA",
    "title": "Arlec White Grid Connect Smart Aurora Projector with Bluetooth Speaker",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALP281HA_CPIN007197_OL.pdf?v=1754378919",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_Aurora_Projector_Light_ALP281HA.jpg?v=1762754954"
  },
  {
    "sku": "GLD361HA",
    "title": "Arlec White Grid Connect Smart B15 LED  5.5W 470lm RGB Colour Changing Candle Globe",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD361HA_CPIN004697-5_OL.pdf?v=1754378967",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_B15_LED_470lm_RGB_Colour_Changing_5.5W_Candle_Globe_GLD361HA.jpg?v=1762755716"
  },
  {
    "sku": "GLD365HA",
    "title": "Arlec White Grid Connect Smart B15 LED 470lm 5.5W RGB Colour Mode Fancy Round Globe",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD365HA_CPIN004697-5_OL.pdf?v=1754378969",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_B15_LED_470lm_RGB_Colour_Mode_5.5W_Grid_Connect_Smart_Fancy_Round_Globe_GLD365HA.jpg?v=1762755736"
  },
  {
    "sku": "GLD310HA",
    "title": "Arlec White Grid Connect Smart B22 LED 1050lm 12W CCT Colour Mode  Globe",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD310HA_CPIN004697-4_OL.pdf?v=1754378967",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_B22_LED_1050lm_CCT_Colour_Mode_12W_Globe_GLD310HA.jpg?v=1762755654"
  },
  {
    "sku": "GLD320HA",
    "title": "Arlec White Grid Connect Smart B22 LED 830lm 10W RGB CCT Colour Mode  Globe",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD320HA_CPIN004697-5_OL.pdf?v=1754378968",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_B22_LED_830lm_RGB_CCT_Colour_Mode_10W_Globe_GLD320HA.jpg?v=1762755686"
  },
  {
    "sku": "ALP253HA",
    "title": "Arlec White Grid Connect Smart Connecting Bar Light Set",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALP253HACPIN007196_OL.pdf?v=1754378917",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Grid_Connect_6_Piece_Connectable_Bar_Light_Set_ALP253HA_819f2097-84cd-4888-a184-a1fe9b342b67.jpg?v=1762754946"
  },
  {
    "sku": "ALP211HA",
    "title": "Arlec White Grid Connect Smart Corner Light with Sound Sync",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALP211HA_CPIN006456_2_OL.pdf?v=1754378922",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_Corner_Light_ALP211HA.jpg?v=1762754937"
  },
  {
    "sku": "GLD364HA",
    "title": "Arlec White Grid Connect Smart E14 LED 470lm  5.5W RGB Colour Changing Fancy Round Globe",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD364HA_CPIN004697-5_OL.pdf?v=1754378968",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_E14_LED_470lm_RGB_Colour_Changing_5.5W_Fancy_Round_Globe_GLD322HA.jpg?v=1762755725"
  },
  {
    "sku": "GLD360HA",
    "title": "Arlec White Grid Connect Smart E14 LED 5.5W 470lm Candle CCT Globe",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD360HA_CPIN004697-5_OL.pdf?v=1754378968",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_Grid_Connect_Smart_E14_LED_5.5W_470lm_Candle_CCT_Globe_GLD360HA.jpg?v=1762755706"
  },
  {
    "sku": "GLD312HA",
    "title": "Arlec White Grid Connect Smart E27 LED 1050lm 12W CCT Colour Mode  Globe",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD312HA_CPIN004697-4_OL.pdf?v=1754378967",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_E27_LED_1050lm_CCT_Colour_Mode_12W_Globe_GLD312HA.jpg?v=1762755664"
  },
  {
    "sku": "GLD322HA",
    "title": "Arlec White Grid Connect Smart E27 LED 830lm 10W RGB CCT Colour Mode  Globe",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD322HA_CPIN004697-5_OL.pdf?v=1754378967",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_E27_LED_830lm_RGB_CCT_Colour_Mode_10W_Globe_GLD322HA.jpg?v=1762755695"
  },
  {
    "sku": "GLD381HA",
    "title": "Arlec White Grid Connect Smart GU10 LED 420lm 5.5W RGB CCT Colour Mode Globe",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/GLD381HA_CPIN004697-4_OL.pdf?v=1754378968",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_GU10_LED_420lm_RGB_CCT_Colour_Mode_5.5W_Globe_GLD381HA_ef9a622e-4431-4f8b-b658-9b11967cfa19.jpg?v=1762755749"
  },
  {
    "sku": "PC44HA",
    "title": "Arlec White Grid Connect Smart IP44 Weatherproof Plug-In Socket with Energy Meter",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_IP44_Heavy_Duty_Timer_PC44HA.jpg?v=1762756122"
  },
  {
    "sku": "PC43HA",
    "title": "Arlec White Grid Connect Smart IP44 Weatherproof Timer",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_IP44_Heavy_Duty_Timer_PC43HA.jpg?v=1762756092"
  },
  {
    "sku": "ALD155HA",
    "title": "Arlec White Grid Connect Smart LED Strip Light with Remote Control",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALD155HA_CPIN005455_5_OL.pdf?v=1754378915",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1m_Cool_White_And_Warm_White_Grid_Connect_Smart_CCT_LED_Strip_Light_With_Remote_ALD155HA_1.jpg?v=1762754629"
  },
  {
    "sku": "HUBRF11HA",
    "title": "Arlec White Grid Connect Smart Motorised Home Roller Blind Controller",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/HUBRF11HA_CPIN005057-2.pdf?v=1754378966",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Motorised_Smart_Home_Blind_Controller_With_Grid_Connect_HUBRF11HA.jpg?v=1762831247"
  },
  {
    "sku": "PC193PDHA",
    "title": "Arlec White Grid Connect Smart Plug-In Multi Function Socket with USB PD20W",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_Plug_In_Multi-Function_Socket_With_USB_PD20W_PC193PDHA.jpg?v=1762752816"
  },
  {
    "sku": "PA1622HA",
    "title": "Arlec White Grid Connect Smart Portable Air Conditioner",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PA1622HACPIN006812OL.pdf?v=1754379042",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_Grid_Connect_Smart_Portable_Air_Conditioner_PA1622HA.jpg?v=1762756071"
  },
  {
    "sku": "ALP010HA",
    "title": "Arlec White Grid Connect Smart Portable Hemisphere Lamp RGB CCT",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALP010HA.pdf?v=1754477174",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ArlecWhiteGridConnectSmartPortableHemisphereLampRGBCCT1.png?v=1765259756"
  },
  {
    "sku": "PC191HA",
    "title": "Arlec White Grid Connect Smart Power Adaptor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PC191HA_CPIN006842_2_OL.pdf?v=1754379040",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_Grid_Connect_Smart_Plug_in_Socket_with_Energy_Meter_-_Single_Pack_PC191HA.jpg?v=1762756132"
  },
  {
    "sku": "PC191HA-4",
    "title": "Arlec White Grid Connect Smart Power Adaptor-4 Pack",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PC191HA-4_CPIN006842_2_OL.pdf?v=1754379040",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_Plug_In_Socket_With_Energy_Meter_-_4_Pack_PC191HA-4_1.jpg?v=1762756144"
  },
  {
    "sku": "GLD315HA",
    "title": "Arlec White Grid Connect Smart R80 LED 806lm 9.5W ES CCT Globe",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ArlecGridConnectSmartR80LED806lm9.5WESCCTGlobe_GLD315HA.jpg?v=1762755676"
  },
  {
    "sku": "ASR352HA",
    "title": "Arlec White Grid Connect Smart Reverse Cycle Inverter",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ASR352HA.pdf?v=1754454814",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_3.5kW_Grid_Connect_Smart_Rayton_Split_System_Air_Con_Inverter_ASR352HA.jpg?v=1762830937"
  },
  {
    "sku": "PA1622HCHA",
    "title": "Arlec White Grid Connect Smart Reverse Cycle Portable Air Conditioner",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PA1622HCHACPIN006811OL.pdf?v=1754379043",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Smart_Grid_Connect_4.68KW_16000BTU_Heating_and_Cooling_WiFi_Portable_Aircon_PA1622HCHA_eab8b6b7-cee9-4bb9-903c-3c61dc40a59b.jpg?v=1762756083"
  },
  {
    "sku": "UC508HA",
    "title": "Arlec White Grid Connect Smart RGBW Puck Lights - 4 Pack",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC508HA_CPIN006972_OL.pdf?v=1754379101",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_RGBW_Puck_Lights_-_4_Pack_UC508HA.jpg?v=1762756419"
  },
  {
    "sku": "UC566HA",
    "title": "Arlec White Grid Connect Smart Slimline Linkable Bar Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC566HA_CPIN006973_2_OL.pdf?v=1754379102",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_Slimline_Linkable_Bar_Light_UC566HA.jpg?v=1762756492"
  },
  {
    "sku": "ALP018HA",
    "title": "Arlec White Grid Connect Smart Sound Sync Mood Lamp RGB CCT",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ALP018HA.pdf?v=1754477173",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ArlecWhiteGridConnectSmartSoundSyncMoodLampRGBCCT1.png?v=1765259912"
  },
  {
    "sku": "PFC011HA",
    "title": "Arlec White Grid Connect Smart Treat Dispenser With Camera",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PFC011HA_CPIN008904_OL.pdf?v=1784621466",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PFC011HA_9a9f3858-1b8a-4dc6-97b1-88c7695cb449.png?v=1789728149"
  },
  {
    "sku": "DA25-D",
    "title": "Arlec White IND to AU Double Socket Outbound Travel Adaptor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "DA25-P",
    "title": "Arlec White IND to AU Single Socket Outbound Travel Adaptor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "DA46TC-P",
    "title": "Arlec White IND to AU Socket Outbound Travel AdaptorUSB A &C PD20W",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "CLS1",
    "title": "Arlec White Indoor Safety Cord Box",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Indoor_Safety_Box_CLS1.jpg?v=1762752141"
  },
  {
    "sku": "ABL368WH",
    "title": "Arlec White Kent Bunker E27 Large Base",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL368WH_1.png?v=1790587552"
  },
  {
    "sku": "ABL391WH",
    "title": "Arlec White Kent Large Oval Bunker",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL391WHCPIN007632_OL.pdf?v=1754378917",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_Large_Kent_Oval__Bunker_Light_ABL391WH.jpg?v=1762754465"
  },
  {
    "sku": "ABL018WH",
    "title": "Arlec White Large Base Frosted Glass Diffuser Oval Bunker",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL018WH.png?v=1790849988"
  },
  {
    "sku": "UC104",
    "title": "Arlec White LED Cupboard Hinge Light - 4 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_LED_Cupboard_Hinge_Light_-_4_Pack_UC104.jpg?v=1762756348"
  },
  {
    "sku": "DA13",
    "title": "Arlec White Left Hand Double Adaptor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_Left_Hand_Double_Adaptor_DA13.jpg?v=1762752225"
  },
  {
    "sku": "DC410",
    "title": "Arlec White Long Distance Premium Cloth Wireless Battery Doorchime",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_Long_Distance_Premium_Cloth_Wireless_Battery_Doorchime_DC410.jpg?v=1762755385"
  },
  {
    "sku": "DC400",
    "title": "Arlec White Long Distance Premium Wireless Battery Doorchime",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_Long_Distance_Premium_Wireless_Battery_Doorchime_DC400.jpg?v=1762831167"
  },
  {
    "sku": "UC521",
    "title": "Arlec White Magnet Mount Sensor Bar Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC521CPIN006968OL.pdf?v=1754379097",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Magnet_Mount_Sensor_Bar_Light_UC521.jpg?v=1762756439"
  },
  {
    "sku": "ABL410WH",
    "title": "Arlec White Marina CCT LED Exterior Wall Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL410BK_WH_CPIN007637_OL.pdf?v=1754378915",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Marina_CCT_LED_Exterior_Wall_Light_White_ABL410WH.jpg?v=1762754484"
  },
  {
    "sku": "CSF7602WL",
    "title": "Arlec White Maxy 5-Blade 76cm AC Ceiling Fan with Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/CSF7602WL_CPIN005662-3OL.pdf?v=1754378983",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_Maxy_5-Blade_76cm_AC_Ceiling_Fan_with_Light_CSF7602WL.jpg?v=1762752028"
  },
  {
    "sku": "ABL116WH",
    "title": "Arlec White Medium Base Frosted Glass Diffuser Oval Bunker",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL116WH.png?v=1790758778"
  },
  {
    "sku": "UC460",
    "title": "Arlec White Motion Sensor LED Rechargeable Step Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC460_CPIN004402_OL.pdf?v=1754379098",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Motion_Sensor_LED_Rechargeable_Step_Light_UC460.jpg?v=1762756391"
  },
  {
    "sku": "BTS880HA",
    "title": "Arlec White Music Cube Portable Speaker with Music Sync",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/BTS880HA.pdf?v=1754455092",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_15cm_RGB_LED_USB_Rechargeable_Wireless_Speaker_BTS880HA.jpg?v=1762831139"
  },
  {
    "sku": "BTS881HA",
    "title": "Arlec White Music Lantern Portable Speaker with Music Sync",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/BTS881HA.pdf?v=1754455032",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Rechargeable_20cm_RGB_LED_USB_Operated_Lighting_System_with_Wireless_Speaker_BTS881HA.jpg?v=1762831149"
  },
  {
    "sku": "ABL110WH",
    "title": "Arlec White Oval Caged Bunker Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL110WH_ABL115_CPIN007599_OL.pdf?v=1754378917",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_Oval_Caged_Bunker_Light_ABL110WH_2.jpg?v=1762754300"
  },
  {
    "sku": "DA14",
    "title": "Arlec White Plug In Power Surge Protection",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_Plug_In_Power_Surge_Protection_DA14.jpg?v=1762752232"
  },
  {
    "sku": "PA1800",
    "title": "Arlec White Portable Air Conditioner with Keypad Control Panel and LED Display",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PA1800_CPIN003402_4.pdf?v=1754379038",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_18_000BTUHr_Portable_Air_Conditioner_With_Remote_and_Timer_PA1800.jpg?v=1762831371"
  },
  {
    "sku": "PC191PD18",
    "title": "Arlec White Power Adapter with Rapid Charging USB A&C PD20W",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Power_Adapter_with_Rapid_Charging_USB_A_C_PD20W_PC191PD18.jpg?v=1762752809"
  },
  {
    "sku": "DA35PD20",
    "title": "Arlec White Power Adaptor with Integrated Phone Mount and USB PD20W",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Power_Adaptor_with_Integrated_Phone_Mount_and_USB_PD20W_DA35PD20.jpg?v=1762752261"
  },
  {
    "sku": "DA32",
    "title": "Arlec White Power Adaptor with Retractable USB Cable",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Power_Adaptor_With_Retractable_USB_Cable_DA32.jpg?v=1762752253"
  },
  {
    "sku": "PB3UNL",
    "title": "Arlec White Powerboard with Touch Switched Light & Dual USB",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Alrec_White_Powerboard_with_Touch_Switched_Light___Dual_USB_PB3UNL_2.jpg?v=1762752427"
  },
  {
    "sku": "UC507",
    "title": "Arlec White Puck Lights - 4 Pack",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC507CPIN006971OL.pdf?v=1754379102",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Warm_White_Puck_Lights_-_4_Pack_UC507.jpg?v=1762756407"
  },
  {
    "sku": "DA56-K",
    "title": "Arlec White Quick Charge Adapter with USB Ports",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_Quick_Charge_Adapter_with_USB_PortsDA56-K_6.jpg?v=1762752306"
  },
  {
    "sku": "MAL552",
    "title": "Arlec White Recessed Security Sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL552_CPIN003855_6_OL.pdf?v=1754379033",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Recessed_Security_Sensor_MAL552.jpg?v=1762755888"
  },
  {
    "sku": "NL120",
    "title": "Arlec White Rechargeable Battery-Powered Motion Sensor Night Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL120.png?v=1781067490"
  },
  {
    "sku": "NL132W",
    "title": "Arlec White Rechargeable Magnet Mount Sensor Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/NL132W.png?v=1781610790"
  },
  {
    "sku": "UC538",
    "title": "Arlec White Rechargeable Swivel Bar Light With Timer",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/UC538_CPIN007594_OL.pdf?v=1754379101",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Rechargeable_Swivel_Bar_Light_With_Timer_UC538.jpg?v=1762756462"
  },
  {
    "sku": "RC210",
    "title": "Arlec White Remote Controlled Power Adaptor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/RC210_CPIN005939-4_OL.pdf?v=1754379100",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Remote_Controlled_Power_Outlet_RC210_c5f5e305-b1e5-42f5-bdf3-7dda73aa2be0.jpg?v=1762752889"
  },
  {
    "sku": "APRF010",
    "title": "Arlec White Replacement HEPA 11 Filter Suitable for APR010",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Air_Purifier_HEPA11_Replacement_Filter_APRF010_1.jpg?v=1762755033"
  },
  {
    "sku": "APRF014",
    "title": "Arlec White Replacement HEPA Filter with Carbon Coating and Mesh Cover  Suitable for APR014",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_HEPA_13_Air_Purifier_Replacement_Filter_APRF014.jpg?v=1762755041"
  },
  {
    "sku": "ABL391RLWH",
    "title": "Arlec White Ridge Rounded Bunker",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL391RLBK_IM.pdf?v=1790832946",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL391RLWH.png?v=1790760799"
  },
  {
    "sku": "DA12-K",
    "title": "Arlec White Right Hand Double Adaptor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_Right_Hand_Double_Adaptor_DA12-K.jpg?v=1762752217"
  },
  {
    "sku": "ATL918",
    "title": "Arlec White Ring Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ATL918CPIN007887_OL.pdf?v=1754378922",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_8_RGB_Ring_Light_ATL918.jpg?v=1762831045"
  },
  {
    "sku": "ABL111RWH",
    "title": "Arlec White Round CCT LED Exterior Step Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL111RBK_SeriesCPIN007668_OL.pdf?v=1754378914",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL111RWH.png?v=1791521108"
  },
  {
    "sku": "PCTH01HA",
    "title": "Arlec White Smart Grid Connect Adaptor with Temperature and Humidity Sensor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Smart_Grid_Connect_Adaptor_With_Temperature_And_Humidity_Sensor_PCTH01HA.jpg?v=1762752834"
  },
  {
    "sku": "ABL111SWHT",
    "title": "Arlec White Square CCT LED Exterior Step Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL111SWHT_SeriesCPIN007668_OL.pdf?v=1754378914",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_4W_White_CCT_Square_Exterior_LED_Step_Light_ABL111SWHT.jpg?v=1762754347"
  },
  {
    "sku": "DA11-K",
    "title": "Arlec White Surge Protected Double Adaptor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_Surge_Protected_Double_Adaptor_DA11-K.jpg?v=1762752209"
  },
  {
    "sku": "AHLMR09",
    "title": "Arlec White Tabletop LED Mirror",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AHLMR09CPIN007565_OL.pdf?v=1754378913",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_250_x_300mm_Tabletop_9_LED_Mirror_White_AHLMR09.jpg?v=1762830743"
  },
  {
    "sku": "DA17-K",
    "title": "Arlec White Triangular Double Adaptor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_Triangular_Double_Adaptor_DA17-K_63ac7687-c395-406c-8db0-f5cd6330265d.jpg?v=1762752238"
  },
  {
    "sku": "DA18",
    "title": "Arlec White Triangular Double Adaptor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_Triangular_Double_Adaptor_DA18_bdbd9061-db29-4f07-8e24-1f932f5248c2.jpg?v=1762752245"
  },
  {
    "sku": "DA182PK",
    "title": "Arlec White Triangular Double Adaptor Twin Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_Triangular_Double_Adaptor_DA182PK.jpg?v=1762829224"
  },
  {
    "sku": "MAL404",
    "title": "Arlec White Twin 20W LED DIY Security Sensor Floodlight with Movement Activation",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/MAL400_CPIN004070.pdf?v=1754379025",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_20W_LED_Twin_Security_Floodlight_With_Movement_Activation_MAL404.jpg?v=1762755865"
  },
  {
    "sku": "PC287HA",
    "title": "Arlec White Twin Grid Connect Smart Power Adaptor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PC287HA_CPIN006842_2_OL.pdf?v=1754379040",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_Plug_in_Twin_Socket_with_Energy_Meter_and_Surge_Protection_PC287HA.jpg?v=1762756166"
  },
  {
    "sku": "DA22-P",
    "title": "Arlec White UK to AU Single Socket Outbound Travel Adaptor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "DA42TC-P",
    "title": "Arlec White UK TO AU Socket Outbound Travel Adaptorwith USB A &C PD20W",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "DA21-P",
    "title": "Arlec White UK&US to AU & NZ Single Socket Inbound Travel Adaptor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "DA22-D",
    "title": "Arlec White Untied Kingdom Double Socket Outbound Travel Adaptor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "DA23-D",
    "title": "Arlec White USA to AU Double Socket Outbound Travel Adaptor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "DA23-P",
    "title": "Arlec White USA to AU Single Socket Outbound Travel Adaptor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "DA43TC-P",
    "title": "Arlec White USA TO AU Socket Outbound Travel Adaptorwith USB A &C PD20W",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": ""
  },
  {
    "sku": "DA10",
    "title": "Arlec White Verticle Double Adaptor",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_Verticle_Double_Adaptor_DA10.jpg?v=1762752203"
  },
  {
    "sku": "CSF04",
    "title": "Arlec White Wall Fan Controller Knob Replacement - 4 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Wall_Fan_Controller_Knob_Replacement_-_4_Pack_CSF04.jpg?v=1762755376"
  },
  {
    "sku": "DC3952",
    "title": "Arlec White Wireless Battery Doorchime with Indicator Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_White_Wireless_Battery_Doorchime_with_Indicator_Light_DC3952.jpg?v=1762755415"
  },
  {
    "sku": "AM129",
    "title": "Arlec Window and Door Magnetic Contact Alarm - 4 Pack",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AM129_CPIN003984.pdf?v=1754378911",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Window_and_Door_Magnetic_Contact_Alarm_-_4_Pack_AM129.jpg?v=1762753814"
  },
  {
    "sku": "PB34U",
    "title": "Arlec Yellow & Black Portable Power Station with USB Charging Port",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB34UCPIN004328.pdf?v=1754379034",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_IP44_4_Outlet_Power_Station_PB34U.jpg?v=1762829341"
  },
  {
    "sku": "YEL18D",
    "title": "Arlec Yellow 1.8m Dual Outlet Split Domestic Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1.8m_Heavy_Duty_Dual_Output_Split_Extension_Lead_YEL18D.jpg?v=1762752978"
  },
  {
    "sku": "HL21",
    "title": "Arlec Yellow 1000W Halogen Worklight with Tripod",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/HL21_CPIN002050-2.pdf?v=1754378967",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_1000W_Halogen_Worklight_With_Tripod_HL21.jpg?v=1762755751"
  },
  {
    "sku": "YEL10",
    "title": "Arlec Yellow 10m Heavy Duty Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_10m_1.0mm__10A_3_Core_Heavy_Duty_Extension_Lead_YEL10_1.jpg?v=1762829538"
  },
  {
    "sku": "WL0113",
    "title": "Arlec Yellow 10W 800lm LED Work Light With Spring Clamp",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/WL0113_CPIN005650_2OL.pdf?v=1754379100",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_10W_800lm_LED_Work_Light_With_Spring_Clamp_WL0113.jpg?v=1762756583"
  },
  {
    "sku": "WL0125",
    "title": "Arlec Yellow 18W 1600lm LED Portable Worklight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/WL0125CPIN005747_2_OL2.pdf?v=1754379099",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_20W_1600lm_LED_Portable_Worklight_WL0125_1.jpg?v=1762756611"
  },
  {
    "sku": "WL0147",
    "title": "Arlec Yellow 2 x 20W 3200lm LED Worklight With Tripod",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/WL0147_CPIN005653_2_OL.pdf?v=1754379099",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2_x_20W_3200lm_LED_Worklight_With_Tripod_WL0147.jpg?v=1762756624"
  },
  {
    "sku": "WL2115",
    "title": "Arlec Yellow 2 x 20W 4000lm Warm White LED Worklight With Tripod",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/WL2115_CPIN007883_OL.pdf?v=1754379100",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2_x_20W_4000lm_Warm_White_LED_Worklight_With_Tripod_WL2115.jpg?v=1762756671"
  },
  {
    "sku": "WL2151",
    "title": "Arlec Yellow 2 x 30W 6000lm LED Worklight With 1.4m Enhanced Tripod",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/WL2151_CPIN007882_OL.pdf?v=1754379099",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_2_x_30W_6000lm_LED_Worklight_With_1.4m_Enhanced_Tripod_WL2151.jpg?v=1762756681"
  },
  {
    "sku": "YEL20",
    "title": "Arlec Yellow 20m Heavy Duty Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_20m_1.0mm__10A_3_Core_Heavy_Duty_Extension_Lead_YEL20.jpg?v=1762752984"
  },
  {
    "sku": "YEL20HA",
    "title": "Arlec Yellow 20m Smart Grid Connect Extra Heavy Duty Extension Lead",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/YEL20HA_CPIN004414_2.pdf?v=1754379100",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Grid_Connect_Smart_20m_Extra_Heavy_Duty_Extension_Lead_YEL20HA.jpg?v=1762752990"
  },
  {
    "sku": "WL0114",
    "title": "Arlec Yellow 20W 1600lm LED Worklight With Spring Clamp",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/WL0114_CPIN005685-2OL.pdf?v=1754379100",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_20W_1600lm_LED_Worklight_With_Spring_Clamp_WL0114.jpg?v=1762756592"
  },
  {
    "sku": "WL0148",
    "title": "Arlec Yellow 25W 2400lm LED Portable Work Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/WL0148CPIN005651_2_OL.pdf?v=1754379098",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_25W_2400lm_LED_Portable_Work_Light_WL0148_WL0148.jpg?v=1762756634"
  },
  {
    "sku": "AWL2623",
    "title": "Arlec Yellow 2x30W 6000lm Tripod Worklight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWL2623_CPIN009324_OL.pdf?v=1791353145",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWL2623.jpg?v=1791353809"
  },
  {
    "sku": "TEL15",
    "title": "Arlec Yellow 3 Tuff 15m Extra Heavy Duty Extension Lead",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_15m_Heavy_Duty_Triple_Socket_Extension_Lead_TEL15.jpg?v=1762752897"
  },
  {
    "sku": "HL110",
    "title": "Arlec Yellow 500W Halogen Portable Worklight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/HL110_CPIN007883_OL.pdf?v=1754378974",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_500W_Portable_Halogen_Worklight_HL110.jpg?v=1762755760"
  },
  {
    "sku": "WL0160",
    "title": "Arlec Yellow 50W 4000lm LED Portable Worklight",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Yellow_50W_4000lm_LED_Portable_Worklight_WL0160.jpg?v=1762756653"
  },
  {
    "sku": "WL0023",
    "title": "Arlec Yellow 5W  250lm Portable Battery Operated LED Work Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_5W__250lm_Portable_Battery_Operated_LED_Work_Light_WL0023.jpg?v=1762756539"
  },
  {
    "sku": "WL0150",
    "title": "Arlec Yellow 9W 800lm LED Portable Worklight",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/WL0150_CPIN005748_2_OL.pdf?v=1754379099",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_10W_800lm_LED_Portable_Worklight_WL0150.jpg?v=1762756645"
  },
  {
    "sku": "WL17",
    "title": "Arlec Yellow Hand Held Work Light",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Yellow_Hand_Held_Work_Light_WL17.jpg?v=1762756532"
  },
  {
    "sku": "DPH01-20",
    "title": "Arlec Yellow Heavy Duty Extension Lead with Lead Organiser",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_20m_Heavy_Duty_Extension_Lead_with_Bonus_Lead_Organiser_DPH01-20.jpg?v=1762829246"
  },
  {
    "sku": "CLS2-Y",
    "title": "Arlec Yellow Outdoor IP44 Cord Safe Box",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Yellow_Outdoor_Cord_Safe_Box_CLS2-Y.jpg?v=1762831160"
  },
  {
    "sku": "CLS2-Y2-P",
    "title": "Arlec Yellow Outdoor Safety Cord Box- 2 Pack",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_IP44_Outdoor_Cord_Safe_Box_-_2_Pack_CLS2-Y2_1.jpg?v=1763447608"
  },
  {
    "sku": "AWLF2210",
    "title": "Arlec Yellow Rechargeable Fan & Light with Clamp",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/AWLF2210CPIN006899OL.pdf?v=1754378924",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/Arlec_Rechargeable_Fan_And_LED_Light_With_Clamp_AWLF2210.jpg?v=1762831110"
  },
  {
    "sku": "PB3RUPD-TWSTYE",
    "title": "Arlec Yellow Tweenie Star 3-Outlet Fast Charging USB Powerboard",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/PB3RUPD-TWSTYE.png?v=1784618766"
  },
  {
    "sku": "LVX1858",
    "title": "Arlec\'s 31cm Battery-Powered Starburst Tree Topper",
    "instruction_manual": "",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVX1858.jpg?v=1765273524"
  },
  {
    "sku": "ABL411BK",
    "title": "Marina Black Large Up/Down Accent Curved Wall Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL411BK_IM.pdf?v=1790832942",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL411BK.png?v=1790757482"
  },
  {
    "sku": "ABL411WH",
    "title": "Marina White Large Up/Down Accent Curved Wall Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL411BK_IM.pdf?v=1790832942",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/ABL411WH.png?v=1790829152"
  },
  {
    "sku": "LVS06LINK",
    "title": "Solar Linkable Oval Wall Light",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS06LINK_IM.pdf?v=1790832946",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS06LINK.jpg?v=1790574235"
  },
  {
    "sku": "LVS01LINK",
    "title": "Solar linkable single head security floodlight with PIR motion sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS01LINK_IM.pdf?v=1790832947",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS01LINK.png?v=1790575643"
  },
  {
    "sku": "LVS03LINK",
    "title": "Solar linkable three head security floodlight with PIR motion sensor",
    "instruction_manual": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS03LINK_IM.pdf?v=1790832947",
    "datasheet": "",
    "thumbnail": "https://cdn.shopify.com/s/files/1/0707/0715/1036/files/LVS03LINK.png?v=1790575199"
  }
];